import { Component, computed, DestroyRef, ElementRef, HostListener, inject, Input, OnDestroy, OnInit, signal, ViewChild, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Map as OlMap, View } from 'ol';
import Feature from 'ol/Feature';
import VectorLayer from 'ol/layer/Vector';
// import 'ol/ol.css'; // CSS import causing build issues - moved to angular.json styles array
import Overlay from 'ol/Overlay';
import { fromLonLat, transform } from 'ol/proj';
import { register } from 'ol/proj/proj4';
import VectorSource from 'ol/source/Vector';
import { Coordinate } from 'ol/coordinate.js';
import { ObjectEvent } from 'ol/Object';
import { defaults as defaultControls } from 'ol/control.js';
import { FeatureLike } from 'ol/Feature';
import proj4 from 'proj4';
import { firstValueFrom, forkJoin, Subject } from 'rxjs';
import { Orthophoto, OrthoPhotoDto,OrthoLayer } from "src/app/bo/orthophoto";
import { take } from 'rxjs/operators';
import { HttpService } from 'src/app/services/http.service';
import { ControlPoint } from '../../bo/controlPoint';
import { DonneeAnalyseSiteDto } from '../../bo/donneeAnalyse';
import { ReferentielDonneeAnalyse } from '../../bo/referentielDonneeAnalyse';
import { Site } from '../../bo/site';
import { Tir } from '../../bo/tir';
import { TirsPolygoneType } from '../../bo/polygon/tirsPolygoneType';
import { UtilisateurService } from '../../services/utilisateur.service';
import { LoggerService } from '../../services/logger.service';
import { HoleDetails, HoleDTO, HoleLegendProperties, HoleFeatureLegendProperties, HoleService, HoleStatus } from 'src/app/services/hole.service';
import { FonctionsService } from 'src/app/services/fonctions-partagees.service';
import { CartStyleUtile } from 'src/app/utils/carteStyleUtile';
import Zoom from 'ol/control/Zoom';
import { TranslateService } from '@ngx-translate/core';
import { MeasureLayer, MEASURE_MODE } from './layers/Ruller';
import { ControlPointsLayer } from './layers/ControlPointsLayer';
import { MAP_VIEW_TYPE, MapLayersControler } from './layers/mapLayers'
import MapConstants from './constants';
import { BlastPolygonsLayer, ZoneColorPalette } from './layers/BlastPolygoneLayer';
import { HoleLayer } from './layers/holeLayer';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { SiteOrthophotosAddFilesModalComponent } from '../site-setup/site-orthophotos-add-files-modal/site-orthophotos-add-files-modal.component';
import { SiteDxfAddFileModalComponent } from '../site-setup/site-dxf-add-file-modal/site-dxf-add-file-modal.component';
import { TirsPolygoneEnum } from 'src/app/bo/polygon/tirPolygoneEnum';
import { Geometry, Polygon as OlPolygon } from 'ol/geom';
import { TirContour } from 'src/app/bo/tirContour';
import { StaticUtils } from 'src/app/utils/staticUtils';
import { CarteHelpers } from './carteHelpers';
import { LazToTerrainService } from 'src/app/services/laz-to-terrain.service';
import { TerrainLoaderService } from 'src/app/services/terrain-loader.service';
// Import Mapbox GL pour la vue 3D avec relief terrain
import mapboxgl from 'mapbox-gl';
import { Equipment, EquipmentUtils } from 'src/app/bo/equipment';
import { EquipmentPosition } from 'src/app/bo/hiboo/equipmentPosition';
import { Shift, ShiftEnum, ShiftUtils } from 'src/app/bo/shifts/shift';
import { BlastEquipmentLayer } from './layers/BlastEquipmentLayer';
import { SitePolygonLayer } from './layers/SitePolygonLayer';
import { ZoneOfInterestLayer } from './layers/ZoneOfInterestLayer';
import { ZoneOfInterestService } from 'src/app/services/zone-of-interest.service';
import { ZoneOfInterestDto } from 'src/app/bo/zoneOfInterest';
import WKTFormat from 'ol/format/WKT';
import { DxfServiceService } from 'src/app/services/dxf-service.service';
import { SitePolygoneDto } from 'src/app/bo/site/sitePolygone';
import { OrthophotoMapService } from 'src/app/services/map.services';
import { PolygonType } from 'src/app/bo/polygon/tirsPolygone';
import { KpiService } from 'src/app/services/kpi.service';
import { EquipmentRoute, EquipmentRouteDto } from 'src/app/bo/equipment/equipmentRoute';
import { EquipmentRouteService } from 'src/app/services/equipment-route.service';

const ZOOM_THRESHOLD = 0.5;
const CvnSiteId = 189; //TODO: to be refactored to dynamically determine location-based values
const FEATURE_NAME= "featureType";
enum FEATURE_TYPE{blast_polygone, hole};

/** Modes d'affichage de la carte, mutuellement exclusifs */
export type ViewMode = 'plan2d' | 'map2d' | '3d';


@Component({
  selector: 'app-carte',
  templateUrl: './carte.component.html',
  styleUrls: ['./carte.component.scss'],
  standalone: false
})

export class CarteComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() site: Site;
  @Input() blastIdToZoom: number = null;
  @ViewChild('popupForm', { static: false }) popupForm: ElementRef;
  @ViewChild('kpiJauge', { static: false }) kpiJauge: ElementRef; 
  @ViewChild('modalConfirmDeleteOrtho') modalConfirmDeleteOrtho: ModalDirective;
  @ViewChild('modalConfirmDeletePolygon') modalConfirmDeletePolygon: ModalDirective;

  private readonly destroyRef = inject(DestroyRef);
  popupOuverte = new Subject<number>();
  popupFermee = new Subject<number>();
  map: OlMap;

  popup;
  view = new View({
    center: transform([0, 0], MapConstants.EPSG_WGS84, MapConstants.EPSG_REFERENCE_OL),
    zoom: 15,
  });
  vectorsPolygone: VectorLayer<any>[] = [];
  holesVectorLayers: VectorLayer<any>[] = [];

  
  //listeControlPoints: ControlPoint[] = null;
  listePolygoneTypes: TirsPolygoneType[] = null;
  listeKPIActifs: ReferentielDonneeAnalyse[] = null; //liste de tous les KPI actifs du site (nom, unité, type, valeur min/max/nom)
  listeKPITirs: DonneeAnalyseSiteDto[]; //la liste de tous les KPI de tous les tirs sélectionnés (valeur, reférentielDonneeAnalyse associé TirId associé)
  listeTirs = signal<Tir[] | undefined>(undefined); //tous les tirs associés au site
  configSite: number[]; //les 4 KPI renseignés dans le setup site
  valKPISelectionne: { idTir: number, valeur: string, unite: string, couleur: string }[] = []; //valeur du KPI sélectionné pour tous les tirs sélectionnés
  defaultKPI: number = null;
  listeTirsSelectionnes: number[] = [];
  listeTypesSelectionnes: number[] = [];
  kpiSelectionne: ReferentielDonneeAnalyse; //le KPI sélectionné dans le treeview
  borneSup = 0;
  borneMoy = 0;
  readonly PolyEnum = TirsPolygoneEnum;
  selectedKPI: ReferentielDonneeAnalyse = null; // Pour le ng-select du KPI scale
  private kpiDataLoaded = false;
  borneInf = 0;
   private readonly dateRangeChangeTimeout: any;
  private previousDateRange: Date[] = [];
  tirPopup = signal<Tir | null>(null); //le tir associé au polygone sélectionné
  coordPolygones: number[] = [];
  popupTirActive = signal(false);
  kpiConfiguration = signal<{ nom: string, valeur: string, unite: string }[]>([]); //la valeur pour le tirPopup sélectionné des 4 KPI de référence
  valKPITir = signal<{ valeur: string, unite: string }>({ valeur: "", unite: "" }); //valeur à afficher sur le popup pour le KPI sélectionné dans le treeview
  proj4_site = "";
  
  /** Les trois modes d'affichage sont exclusifs entre eux */
  viewMode: ViewMode = 'map2d';

  // Propriétés pour la vue 3D
  is3DMode = false;
  originalViewRotation = 0;
  current3DAngle = 45;
  current3DRotation = 0;

  // Propriétés pour la vue Mapbox GL 3D terrain
  isMapboxTerrainMode: boolean = false;
  mapboxReady: boolean = false;
  mapboxMap: mapboxgl.Map | null = null;
  mapboxContainer: HTMLElement | null = null;
  mapboxToken: string = '';

  // Timeline temporelle des tirs en mode 3D
  timelineCursor = signal(Date.now());
  selectedBlastIdsSignal = signal<number[]>([]);
  showSiteTerrain = signal(true);
  showBlastTerrains = signal(true);
  showHoles3D = signal(true);
  terrainOpacity = signal(1);
  sortedBlasts = computed(() => {
    const tirs = this.listeTirs();
    if (!tirs) return [];
    return tirs
      .map(t => ({ ...t, _date: new Date(t.dateTirEffective || t.dateTirPrevisionnelle || 0).getTime() }))
      .filter(t => t._date > 0)
      .sort((a, b) => a._date - b._date);
  });
  filteredSortedBlasts = computed(() => {
    const all = this.sortedBlasts();
    const selected = this.selectedBlastIdsSignal();
    if (selected.length === 0) return all;
    return all.filter(t => selected.includes(t.tirId));
  });
  timelineMin = computed(() => {
    const blasts = this.filteredSortedBlasts();
    return blasts.length > 0 ? blasts[0]._date - 86400000 : 0;
  });
  timelineMax = computed(() => {
    const blasts = this.filteredSortedBlasts();
    return blasts.length > 0 ? blasts[blasts.length - 1]._date + 86400000 : 0; // +1 jour pour inclure le dernier
  });
  visibleBlastCount = computed(() => {
    const cursor = this.timelineCursor();
    const selected = this.selectedBlastIdsSignal();
    return this.sortedBlasts().filter(t => t._date <= cursor && (selected.length === 0 || selected.includes(t.tirId))).length;
  });

  private holes3DLoaded = false;

  /** Chargement du terrain LAS du site : couvre le téléchargement et le décodage */
  siteTerrainLoading = signal(false);

  // Propriétés pour le chargement LAZ
  lazLoadingProgress = signal(0);
  lazIsLoading = signal(false);
  lazPointCount = signal(0);
  lazFileName = signal('');

  // Three.js point cloud rendered as Mapbox custom layer
  private threeRenderer: any = null;
  private threeScene: any = null;
  private threeCamera: any = null;
  private pointCloudLayerId: string = 'laz-point-cloud';
  private pointCloudGeometry: any = null;
  isPointCloudMode: boolean = false;

  referentielOuvert: boolean;
  //listHoles: Hole[] = [];
  holePopup = signal<HoleDTO | null>(null);
  holePopupDetails = signal<HoleDetails | null>(null);
  activeTab = 'state';
  
  popupHoleActive = signal(false);
  blastsNamePopup = signal<string>('');
  showLegend = true
  polygonIDToDelete: number = null;
  cartStyleUtile = new CartStyleUtile();
  holesAreShown = false;
  holeToggle = true;
  controlPointsToggle = true;
  zoiToggle = true;
  inZoom = false; //used to determine if the holes should be shown after zooming in
  //MAP_VIEW_TYPE = MAP_VIEW_TYPE;
  layersPolygonesSelected: VectorLayer<any>[] = [];
  layersHolesSelected: VectorLayer<any>[] = [];
  //layerActiveType:MAP_VIEW_TYPE;
  showPopupForm = signal(false);
  timeSelection = signal('shift');
  selectedDate = signal<Date | undefined>(undefined);
  selectedDateRange = signal<Date[]>([]);
  selectedShift = signal<ShiftEnum | undefined>(undefined);
  selectedEquipments = signal<Equipment[]>([]);
  focusedEquipment = signal<Equipment | undefined>(undefined);
  shifts = Object.values(ShiftEnum).filter(value => typeof value === 'number');
  shiftsKeys = Object.keys(ShiftEnum).filter(k => !isNaN(Number(k)));
  today: Date = new Date();
  equipments: Equipment[];
  equipmentsPositions: EquipmentPosition[] = [];
  hasAppliedFilters = signal(false);
  equipmentLayer: VectorLayer<VectorSource<Feature<Geometry>>>;
  popupEquipmentActive = signal(false);
  isMouseInPopup = false;
  equipmentDisplayName: string;
  equipmentName: string;
  equipmentExternalId: number;
  formattedDate: string;
  formattedTime: string;
  equipmentLatitude: number;
  equipmentLongitude: number;
  equipmentAssignedShift: Shift | null;
  currentEquipmentPosition: EquipmentPosition | null;
  assignmentMode = signal(false);
  pendingEquipmentAssignment: EquipmentPosition | null;
  routeAssignmentMode = false; // Mode assignation de route à un blast
  shouldLoadSavedPositions: boolean;
  loadingEquipments = false;
  missingDateField = false;
  missingDateRangeField = false;
  missingShiftField = false;
  missingEquipmentField = false;
  showEquipmentButton = false;
  allView = signal(true);
  showAssignedEquipments = false;
  showEquipmentRoutes = true; // Activé par défaut pour les recherches

  // Time slider properties
  selectedTime = signal(0); // Temps sélectionné en minutes depuis minuit
  minTime = signal(0); // Heure de début en minutes
  maxTime = signal(1439); // Heure de fin en minutes (23:59)
  timeSliderEnabled = signal(false); // Actif seulement quand une date est sélectionnée

  // Equipment card expansion state
  expandedEquipmentCards = signal<Set<number>>(new Set());

  // Date and shift picker state
  isDateRangeExpanded = signal(false);

  // Route split mode state
  splitRouteMode = signal(false);

  // Route merge mode state
  mergeRouteMode = false;

  // Route sélectionnée pour fusion depuis les cards
  routeSelectedForMerge = signal<EquipmentRoute | null>(null);

  // Signal pour forcer le rafraîchissement des routes en zoneless
  routesVersion = signal(0);

  // Route drag & drop state
  draggingRoute = signal<EquipmentRoute | null>(null);
  dragTooltipVisible = false;
  dragTooltipText = '';
  dragTooltipX = 0;
  dragTooltipY = 0;

  // Route assignment state (pour assigner une route à un blast via clic)
  routeToAssignByClick = signal<EquipmentRoute | null>(null);

  holeLegendProperties: HoleLegendProperties[] = [];
  holeFeatureLegendProperties: HoleFeatureLegendProperties[] = [];
  showValKPITir = false;

  public activeButton = 1;// No button is active initially
  public bottomActiveButoon =0;
  private enablePolygonePicking = true;
  private enableHoleInteraction = true;
  private rulerControlLayer: MeasureLayer;
  private controlPointLayer: ControlPointsLayer;
  protected mapLayersControler: MapLayersControler;
  private blastPolygoneLayer: BlastPolygonsLayer;
  private equipmentLayerManager: BlastEquipmentLayer;
  private holeLayer: HoleLayer;
  private sitePolygonLayer: SitePolygonLayer;
  /** DXF layers of the current site, listed in the visibility panel */
  protected dxfLayers: SitePolygoneDto[] = [];
  private zoneOfInterestLayer: ZoneOfInterestLayer;

  // ZOI drawing state
  protected zoiModalVisible = false;
  protected showZoiTypeModal = false;
  protected zoiName = '';
  protected zoiType = 0;
  protected zoiThreshold = 30;
  private zoiGeometryType = '';
  private zoiCenterX?: number;
  private zoiCenterY?: number;
  private zoiRadius?: number;
  private zoiWkt?: string;

  protected modalPolygoneTypeisVisible: boolean;
  protected modalValidationPolygoneisVisible: boolean;
    protected modalValidationPrePolygoneisVisible: boolean;
  protected optionsTirsPolygoneEnum: TirsPolygoneEnum[] = [TirsPolygoneEnum.MUCKPILE, TirsPolygoneEnum.DANGER_ZONE];
  protected optionsCarteTirsPolygoneEnum: TirsPolygoneEnum[] = [TirsPolygoneEnum.DRILLED, TirsPolygoneEnum.MUCKPILE, TirsPolygoneEnum.DANGER_ZONE];
  protected selectedTirsPolygoneEnum = TirsPolygoneEnum.MUCKPILE;
  protected cartSelectedTirsPolygoneEnum: TirsPolygoneEnum[] = [];
  @ViewChild('allViewCheckbox', { static: false }) allViewCheckbox: ElementRef<HTMLInputElement>;
  // Container des boutons du bas (présent dans les deux variantes : simple et scrollable)
  @ViewChild('bottomButtonsContainer') bottomButtonsContainer?: ElementRef<HTMLElement>;
  @ViewChild('topButtonsContainer') topButtonsContainer?: ElementRef<HTMLElement>;

  public selectedPolygonFeature: Feature = undefined;
  public selectedPolygonType: any = null;
  private polygonCoordinatesToSave: Coordinate[][] = [];
  
  preSelectedBlast: Tir = null;
  selectedBlastForPolygon: number = null;

  //menu right click
  menuVisible = false;
  menuPosition = { x: 0, y: 0 };
  menuTirSelected: Tir = undefined;

  showPolygonTypeModal = false;
  useZoneColors = false; 

  showHolesModal = false;

  selectedHoleStatusFilter: string | HoleStatus = 'actual';
  
  // Helper method to convert TirsPolygoneEnum to correct PolygonType numerical values
  private convertPolygonEnumToNumber(polygonEnum: TirsPolygoneEnum): number {
    switch (polygonEnum) {
      case TirsPolygoneEnum.AUTOMATIC:
        return 0; // AutomaticFromHoles
      case TirsPolygoneEnum.DRILLED:
        return 1; // DrillingContour
      case TirsPolygoneEnum.MUCKPILE:
        return 2; // MuckPile
      case TirsPolygoneEnum.DANGER_ZONE:
        return 3; // DangerZone
      default:
        return 1; // Default to DrillingContour
    }
  }
  
  // Propriété pour la suppression des orthophotos
  // Propriétés pour la gestion des orthophotos
  orthoToDelete: OrthoPhotoDto | null = null;
  selectedOrthoLayer: OrthoPhotoDto | null = null;
  selectedHoleFeatureFilter = 'all';

  isBottomButtonsOverflow = false; 
  bottomButtonsViewportHeight: number | null = null; 
  isTopButtonsOverflow = false; 
  
  isHolesModalOverflow = false; 
  
  // Removed static orthoLayers data - will use dynamic data from mapLayersControler
  
  private viewportListener?: () => void; 
  private recalcTimeout: any; 
  private lastDevicePixelRatio: number = window.devicePixelRatio; 
  private zoomCheckInterval: any; 
  showDeletePolygonConfirm = false;

  constructor(
    public utilService: UtilisateurService,
    private readonly http: HttpService,
    private readonly logger: LoggerService,
    private readonly holeService: HoleService,
    private readonly fonctionsService: FonctionsService,
    private readonly translate: TranslateService,
    private readonly dxfService: DxfServiceService,
    private readonly modalService: BsModalService,
    private readonly mapService: OrthophotoMapService,
    private readonly kpiService: KpiService,
    private readonly cdr: ChangeDetectorRef,
    private readonly equipmentRouteService: EquipmentRouteService,
    private readonly zoiService: ZoneOfInterestService,
    private readonly lazToTerrainService: LazToTerrainService,
    private readonly terrainLoaderService: TerrainLoaderService
  ) {

    this.http.get<TirsPolygoneType[]>('TirsPolygoneType/tirsPolygoneType').pipe(takeUntilDestroyed(this.destroyRef)).subscribe(result => {
      this.listePolygoneTypes = result;
    });

    this.listeTypesSelectionnes = this.cartSelectedTirsPolygoneEnum.map(x => this.convertPolygonEnumToNumber(x))

  }

  ngOnChanges() {
    if (this.map == null) return;
    this.onChangeSite();

    if (this.site.siteId === CvnSiteId) {
      this.initializeEquipmentLayer();
    }else{
      this.showEquipmentButton = false;
    }
    
  }

  ngAfterViewInit(): void {
    this.evaluateBottomButtonsOverflow();
    this.evaluateTopButtonsOverflow();
    this.adjustTopRightButtonsPosition();
    setTimeout(() => this.evaluateBottomButtonsOverflow(), 100);
    setTimeout(() => this.evaluateTopButtonsOverflow(), 100);
    setTimeout(() => this.adjustTopRightButtonsPosition(), 100);
    
    if ((window as any).visualViewport) {
      this.viewportListener = () => {
        this.scheduleOverflowRecalc();
      };
      (window as any).visualViewport.addEventListener('resize', this.viewportListener, { passive: true });
    }

    window.addEventListener('load', () => {
      this.lastDevicePixelRatio = window.devicePixelRatio;
      // Essayer de calculer les features après que tout soit chargé
      // setTimeout(() => {
      //   this.calculateHoleFeatureLegendProperties();
      // }, 2000);
    });

    // Vérification périodique du zoom (fallback)
    this.zoomCheckInterval = setInterval(() => {
      if (window.devicePixelRatio !== this.lastDevicePixelRatio) {
        this.lastDevicePixelRatio = window.devicePixelRatio;
        this.scheduleOverflowRecalc();
      }
    }, 500);
  }

  @HostListener('window:resize') onWindowResize() {
    // Détection changement de DPR (zoom navigateur)
    if (window.devicePixelRatio !== this.lastDevicePixelRatio) {
      this.lastDevicePixelRatio = window.devicePixelRatio;
      
      if (this.recalcTimeout) clearTimeout(this.recalcTimeout);
      this.recalcTimeout = setTimeout(() => {
        this.adjustTopRightButtonsPosition();
        setTimeout(() => {
          this.evaluateBottomButtonsOverflow();
          this.evaluateTopButtonsOverflow();
        }, 20);
      }, 100);
      return;
    }
    
    this.scheduleOverflowRecalc();
  }


  ngOnInit() {
    this.referentielOuvert = true;
    this.createMap();

    // Pré-charger le token Mapbox pour que le clic 3D soit instantané
    this.mapService.getMapBoxPublicKey().then(token => {
      this.mapboxToken = token;
      (mapboxgl as any).accessToken = token;
    }).catch(() => {});

    const savedShowPopupForm = localStorage.getItem('showPopupForm');
    this.showPopupForm.set(savedShowPopupForm === 'true');
    
    const savedControlPointsToggle = localStorage.getItem('controlPointsToggle');
    this.controlPointsToggle = savedControlPointsToggle !== null ? savedControlPointsToggle === 'true' : true;

    const savedZoiToggle = localStorage.getItem('zoiToggle');
    this.zoiToggle = savedZoiToggle !== null ? savedZoiToggle === 'true' : true;
    
    this.loadPolygonToggles();

    this.onChangeSite();
    const isInit = true;

    this.popup = new Overlay({
      id: 'overlay',
      element: document.getElementById('popup')
    });

    this.map.addOverlay(this.popup);
    const popupElement = document.getElementById('popup');
    if (popupElement) {
      popupElement.addEventListener('mouseenter', () => {
        this.isMouseInPopup = true;
      });
      
      popupElement.addEventListener('mouseleave', () => {
        this.isMouseInPopup = false;
      });
    }
    
    const zoomInSvg = document.createElement('img');
    zoomInSvg.src = 'assets/icon/Zoom+.svg';
    zoomInSvg.style.width = '16px';
    zoomInSvg.style.height = '16px';

    const zoomOutSvg = document.createElement('img');
    zoomOutSvg.src = 'assets/icon/Zoom-.svg';
    zoomOutSvg.style.width = '16px';
    zoomOutSvg.style.height = '16px';

    let customZoom = new Zoom({ 
      className: 'custom-zoom',
      zoomInLabel: zoomInSvg,
      zoomOutLabel: zoomOutSvg
     });
    
    this.map.addControl(customZoom)
    

    this.onHover();
    this.onClick();
    this.onZoom();
    this.configureOnPan();

    this.mapLayersControler = new MapLayersControler(this.map, this.http, this.site, this.logger, 0, this.mapService);
    // Le fond Bing est persisté : le bouton actif doit refléter ce qui est réellement affiché
    this.viewMode = this.mapLayersControler.isBingLayerVisible ? 'map2d' : 'plan2d';

    this.sitePolygonLayer = new SitePolygonLayer(this.dxfService, this.map, this.site.siteId, this.getDynamicZIndex(10), Number(this.site.epsg));
    this.zoneOfInterestLayer = new ZoneOfInterestLayer(this.zoiService, this.map, this.site.siteId, this.getDynamicZIndex(11));
    this.zoneOfInterestLayer.setVisible(this.zoiToggle);
    this.zoneOfInterestLayer.refresh();
    this.blastPolygoneLayer = new BlastPolygonsLayer(this.map, this.site.siteId, this.http, this.getDynamicZIndex(20));
    this.holeLayer = new HoleLayer(this.map, this.holeService, this.logger, this.getDynamicZIndex(30));

    this.holeLayer.holeLegend$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(updatedLegend => {
      this.holeLegendProperties = [...updatedLegend];
      // Aussi calculer les propriétés des features quand la légende des holes est mise à jour
      // this.calculateHoleFeatureLegendProperties();
    });

    this.controlPointLayer = new ControlPointsLayer(this.map, this.getDynamicZIndex(40));
    this.rulerControlLayer = new MeasureLayer(this.map, this.getDynamicZIndex(100));
    
    if (this.site.siteId === CvnSiteId){
      this.initializeEquipmentLayer();
    }else{
      this.showEquipmentButton = false;
    }
    
    this.getTypeChange();
    this.checkScreenSize();
    this.updateKpiScaleGradient();
  }
  @HostListener('window:resize')
  onResize() {
    this.checkScreenSize();
  }


  private createMap() {
    this.map = new OlMap({
      layers: null,
      controls: defaultControls({zoom: false}),
      target: 'map',
      view: this.view,
    });
    this.map.getView().on('change:resolution', () => this.updateCustomScale());
    this.updateCustomScale(); // init
  }

  private getDynamicZIndex(layerOffset: number): number {
    if (this.mapLayersControler) {
      return this.mapLayersControler.getRecommendedBaseZIndexForOtherLayers() + layerOffset;
    }
    return 10 + layerOffset;
  }
  getHoleIconForLegend(status: string): string {
    return this.holeLayer.getHoleIconPath(status);
  } 
private updateCustomScale() {
  const view = this.map.getView();
  const resolution = view.getResolution();
  const dpi = 25.4 / 0.28; 
  const metersPerUnit = view.getProjection().getMetersPerUnit();


  const nominalCount = resolution * dpi * metersPerUnit;
  const niceScale = this.getNiceScale(nominalCount);

  const scaleWidth = niceScale / metersPerUnit / resolution;

  const scaleText = document.getElementById('scale-text');
  const scaleBar = document.getElementById('scale-bar');

  if (scaleText && scaleBar) {
    scaleText.innerText = this.formatScaleLabel(niceScale);
    scaleBar.style.width = `${scaleWidth}px`;  }
}

private getNiceScale(rawLength: number): number {
  const scales = [1, 2, 5];
  const exponent = Math.floor(Math.log10(rawLength));
  const base = Math.pow(10, exponent);
  const factor = rawLength / base;

  let nice = scales.find(s => s >= factor);
  if (!nice) nice = 10;

  return nice * base;
}

private formatScaleLabel(length: number): string {
  return length >= 1000 ? `${length / 1000} km` : `${length} m`;
}

  ngOnDestroy() {
    if ((window as any).visualViewport && this.viewportListener) {
      (window as any).visualViewport.removeEventListener('resize', this.viewportListener);
    }

    if (this.recalcTimeout) {
      clearTimeout(this.recalcTimeout);
    }
    if (this.zoomCheckInterval) {
      clearInterval(this.zoomCheckInterval);
    }

    // Nettoyer le point cloud et Mapbox GL
    this.cleanupPointCloudLayer();
    if (this.mapboxMap) {
      this.mapboxMap.remove();
      this.mapboxMap = null;
    }
    if (this.mapboxContainer) {
      this.mapboxContainer.remove();
      this.mapboxContainer = null;
    }

    // Nettoyer les styles personnalisés appliqués aux boutons top-right
    this.resetTopRightButtonsStyles();
  }

  private resetTopRightButtonsStyles(): void {
    const topRightButtons = document.querySelector('.top-right-buttons') as HTMLElement;
    
    if (topRightButtons) {
      topRightButtons.style.removeProperty('--top-right-distance');
      topRightButtons.style.removeProperty('--top-right-gap');
      topRightButtons.style.removeProperty('--top-right-padding');
      topRightButtons.style.transform = '';
      topRightButtons.classList.remove('zoom-high', 'zoom-low');
    }
  }

 @HostListener('document:keydown.escape')
 onKeydownHandler() {
  this.map.getTargetElement().classList.remove('map-drawing');

  if (this.menuVisible) {
    this.menuVisible = false;
  }

  if (this.showPolygonTypeModal) {
    this.closePolygonTypeModal();
  }

  if (this.modalValidationPrePolygoneisVisible) {
    this.closeModalValidationPolygone();
  }

  if (this.activeButton == 1) return;

  this.clearDrawnPolygon();
  
  this.polygonCoordinatesToSave = [];
  this.selectedPolygonFeature = undefined;
  
  this.enablePolygonePicking = true;
  this.enableHoleInteraction = true;
  this.activeButton = 1;
  this.closePolygonTypeModal();
}

  @HostListener('document:click', ['$event']) onDocumentClick(event: MouseEvent) {
    if (this.showPopupForm() && this.popupForm && !this.popupForm.nativeElement.contains(event.target)) {
      if (!(event.target instanceof Element)) return;
      if (event.target.closest('.cdk-overlay-container, .ng-dropdown-panel')) {
        return;
      }
      this.closePopupForm();
    }
  }

  onWheel(event: WheelEvent) {
    if (this.timeSliderEnabled()) {
      event.preventDefault();
      const delta = Math.sign(event.deltaY);
      this.selectedTime.update(v => v - delta * 1); // Inverted: scroll down = forward in time (1 minute par scroll)
      if (this.selectedTime() < this.minTime()) {
        this.selectedTime.set(this.minTime());
      }
      if (this.selectedTime() > this.maxTime()) {
        this.selectedTime.set(this.maxTime());
      }
      this.onTimeSliderChange();
    }
  }

  @HostListener('document:contextmenu', ['$event'])
  onDocumentRightClick(event: MouseEvent) {
    event.preventDefault();
    this.selectedPolygonFeature = undefined;
    this.menuPosition = { x: event.clientX, y: event.clientY };

    this.menuVisible = !this.menuVisible;
    // Ne pas fermer la popup lors d'un clic droit
  }

  public toggleSplitRouteMode(): void {
    this.splitRouteMode.update(v => !v);
    // Désactiver le mode merge si on active le mode split
    if (this.splitRouteMode() && this.mergeRouteMode) {
      this.mergeRouteMode = false;
      this.routeSelectedForMerge.set(null);
      this.equipmentLayerManager.getRouteLayer().setMergeMode(false);
    }
    this.equipmentLayerManager.getRouteLayer().setSplitMode(this.splitRouteMode());
  }

  public toggleMergeRouteMode(): void {
    this.mergeRouteMode = !this.mergeRouteMode;
    // Désactiver le mode split si on active le mode merge
    if (this.mergeRouteMode && this.splitRouteMode()) {
      this.splitRouteMode.set(false);
      this.equipmentLayerManager.getRouteLayer().setSplitMode(false);
    }
    // Réinitialiser la sélection de fusion quand le mode merge est désactivé
    if (!this.mergeRouteMode) {
      this.routeSelectedForMerge.set(null);
    }
    this.equipmentLayerManager.getRouteLayer().setMergeMode(this.mergeRouteMode);
  }

  public toggleAssignmentMode(): void {
    this.assignmentMode.update(v => !v);
    if (this.assignmentMode()) {
      this.map.getViewport().style.cursor = 'crosshair';
    } else {
      this.map.getViewport().style.cursor = '';
      this.pendingEquipmentAssignment = null;
      this.routeToAssignByClick.set(null); // Nettoyer la route sélectionnée
    }
  }

  public layerSwitch(button: number) {
    // Seule l'orthophoto reste un calque cumulable, et uniquement en 2D
    if (button === 1) {
      if (this.viewMode === '3d') return;
      this.mapLayersControler.toggleLayer(MAP_VIEW_TYPE.geoserver, !this.mapLayersControler.isOrthoLayerVisible);
    }
    else if (button === 2) {
      this.setViewMode('plan2d');
    }
    else if (button === 3) {
      this.setViewMode('map2d');
    }
    else if (button === 4) {
      this.setViewMode('3d');
    }
  }

  /**
   * Plan 2D, Map 2D et 3D sont trois modes exclusifs : on ne cumule plus les
   * fonds, et la 3D n'est plus une surcouche de la 2D mais une vue à part.
   */
  public setViewMode(mode: ViewMode): void {
    if (this.viewMode === mode) return;

    const wasThreeD = this.viewMode === '3d';
    this.viewMode = mode;

    if (mode === '3d') {
      // L'orthophoto n'est pas touchée : le viewport OL est masqué en 3D, donc
      // elle n'apparaît pas, et son état (persisté) est retrouvé au retour en 2D.
      if (!this.isMapboxTerrainMode) {
        this.toggleMapboxTerrainView();
      }
      return;
    }

    if (wasThreeD) {
      this.disableMapboxTerrainView();
    }

    this.mapLayersControler.toggleLayer(MAP_VIEW_TYPE.ol, mode === 'plan2d');
    this.mapLayersControler.toggleLayer(MAP_VIEW_TYPE.bing, mode === 'map2d');
  }

  // =========================================================================
  // VUE 3D : nuage LAS, terrains blast et trous, sans fond de carte
  // =========================================================================

  /**
   * Le changement de site ne traversait pas la vue 3D : la carte Mapbox restait
   * centrée sur l'ancien site, et les caches comme les meshes gardaient ses trous
   * et ses terrains. On la reconstruit entièrement sur le nouveau site.
   */
  private refresh3DViewForSite(): void {
    if (!this.isMapboxTerrainMode) return;

    // Vide les caches, les meshes et détruit la carte Mapbox
    this.disableMapboxTerrainView();

    this.viewMode = '3d';
    this.isMapboxTerrainMode = true;
    this.is3DMode = true;

    const olViewport = document.getElementById('map')?.querySelector('.ol-viewport') as HTMLElement;
    if (olViewport) olViewport.style.display = 'none';
    this.cdr.detectChanges();

    // La vue OL est encore en animation vers le nouveau site : on part des
    // coordonnées du site plutôt que du centre courant, qui serait l'ancien.
    let center: [number, number] | undefined;
    if (this.site?.epsg && this.site.coordX != null && this.site.coordY != null) {
      const wgs84 = transform([this.site.coordX, this.site.coordY], 'EPSG:' + this.site.epsg, 'EPSG:4326');
      center = [wgs84[0], wgs84[1]];
    }

    this.enableMapboxTerrainView(center);
  }

  toggleMapboxTerrainView(): void {
    if (!this.isMapboxTerrainMode) {
      this.isMapboxTerrainMode = true;
      this.is3DMode = true;
      // Masquer immédiatement le viewport OL
      const olViewport = document.getElementById('map')?.querySelector('.ol-viewport') as HTMLElement;
      if (olViewport) olViewport.style.display = 'none';
      this.cdr.detectChanges();

      this.enableMapboxTerrainView();
    } else {
      this.disableMapboxTerrainView();
    }
  }

  private async enableMapboxTerrainView(centerOverrideWGS84?: [number, number]): Promise<void> {
    try {
      // Obtenir le token Mapbox
      if (!this.mapboxToken) {
        this.mapboxToken = await this.mapService.getMapBoxPublicKey();
        // Utiliser le worker CDN pour éviter le conflit __async avec le bundler Angular
        (mapboxgl as any).workerUrl = `https://api.mapbox.com/mapbox-gl-js/v3.18.1/mapbox-gl-csp-worker.js`;
        (mapboxgl as any).accessToken = this.mapboxToken;
      }

      // Créer le conteneur Mapbox dans #map
      const mapContainer = document.getElementById('map');
      if (!mapContainer) return;

      this.mapboxContainer = document.createElement('div');
      this.mapboxContainer.id = 'mapbox-container';
      this.mapboxContainer.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;z-index:10;';
      mapContainer.appendChild(this.mapboxContainer);

      // Centre et zoom de la carte OL en WGS84. Sur un changement de site, la vue OL
      // est encore en cours d'animation : l'appelant fournit alors le centre visé.
      const olView = this.map.getView();
      const center = olView.getCenter() || [0, 0];
      const zoom = olView.getZoom() || 10;
      const centerWGS84 = centerOverrideWGS84 ?? transform(center, 'EPSG:3857', 'EPSG:4326');

      // Si le centre est à (0,0), utiliser un fallback
      const finalCenter: [number, number] = (Math.abs(centerWGS84[0]) < 0.1 && Math.abs(centerWGS84[1]) < 0.1)
        ? [6.8649, 45.8326] // Chamonix (test)
        : [centerWGS84[0], centerWGS84[1]];

      // Activer le mode 3D immédiatement pour que le HTML réagisse
      this.isMapboxTerrainMode = true;
      this.is3DMode = true;

      // La 3D n'affiche plus de fond de carte : ni satellite, ni relief Mapbox.
      // Seuls le nuage LAS, les terrains blast et les trous sont rendus, sur fond neutre.
      const mapStyle = {
        version: 8 as const,
        sources: {},
        layers: [{ id: 'bg', type: 'background' as const, paint: { 'background-color': '#4a6fa5' } }]
      };

      this.mapboxMap = new mapboxgl.Map({
        container: this.mapboxContainer,
        style: mapStyle,
        center: finalCenter,
        zoom: Math.max(zoom, 13),
        pitch: 75,
        bearing: 0,
        antialias: true,
        dragRotate: true,
        dragPan: true,
        preserveDrawingBuffer: true,
        failIfMajorPerformanceCaveat: false
      });

      // Masquer les labels dès que le style est parsé (avant le rendu des tuiles)
      this.mapboxMap!.on('style.load', () => {
        this.mapboxMap!.getStyle().layers.forEach((layer: any) => {
          if (layer.type === 'symbol') {
            this.mapboxMap!.setLayoutProperty(layer.id, 'visibility', 'none');
          }
        });
      });

      // Configurer le terrain quand la carte est chargée
      await new Promise<void>((resolve) => {
        this.mapboxMap!.on('load', () => {
          // Ni source DEM, ni terrain, ni hillshade : le relief affiché vient
          // uniquement du LAS et des terrains blast, pas de Mapbox.

          // Animation de caméra
          setTimeout(() => {
            this.mapboxMap!.easeTo({ pitch: 70, bearing: 30, duration: 3000 });
          }, 1000);

          this.mapboxMap!.addControl(new mapboxgl.NavigationControl(), 'top-right');

          // Réduire la sensibilité des contrôles
          this.mapboxMap!['dragPan']._inertiaOptions = { maxSpeed: 400, linearity: 0.1, deceleration: 3500 };
          this.mapboxMap!['scrollZoom'].setWheelZoomRate(1 / 400);
          this.mapboxMap!['scrollZoom'].setZoomRate(1 / 100);
          this.mapboxReady = true;
          this.cdr.detectChanges();
          resolve();

          // Charger le terrain LAZ depuis le cache si disponible
          this.loadCachedLazTerrain();

          // Afficher les trous 3D des tirs déjà sélectionnés
          if (this.listeTirsSelectionnes.length > 0) {
            this.display3DHoles(this.listeTirsSelectionnes);
          }
        });
      });

      // Masquer OL viewport
      const olViewport = mapContainer.querySelector('.ol-viewport') as HTMLElement;
      if (olViewport) olViewport.style.display = 'none';

    } catch (error) {
      this.isMapboxTerrainMode = false;
      this.is3DMode = false;
      console.error('Erreur activation vue 3D terrain:', error);
    }
  }

  private disableMapboxTerrainView(): void {
    // Nettoyer les layers 3D
    this.cleanup3DHoles();
    this.cleanupPointCloudLayer();
    try { if (this.mapboxMap?.getLayer(this.terrainMeshLayerId)) this.mapboxMap.removeLayer(this.terrainMeshLayerId); } catch (e) {}

    // Nettoyer Mapbox
    if (this.mapboxMap) {
      this.mapboxMap.remove();
      this.mapboxMap = null;
    }
    if (this.mapboxContainer) {
      this.mapboxContainer.remove();
      this.mapboxContainer = null;
    }

    // Restaurer OL
    const mapContainer = document.getElementById('map');
    if (mapContainer) {
      const olViewport = mapContainer.querySelector('.ol-viewport') as HTMLElement;
      if (olViewport) olViewport.style.display = 'block';
    }

    setTimeout(() => this.map?.updateSize(), 100);

    this.isMapboxTerrainMode = false;
    this.is3DMode = false;
    this.mapboxReady = false;
    this.holes3DLoaded = false;
    // La 3D peut être quittée autrement que par setViewMode (changement de site,
    // destruction du composant) : on resynchronise le mode courant.
    if (this.viewMode === '3d') {
      this.viewMode = this.mapLayersControler.isOSMLayerVisible ? 'plan2d' : 'map2d';
    }
    this.allBlastHolesCache.clear();
    this.allBlastTerrainCache.clear();
    this.holes3DMeshes.clear();
    this.terrain3DMeshes.clear();
    this.holes3DScene = null;

    // Reset LAZ state
    this.lazLoadingProgress.set(0);
    this.lazIsLoading.set(false);
    this.lazPointCount.set(0);
    this.lazFileName.set('');
  }

  // =========================================================================
  // CHARGEMENT LAZ → VIEWER THREE.JS AVEC VRAIS XYZ
  // =========================================================================

  async onLazFileSelected(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;

    const file = input.files[0];
    this.lazFileName.set(file.name);
    this.lazIsLoading.set(true);
    this.lazLoadingProgress.set(0);

    try {
      const arrayBuffer = await file.arrayBuffer();
      this.lazLoadingProgress.set(10);

      const dataView = new DataView(arrayBuffer);

      // ---- Parser le header LAS ----
      const pointDataRecordFormat = dataView.getUint8(104) & 0x3f;
      const isCompressed = ((dataView.getUint8(104) & 0x80) >> 7) === 1;
      const pointDataRecordLength = dataView.getUint16(105, true);
      const pointDataOffset = dataView.getUint32(96, true);

      const versionMajor = dataView.getUint8(24);
      const versionMinor = dataView.getUint8(25);
      let pointCount: number;
      if (versionMajor >= 1 && versionMinor >= 4) {
        pointCount = Number(dataView.getBigUint64(247, true));
      } else {
        pointCount = dataView.getUint32(107, true);
      }

      const scaleX = dataView.getFloat64(131, true);
      const scaleY = dataView.getFloat64(139, true);
      const scaleZ = dataView.getFloat64(147, true);
      const offsetX = dataView.getFloat64(155, true);
      const offsetY = dataView.getFloat64(163, true);
      const offsetZ = dataView.getFloat64(171, true);

      // Bornes XYZ du nuage (dans le header LAS)
      const headerMaxX = dataView.getFloat64(179, true);
      const headerMinX = dataView.getFloat64(187, true);
      const headerMaxY = dataView.getFloat64(195, true);
      const headerMinY = dataView.getFloat64(203, true);
      const headerMaxZ = dataView.getFloat64(211, true);
      const headerMinZ = dataView.getFloat64(219, true);

      this.lazPointCount.set(pointCount);
      this.lazLoadingProgress.set(20);

      // Offset RGB dans le point record
      let rgbOffset = -1;
      if (pointDataRecordFormat === 2) rgbOffset = 20;
      else if (pointDataRecordFormat === 3 || pointDataRecordFormat === 5) rgbOffset = 28;
      else if (pointDataRecordFormat === 7 || pointDataRecordFormat === 8) rgbOffset = 30;

      // Sous-échantillonnage (max ~2M points pour Three.js)
      const step = pointCount > 2000000 ? Math.ceil(pointCount / 2000000) : 1;
      const displayCount = Math.ceil(pointCount / step);

      // Centre et bornes Z directement depuis le header (évite un scan complet)
      const centerX = (headerMinX + headerMaxX) / 2;
      const centerY = (headerMinY + headerMaxY) / 2;
      const centerZ = (headerMinZ + headerMaxZ) / 2;
      const minZf = headerMinZ;
      const maxZf = headerMaxZ;
      const rangeZf = (maxZf - minZf) || 1;

      // Buffers de sortie Three.js
      const positions = new Float32Array(displayCount * 3);
      const colors = new Float32Array(displayCount * 3);

      // ---- Convertir le centre vers WGS84 et créer le layer AVANT le parsing ----
      const siteEpsg = this.site?.epsg ? 'EPSG:' + this.site.epsg : null;
      let centerLng: number, centerLat: number;
      if (siteEpsg) {
        const centerWGS84 = proj4(siteEpsg, 'EPSG:4326', [centerX, centerY]);
        centerLng = centerWGS84[0];
        centerLat = centerWGS84[1];
      } else {
        centerLng = centerX;
        centerLat = centerY;
      }

      // Rien à masquer : la vue 3D n'a ni tuile ni terrain Mapbox, et le fond
      // neutre vient déjà du style. Masquer tous les calques ferait au contraire
      // disparaître les trous et terrains blast déjà affichés.

      this.lazLoadingProgress.set(20);

      const YIELD_INTERVAL = 50000;

      console.log('[LAZ] Header parsed — compressed:', isCompressed, 'points:', pointCount, 'step:', step, 'display:', displayCount);
      console.log('[LAZ] Center:', centerX, centerY, centerZ, '→ WGS84:', centerLng, centerLat);

      if (isCompressed) {
        // ---- Fichier LAZ compressé : single-pass décompression + remplissage buffers ----
        console.log('[LAZ] Importing laz-perf...');
        const lazPerfModule = await import('laz-perf') as any;
        const createFn = lazPerfModule.createLazPerf ?? lazPerfModule.default?.createLazPerf ?? lazPerfModule.default;
        console.log('[LAZ] laz-perf imported, initializing WASM...');
        const LazPerf = await createFn();
        console.log('[LAZ] WASM ready');
        this.lazLoadingProgress.set(25);

        const laszip = new LazPerf.LASZip();
        const filePtr = LazPerf._malloc(arrayBuffer.byteLength);
        const pointPtr = LazPerf._malloc(pointDataRecordLength);

        LazPerf.HEAPU8.set(new Uint8Array(arrayBuffer), filePtr);
        laszip.open(filePtr, arrayBuffer.byteLength);

        // Single-pass : décompresser et remplir les buffers en une seule boucle
        let idx = 0;
        for (let i = 0; i < pointCount; i++) {
          laszip.getPoint(pointPtr);

          // Ne traiter que les points échantillonnés
          if (i % step !== 0) continue;

          // Lire directement depuis la mémoire WASM (pas de copie)
          const pOff = pointPtr;
          const heap = LazPerf.HEAPU8;
          const buf = heap.buffer;
          const pView = new DataView(buf, pOff, pointDataRecordLength);

          const x = pView.getInt32(0, true) * scaleX + offsetX - centerX;
          const y = pView.getInt32(4, true) * scaleY + offsetY - centerY;
          const z = pView.getInt32(8, true) * scaleZ + offsetZ - centerZ;

          const i3 = idx * 3;
          positions[i3] = x;
          positions[i3 + 1] = y;
          positions[i3 + 2] = z;

          if (rgbOffset >= 0) {
            colors[i3] = (pView.getUint16(rgbOffset, true) >> 8) / 255;
            colors[i3 + 1] = (pView.getUint16(rgbOffset + 2, true) >> 8) / 255;
            colors[i3 + 2] = (pView.getUint16(rgbOffset + 4, true) >> 8) / 255;
          } else {
            const rawZ = pView.getInt32(8, true) * scaleZ + offsetZ;
            const t = (rawZ - minZf) / rangeZf;
            colors[i3] = t < 0.5 ? 0 : (t - 0.5) * 2;
            colors[i3 + 1] = t < 0.5 ? t * 2 : (1 - t) * 2;
            colors[i3 + 2] = t < 0.5 ? 1 - t * 2 : 0;
          }

          idx++;

          if (i % YIELD_INTERVAL === 0) {
            this.lazLoadingProgress.set(20 + Math.round((i / pointCount) * 70));
            await new Promise<void>(resolve => setTimeout(resolve, 0));
          }
        }

        LazPerf._free(filePtr);
        LazPerf._free(pointPtr);
        laszip.delete();

      } else {
        // ---- Fichier LAS non compressé : lecture directe ----
        console.log('[LAZ] Uncompressed LAS — direct read');
        this.lazLoadingProgress.set(25);
        const pointsData = new DataView(arrayBuffer, pointDataOffset);

        let idx = 0;
        for (let i = 0; i < pointCount; i += step) {
          const off = i * pointDataRecordLength;
          const x = pointsData.getInt32(off, true) * scaleX + offsetX - centerX;
          const y = pointsData.getInt32(off + 4, true) * scaleY + offsetY - centerY;
          const z = pointsData.getInt32(off + 8, true) * scaleZ + offsetZ - centerZ;

          const i3 = idx * 3;
          positions[i3] = x;
          positions[i3 + 1] = y;
          positions[i3 + 2] = z;

          if (rgbOffset >= 0) {
            colors[i3] = (pointsData.getUint16(off + rgbOffset, true) >> 8) / 255;
            colors[i3 + 1] = (pointsData.getUint16(off + rgbOffset + 2, true) >> 8) / 255;
            colors[i3 + 2] = (pointsData.getUint16(off + rgbOffset + 4, true) >> 8) / 255;
          } else {
            const rawZ = pointsData.getInt32(off + 8, true) * scaleZ + offsetZ;
            const t = (rawZ - minZf) / rangeZf;
            colors[i3] = t < 0.5 ? 0 : (t - 0.5) * 2;
            colors[i3 + 1] = t < 0.5 ? t * 2 : (1 - t) * 2;
            colors[i3 + 2] = t < 0.5 ? 1 - t * 2 : 0;
          }

          idx++;

          if (i % YIELD_INTERVAL === 0) {
            this.lazLoadingProgress.set(25 + Math.round((i / pointCount) * 65));
            if (this.pointCloudGeometry) {
              this.pointCloudGeometry.attributes.position.needsUpdate = true;
              this.pointCloudGeometry.attributes.color.needsUpdate = true;
              this.pointCloudGeometry.setDrawRange(0, idx);
              this.mapboxMap?.triggerRepaint();
            }
            await new Promise<void>(resolve => setTimeout(resolve, 0));
          }
        }
      }

      // ---- Trianguler et convertir en proto terrain ----
      console.log('[LAZ] Point processing done, triangulating...');
      this.lazLoadingProgress.set(95);
      this.cdr.detectChanges();

      try {
        const terrainResult = await this.lazToTerrainService.convertToTerrain(
          positions, colors, displayCount,
          centerX, centerY, centerZ,
          this.site?.siteId || 0,
          parseInt(this.site?.epsg || '0', 10)
        );

        // Sauvegarder le proto sur le backend
        if (this.site?.siteId) {
          this.http.saveSiteTerrainBinary(this.site.siteId, terrainResult.protoBinary.buffer as ArrayBuffer)
            .subscribe({
              next: () => console.log('[LAZ] Terrain proto saved to backend'),
              error: (err: any) => console.warn('[LAZ] Failed to save to backend:', err)
            });
        }

        const terrainData = await this.terrainLoaderService.loadTerrainFromBinary(terrainResult.protoBinary.buffer as ArrayBuffer);
        if (terrainData.terrains && this.mapboxMap) {
          await this.addTerrainMeshToMapbox(terrainData, centerLng, centerLat, centerZ);
        }

        console.log(`[LAZ] Terrain mesh: ${terrainResult.vertexCount} vertices, ${terrainResult.triangleCount} triangles`);
      } catch (terrainErr) {
        console.warn('[LAZ] Triangulation failed, keeping point cloud:', terrainErr);
      }

      this.lazLoadingProgress.set(100);
      this.lazIsLoading.set(false);

    } catch (error) {
      console.error('Erreur chargement LAZ:', error);
      this.lazIsLoading.set(false);
    }

    input.value = '';
  }

  /**
   * Ajoute le nuage de points comme custom layer Three.js dans Mapbox GL.
   * La carte terrain reste visible, le nuage est superposé à sa position géo réelle.
   */
  private async addPointCloudToMapbox(
    positions: Float32Array,
    colors: Float32Array,
    count: number,
    centerLng: number,
    centerLat: number,
    centerAlt: number
  ): Promise<void> {
    if (!this.mapboxMap) return;

    if (!this.threeModule) this.threeModule = await import('three');
    const THREE = this.threeModule;

    // Supprimer le layer précédent si on re-upload
    this.cleanupPointCloudLayer();

    // Point de référence en coordonnées Mercator
    const modelAsMercator = mapboxgl.MercatorCoordinate.fromLngLat(
      [centerLng, centerLat],
      centerAlt
    );
    const meterScale = modelAsMercator.meterInMercatorCoordinateUnits();

    const modelTransform = {
      translateX: modelAsMercator.x,
      translateY: modelAsMercator.y,
      translateZ: modelAsMercator.z,
      scale: meterScale
    };

    // Préparer la géométrie Three.js (pré-allouée, remplie progressivement)
    const geometry = new THREE.BufferGeometry();
    const posAttr = new THREE.BufferAttribute(positions, 3);
    const colAttr = new THREE.BufferAttribute(colors, 3);
    posAttr.setUsage(THREE.DynamicDrawUsage);
    colAttr.setUsage(THREE.DynamicDrawUsage);
    geometry.setAttribute('position', posAttr);
    geometry.setAttribute('color', colAttr);
    geometry.setDrawRange(0, 0); // Commence vide

    // Exposer la géométrie pour le rendu progressif
    this.pointCloudGeometry = geometry;

    const material = new THREE.PointsMaterial({
      size: 4.5,
      vertexColors: true,
      sizeAttenuation: true,
      depthTest: true,
      depthWrite: true
    });

    const pointCloud = new THREE.Points(geometry, material);

    // Variables capturées dans la closure du custom layer
    let renderer: any;
    let scene: any;
    let camera: any;

    const mapRef = this.mapboxMap;
    const self = this;

    const customLayer: mapboxgl.CustomLayerInterface = {
      id: this.pointCloudLayerId,
      type: 'custom',
      renderingMode: '3d',

      onAdd(_map: mapboxgl.Map, gl: WebGLRenderingContext) {
        camera = new THREE.Camera();
        scene = new THREE.Scene();
        scene.add(pointCloud);

        renderer = new THREE.WebGLRenderer({
          canvas: _map.getCanvas(),
          context: gl,
          antialias: true
        });
        renderer.autoClear = false;

        self.threeRenderer = renderer;
        self.threeScene = scene;
        self.threeCamera = camera;
      },

      render(_gl: WebGLRenderingContext, matrix: number[]) {
        // LAZ est déjà en Z-up (East=X, North=Y, Alt=Z) — pas de rotation nécessaire
        // Scale Y négatif car Mercator Y pointe vers le sud
        // Scale Z multiplié par l'exagération terrain (1.8) pour que les points
        // correspondent au relief exagéré et ne soient pas cachés dessous
        const terrainExaggeration = 1.8;
        const m = new THREE.Matrix4().fromArray(matrix);
        const l = new THREE.Matrix4()
          .makeTranslation(
            modelTransform.translateX,
            modelTransform.translateY,
            modelTransform.translateZ * terrainExaggeration
          )
          .scale(
            new THREE.Vector3(
              modelTransform.scale,
              -modelTransform.scale,
              modelTransform.scale * terrainExaggeration
            )
          );

        camera.projectionMatrix = m.multiply(l);

        // Ajuster la taille des points en fonction du zoom
        const zoom = self.mapboxMap?.getZoom() || 15;
        material.size = Math.max(2, 1.5 * Math.pow(2, zoom - 14));

        renderer.resetState();
        renderer.render(scene, camera);

        mapRef.triggerRepaint();
      }
    };

    this.mapboxMap.addLayer(customLayer);

    // Voler vers la position du nuage de points
    this.mapboxMap.flyTo({
      center: [centerLng, centerLat],
      zoom: 17,
      pitch: 60,
      bearing: 30,
      duration: 2000
    });

    this.isPointCloudMode = true;
  }


  /**
   * Supprime le custom layer point cloud de Mapbox et libère les ressources Three.js.
   */
  private holes3DLayerId = 'blast-holes-3d';

  private allBlastHolesCache: Map<number, any[]> = new Map();
  private allBlastTerrainCache: Map<number, ArrayBuffer> = new Map();
  private holes3DScene: any = null;
  private holes3DMeshes: Map<number, any[]> = new Map();
  private terrain3DMeshes: Map<number, any[]> = new Map();
  private siteTerrainMeshes: any[] = [];
  /** Groupe Three.js de chaque terrain, pour pouvoir le détacher de la scène */
  private terrain3DGroups: Map<number, any> = new Map();
  /** Géométrie et matériaux communs à tous les tirs, libérés uniquement en fin de session */
  private shared3DResources: { topMaterial: any, bottomMaterial: any, lineMaterial: any, sphereGeometry: any } | null = null;
  /**
   * Distance au-delà de laquelle un trou est considéré comme aberrant, dans les
   * unités de l'EPSG du site (50 km sur un système projeté en mètres). Large à
   * dessein : il s'agit d'écarter des données franchement fausses, pas de border
   * l'emprise réelle d'un site.
   */
  private static readonly MAX_DISTANCE_FROM_SITE = 50000;

  /**
   * Origine des coordonnées de la scène 3D, figée à la première construction.
   * Tous les meshes sont positionnés relativement à elle : la garder stable est
   * ce qui permet de conserver ceux déjà construits d'une sélection à l'autre.
   */
  private ref3D: { x: number, y: number, z: number } | null = null;
  /** Sélection déjà construite, pour ne pas tout refaire quand elle n'a pas bougé */
  private lastDisplayed3DKey = '';
  /** Seule la dernière reconstruction lancée a le droit d'écrire dans la scène */
  private display3DGeneration = 0;

  onTerrainOpacityChange(value: number): void {
    this.terrainOpacity.set(value);
    const applyOpacity = (mesh: any) => {
      if (mesh?.material) {
        mesh.material.opacity = value;
        mesh.material.transparent = true;
        mesh.material.depthWrite = value >= 1;
        mesh.material.needsUpdate = true;
      }
    };
    this.siteTerrainMeshes.forEach(applyOpacity);
    this.terrain3DMeshes.forEach(meshes => meshes.forEach(applyOpacity));
    this.mapboxMap?.triggerRepaint();
  }

  onLayerToggle(): void {
    // Terrain site (LAZ)
    if (this.mapboxMap) {
      const terrainMeshLayer = this.mapboxMap.getLayer(this.terrainMeshLayerId);
      if (terrainMeshLayer) {
        this.mapboxMap.setLayoutProperty(this.terrainMeshLayerId, 'visibility', this.showSiteTerrain() ? 'visible' : 'none');
      }
    }
    // Terrains blast + trous : toggle visibilité des meshes Three.js
    this.terrain3DMeshes.forEach((meshes) => {
      meshes.forEach(m => m.visible = this.showBlastTerrains());
    });
    this.holes3DMeshes.forEach((meshes) => {
      meshes.forEach(m => m.visible = this.showHoles3D());
    });
    this.mapboxMap?.triggerRepaint();
  }

  /**
   * Molette sur le slider : un cran avance ou recule d'un jour, soit le pas du
   * curseur. preventDefault évite que la page défile en même temps.
   */
  onTimelineWheel(event: WheelEvent): void {
    event.preventDefault();

    const oneDay = 86400000;
    const direction = event.deltaY < 0 ? 1 : -1;
    const next = this.timelineCursor() + direction * oneDay;

    this.onTimelineCursorChange(
      Math.min(this.timelineMax(), Math.max(this.timelineMin(), next))
    );
  }

  /**
   * Les bornes du slider dépendent de la sélection. Sans recalage, le curseur
   * reste sur son ancienne valeur, souvent hors de la nouvelle plage : la poignée
   * se colle à une extrémité et devient impossible à déplacer.
   */
  private clampTimelineCursor(): void {
    const min = this.timelineMin();
    const max = this.timelineMax();
    if (max <= 0) return;

    const cursor = this.timelineCursor();
    if (cursor < min || cursor > max) {
      // On repart de la borne haute : tous les tirs sélectionnés restent visibles
      this.timelineCursor.set(max);
    }
  }

  onTimelineCursorChange(value: number): void {
    this.timelineCursor.set(+value);
    const beforeCursor = new Set(
      this.sortedBlasts().filter(t => t._date <= +value).map(t => t.tirId)
    );
    this.holes3DMeshes.forEach((meshes, blastId) => {
      const visible = beforeCursor.has(blastId) && this.listeTirsSelectionnes.includes(blastId) && this.showHoles3D();
      meshes.forEach(m => m.visible = visible);
    });
    this.terrain3DMeshes.forEach((meshes, blastId) => {
      const visible = beforeCursor.has(blastId) && this.listeTirsSelectionnes.includes(blastId) && this.showBlastTerrains();
      meshes.forEach(m => m.visible = visible);
    });
    this.mapboxMap?.triggerRepaint();
  }

  private async display3DHoles(blastIds: number[]): Promise<void> {
    if (!this.mapboxMap) return;

    // La reconstruction repart de zéro à chaque appel : inutile de la relancer
    // si la sélection n'a pas changé (le handler se déclenche aussi pour autre chose).
    const selectionKey = [...blastIds].sort((a, b) => a - b).join(',');
    if (selectionKey === this.lastDisplayed3DKey && this.mapboxMap.getLayer(this.holes3DLayerId)) {
      return;
    }

    // Deux clics rapprochés relancent la méthode avant la fin de la précédente :
    // on marque la génération courante et les appels dépassés s'arrêtent aux await.
    const generation = ++this.display3DGeneration;

    if (!this.threeModule) this.threeModule = await import('three');
    if (generation !== this.display3DGeneration) return;
    const THREE = this.threeModule;

    const siteEpsg = this.site?.epsg ? 'EPSG:' + this.site.epsg : null;

    // Une seule requête pour tous les tirs manquants, avec les seuls champs
    // utiles au rendu 3D : un appel par tir saturait le réseau.
    const uncachedHoleIds = blastIds.filter(id => !this.allBlastHolesCache.has(id));
    if (uncachedHoleIds.length > 0) {
      try {
        const blasts = await this.holeService.GetBlastsHoles3D(uncachedHoleIds);
        if (generation !== this.display3DGeneration) return;
        blasts.forEach(blast => {
          if (blast?.Holes) {
            this.allBlastHolesCache.set(blast.tirId, blast.Holes);
          }
        });
      } catch {
        if (generation !== this.display3DGeneration) return;
      }
    }

    // Le réseau des terrains tourne pendant qu'on construit la géométrie des trous
    const terrainFetch = this.fetchMissingTerrains(blastIds);

    // Les tirs désélectionnés sont retirés ; ceux qui restent gardent leurs meshes,
    // valides tant que le repère ne bouge pas.
    const selected = new Set(blastIds);
    this.removeBlastsFrom3DScene(
      [...this.holes3DMeshes.keys()].filter(id => !selected.has(id))
    );

    // Seuls les tirs pas encore construits sont traités
    const holesPerBlast: { blastId: number, holes: any[] }[] = [];
    for (const id of blastIds) {
      if (this.holes3DMeshes.has(id)) continue;
      const holes = this.allBlastHolesCache.get(id);
      if (holes) holesPerBlast.push({ blastId: id, holes });
    }

    // Le repère est figé à la première construction et conservé toute la session 3D.
    // C'est ce qui rend les meshes réutilisables : s'il suivait la sélection, tous
    // les offsets changeraient et il faudrait tout reconstruire à chaque clic.
    if (!this.holes3DScene) {
      // Le repère doit venir d'un trou plausible : pris sur une position aberrante,
      // il décalerait toute la scène et rendrait tous les autres tirs invisibles.
      const firstHole = holesPerBlast
        .flatMap(b => b.holes)
        .find(h => h.PositionPlannedXYZ && this.isHoleNearSite(h));
      if (!firstHole) return;

      this.ref3D = {
        x: firstHole.PositionPlannedXYZ.x,
        y: firstHole.PositionPlannedXYZ.y,
        z: firstHole.PositionPlannedXYZ.z
      };

      let refLng: number, refLat: number;
      if (siteEpsg) {
        const refWGS84 = proj4(siteEpsg, 'EPSG:4326', [this.ref3D.x, this.ref3D.y]);
        refLng = refWGS84[0];
        refLat = refWGS84[1];
      } else {
        refLng = this.ref3D.x;
        refLat = this.ref3D.y;
      }

      const modelAsMercator = mapboxgl.MercatorCoordinate.fromLngLat([refLng, refLat], this.ref3D.z);
      const terrainExaggeration = 1.8;
      const modelTransform = {
        translateX: modelAsMercator.x,
        translateY: modelAsMercator.y,
        translateZ: modelAsMercator.z,
        scale: modelAsMercator.meterInMercatorCoordinateUnits()
      };

      this.holes3DScene = new THREE.Scene();
      const camera = new THREE.Camera();
      this.addHoles3DLayer(this.holes3DScene, camera, modelTransform, terrainExaggeration, THREE);
    }

    const ref = this.ref3D!;
    const scene = this.holes3DScene;

    // Partagés par tous les tirs et créés une seule fois : ils ne doivent surtout
    // pas être libérés à la désélection d'un tir, sinon les autres perdent leur rendu.
    this.shared3DResources ??= {
      topMaterial: new THREE.MeshBasicMaterial({ color: 0xff0000 }),
      bottomMaterial: new THREE.MeshBasicMaterial({ color: 0x0000ff }),
      lineMaterial: new THREE.LineBasicMaterial({ color: 0xffffff }),
      sphereGeometry: new THREE.SphereGeometry(0.3, 12, 12)
    };
    const { topMaterial, bottomMaterial, lineMaterial, sphereGeometry } = this.shared3DResources;

    // Un Mesh et une géométrie par trou gelaient l'UI et écroulaient le framerate
    // dès quelques milliers de trous. On accumule les coordonnées puis on crée
    // trois objets par tir : deux InstancedMesh pour les sphères, un LineSegments
    // pour les tiges. Le coût passe de 3N objets à 3.
    for (const { blastId, holes } of holesPerBlast) {
      const meshesForBlast: any[] = [];
      const topPositions: number[] = [];
      const bottomPositions: number[] = [];
      const linePositions: number[] = [];

      for (const hole of holes) {
        if (!hole.PositionPlannedXYZ || !hole.Geometry) continue;
        // Données ponctuellement incohérentes : un trou à l'opposé du site
        // étirerait la scène sur des centaines de kilomètres
        if (!this.isHoleNearSite(hole)) continue;

        const status = hole.Status?.toUpperCase();
        const x = hole.PositionPlannedXYZ.x - ref.x;
        const y = hole.PositionPlannedXYZ.y - ref.y;
        const z = hole.PositionPlannedXYZ.z - ref.z;

        topPositions.push(x, y, z);

        if (status !== 'COLLAPSED' && status !== 'MISSING') {
          const angleRad = (hole.Geometry.angle || 0) * Math.PI / 180;
          const azimuthRad = (hole.Geometry.azimuth || 0) * Math.PI / 180;
          const length = hole.Geometry.length || 10;
          const dx = length * Math.sin(angleRad) * Math.sin(azimuthRad);
          const dy = length * Math.sin(angleRad) * Math.cos(azimuthRad);
          const dz = -length * Math.cos(angleRad);

          bottomPositions.push(x + dx, y + dy, z + dz);
          linePositions.push(x, y, z, x + dx, y + dy, z + dz);
        }
      }

      const addSpheres = (positions: number[], material: any) => {
        const count = positions.length / 3;
        if (count === 0) return;

        const instanced = new THREE.InstancedMesh(sphereGeometry, material, count);
        const matrix = new THREE.Matrix4();
        for (let i = 0; i < count; i++) {
          matrix.setPosition(positions[i * 3], positions[i * 3 + 1], positions[i * 3 + 2]);
          instanced.setMatrixAt(i, matrix);
        }
        instanced.instanceMatrix.needsUpdate = true;
        // La bounding sphere vient de la géométrie de base, pas des instances :
        // sans ça le frustum culling ferait disparaître les trous.
        instanced.frustumCulled = false;

        scene.add(instanced);
        meshesForBlast.push(instanced);
      };

      addSpheres(topPositions, topMaterial);
      addSpheres(bottomPositions, bottomMaterial);

      if (linePositions.length > 0) {
        const lineGeometry = new THREE.BufferGeometry();
        lineGeometry.setAttribute('position', new THREE.Float32BufferAttribute(linePositions, 3));
        const lines = new THREE.LineSegments(lineGeometry, lineMaterial);
        lines.frustumCulled = false;
        scene.add(lines);
        meshesForBlast.push(lines);
      }

      this.holes3DMeshes.set(blastId, meshesForBlast);
    }

    // Quels tirs sont visibles selon le curseur de la timeline
    const cursor = this.timelineCursor();
    const visibleIds = new Set(
      this.sortedBlasts().filter(t => t._date <= cursor).map(t => t.tirId)
    );
    // Le toggle de calque est pris en compte, sinon une reconstruction
    // faisait réapparaître des trous que l'utilisateur avait masqués.
    const holesVisible = this.showHoles3D();
    this.holes3DMeshes.forEach((meshes, bid) => {
      meshes.forEach(m => m.visible = visibleIds.has(bid) && holesVisible);
    });
    this.mapboxMap?.triggerRepaint();

    await terrainFetch;
    if (generation !== this.display3DGeneration) return;

    const offsetPoint = new THREE.Vector3(ref.x, ref.y, ref.z);

    // Seuls les terrains pas encore décodés sont traités : le décodage protobuf
    // est le poste le plus coûteux, inutile de le refaire pour un tir déjà affiché.
    const terrainIdsToBuild = blastIds.filter(id => !this.terrain3DMeshes.has(id));

    for (let i = 0; i < terrainIdsToBuild.length; i++) {
      const cachedTerrain = this.allBlastTerrainCache.get(terrainIdsToBuild[i]);
      if (cachedTerrain) {
        try {
          // offsetPoint aligne les vertices du terrain avec ceux des trous
          const terrainData = await this.terrainLoaderService.loadTerrainFromBinary(cachedTerrain.slice(0), offsetPoint);
          if (generation !== this.display3DGeneration) return;
          const terrainMeshes: any[] = [];

          // Convertir les materials en MeshBasicMaterial (pas de lumière dans le custom layer Mapbox)
          terrainData.terrains.traverse((child: any) => {
            if (child.isMesh) {
              child.frustumCulled = false;
              const oldMat = child.material;
              const opacity = this.terrainOpacity();
              const newMat = new THREE.MeshBasicMaterial({
                side: THREE.DoubleSide,
                transparent: true,
                opacity,
                depthWrite: opacity >= 1
              });

              if (oldMat.map) newMat.map = oldMat.map;
              if (oldMat.vertexColors) newMat.vertexColors = true;
              if (!oldMat.map && !oldMat.vertexColors) {
                newMat.color = oldMat.color || new THREE.Color(0x8B7355);
              }

              child.material = newMat;
              terrainMeshes.push(child);
            }
          });

          scene.add(terrainData.terrains);

          const blastId = terrainIdsToBuild[i];
          const terrainVisible = visibleIds.has(blastId) && this.showBlastTerrains();
          terrainMeshes.forEach(m => m.visible = terrainVisible);
          this.terrain3DMeshes.set(blastId, terrainMeshes);
          // Le groupe est conservé pour pouvoir le retirer de la scène à la désélection
          this.terrain3DGroups.set(blastId, terrainData.terrains);
          this.mapboxMap?.triggerRepaint();
        } catch (e) {
          // Pas de terrain pour ce blast
        }

        // Le décodage protobuf d'un terrain est lourd et synchrone : sans cette
        // pause, la boucle gèlerait l'onglet jusqu'au dernier terrain.
        await this.yieldToBrowser();
        if (generation !== this.display3DGeneration) return;
      }
    }

    this.lastDisplayed3DKey = selectionKey;
  }

  /**
   * Retire de la scène les tirs désélectionnés et libère leur mémoire GPU.
   * Les tirs toujours sélectionnés ne sont pas touchés : leurs meshes restent
   * valides puisque le repère de la scène ne change pas.
   */
  private removeBlastsFrom3DScene(blastIds: number[]): void {
    if (blastIds.length === 0 || !this.holes3DScene) return;

    for (const blastId of blastIds) {
      this.holes3DMeshes.get(blastId)?.forEach(mesh => {
        this.holes3DScene.remove(mesh);
        this.disposeObject3D(mesh);
      });
      this.holes3DMeshes.delete(blastId);

      const terrainGroup = this.terrain3DGroups.get(blastId);
      if (terrainGroup) {
        this.holes3DScene.remove(terrainGroup);
        terrainGroup.traverse((child: any) => this.disposeObject3D(child));
        this.terrain3DGroups.delete(blastId);
      }
      this.terrain3DMeshes.delete(blastId);
    }

    this.mapboxMap?.triggerRepaint();
  }

  /**
   * Libère géométrie, matériaux et textures d'un objet Three.js, en épargnant
   * les ressources partagées entre tirs, qui survivent à la désélection.
   */
  private disposeObject3D(object: any): void {
    if (!object) return;

    const shared = this.shared3DResources;
    const isShared = (resource: any) => !!resource && !!shared && (
      resource === shared.sphereGeometry || resource === shared.topMaterial ||
      resource === shared.bottomMaterial || resource === shared.lineMaterial
    );

    // Libère les buffers d'instances, sans toucher à la géométrie de base partagée
    if (object.isInstancedMesh) object.dispose();

    if (!isShared(object.geometry)) object.geometry?.dispose();

    const materials = Array.isArray(object.material) ? object.material : [object.material];
    materials.forEach((material: any) => {
      if (!material || isShared(material)) return;
      material.map?.dispose();
      material.dispose();
    });
  }

  /**
   * Écarte les trous dont la position est manifestement fausse.
   * Certains tirs portent des coordonnées à l'opposé du site : sans filtre, ils
   * étirent la scène sur des centaines de kilomètres et tout le reste devient
   * un point invisible.
   *
   * La comparaison se fait dans le référentiel du site, en unités de son EPSG.
   * Sur un système projeté ce sont des mètres ; sur un système géographique le
   * seuil n'est jamais atteint et le filtre reste simplement inactif.
   */
  private isHoleNearSite(hole: any): boolean {
    const siteX = this.site?.coordX;
    const siteY = this.site?.coordY;

    // Sans coordonnées de site, aucune référence : on ne filtre rien
    if (siteX == null || siteY == null) return true;

    const dx = hole.PositionPlannedXYZ.x - siteX;
    const dy = hole.PositionPlannedXYZ.y - siteY;

    return (dx * dx + dy * dy) <= CarteComponent.MAX_DISTANCE_FROM_SITE * CarteComponent.MAX_DISTANCE_FROM_SITE;
  }

  /** Rend la main au navigateur pour qu'il puisse peindre et traiter les entrées */
  private yieldToBrowser(): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, 0));
  }

  /**
   * Branche la scène Three.js sur Mapbox via un custom layer.
   * Appelé dès que les trous sont prêts, avant le décodage des terrains,
   * pour que la carte affiche quelque chose sans attendre.
   */
  private addHoles3DLayer(
    scene: any,
    camera: any,
    modelTransform: { translateX: number, translateY: number, translateZ: number, scale: number },
    terrainExaggeration: number,
    THREE: any
  ): void {
    if (!this.mapboxMap) return;

    const mapRef = this.mapboxMap;
    let renderer: any;

    const customLayer: mapboxgl.CustomLayerInterface = {
      id: this.holes3DLayerId,
      type: 'custom' as any,
      renderingMode: '3d',
      onAdd(_map: any, gl: WebGLRenderingContext) {
        renderer = new THREE.WebGLRenderer({ canvas: mapRef.getCanvas(), context: gl, antialias: true });
        renderer.autoClear = false;
        // Forcer le re-upload des textures dans le contexte GL de Mapbox
        scene.traverse((child: any) => {
          if (child.isMesh && child.material?.map) {
            child.material.map.needsUpdate = true;
          }
        });
      },
      render(_gl: WebGLRenderingContext, matrix: number[]) {
        const m = new THREE.Matrix4().fromArray(matrix);
        const l = new THREE.Matrix4()
          .makeTranslation(modelTransform.translateX, modelTransform.translateY, modelTransform.translateZ * terrainExaggeration)
          .scale(new THREE.Vector3(modelTransform.scale, -modelTransform.scale, modelTransform.scale * terrainExaggeration));
        camera.projectionMatrix = m.multiply(l);
        renderer.resetState();
        renderer.render(scene, camera);
        mapRef.triggerRepaint();
      }
    };

    this.mapboxMap.addLayer(customLayer);
    this.mapboxMap.triggerRepaint();
  }

  /**
   * Télécharge en une requête les terrains encore absents du cache.
   * Extrait de display3DHoles pour lancer le réseau avant la construction de la
   * géométrie des trous au lieu d'attendre qu'elle soit finie.
   */
  private async fetchMissingTerrains(blastIds: number[]): Promise<void> {
    const uncachedTerrainIds = blastIds.filter(id => !this.allBlastTerrainCache.has(id));
    if (uncachedTerrainIds.length === 0) return;

    // Les ids passent en query string : on découpe pour rester loin de la limite
    // de longueur d'URL, tout en gardant très peu de requêtes.
    const CHUNK_SIZE = 200;
    const chunks: number[][] = [];
    for (let i = 0; i < uncachedTerrainIds.length; i += CHUNK_SIZE) {
      chunks.push(uncachedTerrainIds.slice(i, i + CHUNK_SIZE));
    }

    const containers = await Promise.all(
      chunks.map(chunk =>
        firstValueFrom(this.http.getTerrainsBinary(chunk)).catch(() => null)
      )
    );

    // Pas de terrain disponible : la 3D s'affiche sans, comme avant
    containers.forEach(container => {
      if (container && container.byteLength > 0) {
        this.unpackTerrains(container);
      }
    });
  }

  /**
   * Découpe le conteneur binaire renvoyé par Blasts/terrains et remplit le cache.
   * Format, répété pour chaque terrain : id du tir (int32 LE), longueur (int32 LE), octets.
   */
  private unpackTerrains(container: ArrayBuffer): void {
    const view = new DataView(container);
    const HEADER_SIZE = 8;
    let offset = 0;

    while (offset + HEADER_SIZE <= container.byteLength) {
      const blastId = view.getInt32(offset, true);
      const length = view.getInt32(offset + 4, true);
      offset += HEADER_SIZE;

      // Conteneur tronqué : on garde ce qui a pu être lu plutôt que de tout perdre
      if (length <= 0 || offset + length > container.byteLength) break;

      this.allBlastTerrainCache.set(blastId, container.slice(offset, offset + length));
      offset += length;
    }
  }

  private cleanup3DHoles(): void {
    if (this.mapboxMap) {
      try {
        if (this.mapboxMap.getLayer(this.holes3DLayerId)) {
          this.mapboxMap.removeLayer(this.holes3DLayerId);
        }
      } catch (e) {}
    }

    // Chaque reconstruction crée une scène neuve. Sans libération explicite, les
    // géométries, matériaux et textures de la précédente restent en mémoire GPU.
    if (this.holes3DScene) {
      const disposed = new Set<any>();
      this.holes3DScene.traverse((child: any) => {
        // InstancedMesh porte en plus ses buffers d'instances
        if (child.isInstancedMesh) child.dispose();
        if (child.geometry && !disposed.has(child.geometry)) {
          disposed.add(child.geometry);
          child.geometry.dispose();
        }
        const materials = Array.isArray(child.material) ? child.material : [child.material];
        materials.forEach((material: any) => {
          if (!material || disposed.has(material)) return;
          disposed.add(material);
          material.map?.dispose();
          material.dispose();
        });
      });
      this.holes3DScene = null;
    }

    // Le repère et les ressources partagées ne valent que pour la scène détruite
    this.ref3D = null;
    this.shared3DResources = null;
    this.terrain3DGroups.clear();
    this.holes3DMeshes.clear();
    this.terrain3DMeshes.clear();
    this.lastDisplayed3DKey = '';
  }

  private terrainMeshLayerId = 'laz-terrain-mesh';
  private threeModule: any = null;

  async loadCachedLazTerrain(): Promise<boolean> {
    if (!this.site?.siteId || !this.mapboxMap) return false;

    // Levé avant la requête : le téléchargement du terrain est la phase pendant
    // laquelle l'écran restait noir sans aucune indication.
    this.siteTerrainLoading.set(true);
    this.cdr.detectChanges();

    // Charger le proto terrain depuis le backend
    let cached: Uint8Array | null = null;
    try {
      const backendData = await firstValueFrom(this.http.getSiteTerrainBinary(this.site.siteId));
      if (backendData && backendData.byteLength > 0) {
        cached = new Uint8Array(backendData);
        console.log('[LAZ] Loaded terrain from backend');
      }
    } catch (e) {
      // Pas de terrain sur le backend
    }
    if (!cached) {
      this.siteTerrainLoading.set(false);
      this.cdr.detectChanges();
      return false;
    }

    console.log('[LAZ] Loading terrain from cache...');
    this.lazIsLoading.set(true);
    this.lazLoadingProgress.set(50);
    this.lazFileName.set('Cached terrain');
    this.cdr.detectChanges();

    try {
      const siteEpsg = this.site?.epsg ? 'EPSG:' + this.site.epsg : null;
      const terrainData = await this.terrainLoaderService.loadTerrainFromBinary(cached.buffer as ArrayBuffer);

      if (terrainData.terrains) {
        const offset = terrainData.offset || { x: 0, y: 0, z: 0 };
        let centerLng: number, centerLat: number;
        if (siteEpsg) {
          const wgs84 = proj4(siteEpsg, 'EPSG:4326', [offset.x, offset.y]);
          centerLng = wgs84[0];
          centerLat = wgs84[1];
        } else {
          centerLng = offset.x;
          centerLat = offset.y;
        }

        // Aucun calque à masquer : le fond neutre est déjà celui du style, et
        // tout masquer effacerait les trous et terrains blast déjà en place.
        await this.addTerrainMeshToMapbox(terrainData, centerLng, centerLat, offset.z);
      }

      this.lazLoadingProgress.set(100);
      this.lazIsLoading.set(false);
      this.siteTerrainLoading.set(false);
      this.cdr.detectChanges();
      return true;
    } catch (err) {
      console.warn('[LAZ] Failed to load cached terrain:', err);
      this.lazIsLoading.set(false);
      this.siteTerrainLoading.set(false);
      this.cdr.detectChanges();
      return false;
    }
  }

  private async addTerrainMeshToMapbox(
    terrainData: any,
    centerLng: number,
    centerLat: number,
    centerAlt: number
  ): Promise<void> {
    if (!this.mapboxMap) return;

    if (!this.threeModule) this.threeModule = await import('three');
    const THREE = this.threeModule;

    // Cleanup previous
    this.siteTerrainMeshes = [];
    try { if (this.mapboxMap.getLayer(this.terrainMeshLayerId)) this.mapboxMap.removeLayer(this.terrainMeshLayerId); } catch (e) {}

    const offset = terrainData.offset || { x: 0, y: 0, z: 0 };
    const modelAsMercator = mapboxgl.MercatorCoordinate.fromLngLat([centerLng, centerLat], centerAlt);
    const meterScale = modelAsMercator.meterInMercatorCoordinateUnits();
    const terrainExaggeration = 1.8;

    const modelTransform = {
      translateX: modelAsMercator.x,
      translateY: modelAsMercator.y,
      translateZ: modelAsMercator.z,
      scale: meterScale
    };

    // Récupérer le mesh Three.js depuis le TerrainLoaderService
    const terrainGroup = terrainData.terrains;
    const scene = new THREE.Scene();

    // Repositionner les meshes et forcer le material opaque avec vertex colors
    terrainGroup.traverse((child: any) => {
      if (child.isMesh) {
        const positions = child.geometry.attributes.position;
        for (let i = 0; i < positions.count; i++) {
          positions.setXYZ(
            i,
            positions.getX(i) - offset.x,
            positions.getY(i) - offset.y,
            positions.getZ(i) - offset.z
          );
        }
        positions.needsUpdate = true;
        child.geometry.computeVertexNormals();

        child.material = new THREE.MeshBasicMaterial({
          vertexColors: true,
          side: THREE.DoubleSide,
          transparent: true,
          opacity: this.terrainOpacity()
        });
        this.siteTerrainMeshes.push(child);
      }
    });

    scene.add(terrainGroup);

    const camera = new THREE.Camera();
    const mapRef = this.mapboxMap;

    let renderer: any;

    const customLayer: mapboxgl.CustomLayerInterface = {
      id: this.terrainMeshLayerId,
      type: 'custom' as any,
      renderingMode: '3d',

      onAdd(_map: any, gl: WebGLRenderingContext) {
        renderer = new THREE.WebGLRenderer({
          canvas: mapRef.getCanvas(),
          context: gl,
          antialias: true
        });
        renderer.autoClear = false;
      },

      render(_gl: WebGLRenderingContext, matrix: number[]) {
        const m = new THREE.Matrix4().fromArray(matrix);
        const l = new THREE.Matrix4()
          .makeTranslation(
            modelTransform.translateX,
            modelTransform.translateY,
            modelTransform.translateZ * terrainExaggeration
          )
          .scale(
            new THREE.Vector3(
              modelTransform.scale,
              -modelTransform.scale,
              modelTransform.scale * terrainExaggeration
            )
          );

        camera.projectionMatrix = m.multiply(l);
        renderer.resetState();
        renderer.render(scene, camera);
        mapRef.triggerRepaint();
      }
    };

    this.mapboxMap.addLayer(customLayer);

    // S'assurer que le mesh est au-dessus du fond bleu
    try { this.mapboxMap.moveLayer(this.terrainMeshLayerId); } catch (e) {}
  }

  private cleanupPointCloudLayer(): void {
    if (this.mapboxMap) {
      try {
        if (this.mapboxMap.getLayer(this.pointCloudLayerId)) {
          this.mapboxMap.removeLayer(this.pointCloudLayerId);
        }
      } catch (e) { /* layer already removed */ }
    }

    // Retirer les calques propres au nuage de points. Il n'y a plus de fond de
    // carte ni de terrain Mapbox à restaurer : la vue 3D n'en charge aucun.
    if (this.mapboxMap) {
      try {
        if (this.mapboxMap.getLayer('point-cloud-bg')) this.mapboxMap.removeLayer('point-cloud-bg');
        if (this.mapboxMap.getLayer('point-cloud-mask')) this.mapboxMap.removeLayer('point-cloud-mask');
        if (this.mapboxMap.getSource('point-cloud-mask-src')) this.mapboxMap.removeSource('point-cloud-mask-src');
      } catch (e) {}
    }

    // Libérer la géométrie/matériau Three.js (mais PAS le renderer — il appartient à Mapbox)
    if (this.threeScene) {
      this.threeScene.traverse((object: any) => {
        if (object.geometry) object.geometry.dispose();
        if (object.material) object.material.dispose();
      });
    }

    this.threeRenderer = null;
    this.threeScene = null;
    this.threeCamera = null;
    this.pointCloudGeometry = null;
    this.isPointCloudMode = false;
  }

  onZoom() {
    this.map.getView().on('change:resolution', (event: ObjectEvent) => {
      
      if (event.oldValue == null) return;

      const currentResolution = this.map.getView().getResolution();
      
      if (currentResolution < ZOOM_THRESHOLD) {
        this.handleZoomIn();
      } else {
        this.holesAreShown = false;
        this.inZoom = false;
        this.updateHoleVisibility(); // Cacher les holes quand on dézoom
      }
    });
  }
    private handleZoomIn() {
    if (!this.holesAreShown && this.holeToggle) {
      this.holesAreShown = true;
      this.inZoom = true;
 
      return;
    }
    if (this.holesAreShown && this.holeToggle) {
      this.inZoom = true;
      return;
    }
    this.holesAreShown = false;
    this.inZoom = true;
    this.updateHoleVisibility(); // Cacher les holes
  }


  onHover(){
    let selected = null;
    let tooltip = document.getElementById('map-tooltip');
    
    // Créer l'élément tooltip s'il n'existe pas
    if (!tooltip) {
      tooltip = document.createElement('div');
      tooltip.id = 'map-tooltip';
      tooltip.style.position = 'absolute';
      tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
      tooltip.style.color = 'white';
      tooltip.style.padding = '5px 8px';
      tooltip.style.borderRadius = '4px';
      tooltip.style.fontSize = '12px';
      tooltip.style.pointerEvents = 'none';
      tooltip.style.zIndex = '1000';
      tooltip.style.display = 'none';
      tooltip.style.whiteSpace = 'pre-line';
      tooltip.style.maxWidth = '200px';
      document.body.appendChild(tooltip);
    }
    
    this.map.on('pointermove', (evt) => {
      if (selected !== null) {
        // Ne pas réinitialiser le style des équipements (géré par la timeline)
        if (!selected.get('equipmentType')) {
          const savedStyle = selected.get('_savedStyle');
          selected.setStyle(savedStyle !== undefined ? savedStyle : undefined);
          selected.unset('_savedStyle');
        }
        selected = null;
      }

      // Cacher le tooltip par défaut
      tooltip.style.display = 'none';
      if (this.isMouseInPopup) {
        return;
      }

      const pixel = this.map.getEventPixel(evt.originalEvent);
      const hit = this.map.hasFeatureAtPixel(pixel);
      this.map.getTargetElement().style.cursor = hit ? 'pointer' : '';

      let feature = this.map.forEachFeatureAtPixel(evt.pixel, (feature) => {
        selected = feature;
        if (selected instanceof Feature) {
          selected.set('_savedStyle', selected.getStyle(), true);
        }
        return feature;
      });
  
      if (feature) {
        let tooltipText = '';
        
        if(feature.get(FEATURE_NAME) == FEATURE_TYPE.blast_polygone){
          const fillColor = feature.get(MapConstants.HOVER_FILL_COLOR);
          const style = CartStyleUtile.polygoneStyleHover(fillColor);
          selected.setStyle(style);
          feature = selected;
          
          // Obtenir le nom du blast et sa date prévisionnelle
          const tirId = feature.get(MapConstants.TIR_ID)?.value;
          const blast = this.listeTirs()?.find(tir => tir.tirId === tirId);
          let blastTooltip = blast?.nom || 'Blast';
          
          // Ajouter la date prévisionnelle si disponible
          if (blast?.dateTirPrevisionnelle) {
            const datePrevisionnelle = new Date(blast.dateTirPrevisionnelle);
            const datePrevStr = this.formatDateToDDMMYYYY(datePrevisionnelle);
            blastTooltip += `\n${datePrevStr}`;
          }
          
          tooltipText = blastTooltip;
        }
        
        if(feature.get(FEATURE_NAME) == FEATURE_TYPE.hole){
          const style = CartStyleUtile.holeStyleHover();
          selected.setStyle(style);

          // Obtenir le nom du hole
          const hole = feature.get(MapConstants.HOLE_OBJECT);
          tooltipText = hole?.name || 'Hole';
        }

        if(feature.get(FEATURE_NAME) == MapConstants.FEATURE_TYPE.zone_of_interest){
          const zoiData = feature.get(MapConstants.ZOI_DATA);
          const style = CartStyleUtile.zoiStyleHover(zoiData?.name);
          selected.setStyle(style);
          tooltipText = zoiData?.name || 'Zone of Interest';
        }
        
        // Vérifier si c'est un segment de route d'équipement
        if(feature.get('isVisualSegment')){
          // Récupérer les données du segment
          const equipmentId = feature.get('equipmentId');
          const startTime = feature.get('startTime');
          const endTime = feature.get('endTime');
          const parentRouteId = feature.get('parentRouteId');

          // Trouver la route parente pour obtenir equipmentName et tirId
          let equipmentName = `Equipment ${equipmentId}`;
          let tirId: number | undefined;

          if (this.equipmentLayerManager) {
            const routeLayer = this.equipmentLayerManager.getRouteLayer();
            const routes = routeLayer.getRoutes();
            const parentRoute = routes.find(r => {
              const routeId = r.equipmentId + '_' + r.dayKey + '_' + r.startTime.getTime();
              return routeId === parentRouteId;
            });

            if (parentRoute) {
              equipmentName = parentRoute.equipmentName;
              tirId = parentRoute.tirId;
            }
          }

          // Formater la date
          const routeDate = startTime ? this.formatDateToDDMMYYYY(new Date(startTime)) : '';

          // Formater les heures
          const formatTime = (date: Date): string => {
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');
            return `${hours}:${minutes}`;
          };

          const startTimeStr = startTime ? formatTime(new Date(startTime)) : '';
          const endTimeStr = endTime ? formatTime(new Date(endTime)) : '';

          // Construire le tooltip
          let routeTooltipLines: string[] = [];
          routeTooltipLines.push(equipmentName);

          if (routeDate) {
            routeTooltipLines.push(routeDate);
          }

          if (startTimeStr && endTimeStr) {
            routeTooltipLines.push(`${startTimeStr} - ${endTimeStr}`);
          }

          // Ajouter le nom du blast si assigné
          if (tirId) {
            const blast = this.listeTirs()?.find(tir => tir.tirId === tirId);
            if (blast?.nom) {
              routeTooltipLines.push(`Blast: ${blast.nom}`);
            }
          }

          tooltipText = routeTooltipLines.join('\n');
        }

        // Vérifier si c'est un équipement
        if(feature.get('equipmentType')){
          const equipment = feature.get('equipment');
          let baseTooltip = equipment?.displayName || equipment?.name || 'Equipment';
          
          // Obtenir la date de position de l'équipement
          const positionData = feature.get('positionData');
          let positionDateStr = '';
          
          if (positionData && positionData.date) {
            const positionDate = new Date(positionData.date);
            positionDateStr = this.formatDateToDDMMYYYY(positionDate);
          }
          
          // Vérifier si l'équipement est assigné à un shift (utiliser la même logique que checkEquipmentAssignment)
          if (equipment && positionData && this.equipmentLayerManager) {
            const shifts = this.equipmentLayerManager.getShifts();
            const positionDate = new Date(positionData.date);
            const equipmentId = positionData.equipmentExternalId;
            
            // Chercher le shift qui correspond à cette position d'équipement
            const matchingShift = shifts.find(shift => {
              if (shift.isDeleted || !shift.equipementsIds) return false;
              
              // Vérifier si l'équipement est dans ce shift
              const equipmentIds = shift.equipementsIds.split(';').map(id => parseInt(id.trim(), 10));
              const isEquipmentInShift = equipmentIds.includes(equipmentId);
              
              if (!isEquipmentInShift) return false;
              
              // Vérifier si l'heure de position correspond au shift
              const shiftDate = new Date(shift.date);
              
              if (shift.time === ShiftEnum.NightToMorning) {
                // Pour les shifts de nuit : 
                // - Les positions 0h-6h du jour J appartiennent au shift de nuit du jour J-1
                // - Les positions 22h-23h du jour J appartiennent au shift de nuit du jour J
                const positionHour = positionDate.getHours();
                const positionDateOnly = new Date(positionDate.getFullYear(), positionDate.getMonth(), positionDate.getDate());
                const shiftDateOnly = new Date(shiftDate.getFullYear(), shiftDate.getMonth(), shiftDate.getDate());
                const dayBeforeShift = new Date(shiftDateOnly.getTime() - 24 * 60 * 60 * 1000);
                
                // Plage 1: Soir du jour J (22h à 23h59) - même date que le shift
                if (positionHour >= 22 && positionHour <= 23) {
                  return positionDateOnly.getTime() === shiftDateOnly.getTime();
                }
                
                // Plage 2: Matin du jour J (0h à 5h59) - appartient au shift de la veille (J-1)
                if (positionHour >= 0 && positionHour < 6) {
                  const dayAfterShift = new Date(shiftDateOnly.getTime() + 24 * 60 * 60 * 1000);
                  return positionDateOnly.getTime() === dayAfterShift.getTime();
                }
                
                return false;
              } else {
                // Pour les autres shifts
                const timeRange = ShiftUtils.calculateShiftTimeRange(shiftDate, shift.time);
                return positionDate >= timeRange.startDate && positionDate <= timeRange.endDate;
              }
            });
            
            if (matchingShift) {
              // Si assigné : afficher nom + date du shift + nom du shift
              const shiftDate = new Date(matchingShift.date);
              
              // Pour les shifts de nuit (22h-6h), afficher la date +1 car le shift couvre deux jours
              let displayDate = new Date(shiftDate);
              if (matchingShift.time === ShiftEnum.NightToMorning) {
                displayDate.setUTCDate(displayDate.getUTCDate() + 1);
              }
              
              const shiftDateStr = this.formatDateToDDMMYYYY(displayDate);
              const shiftName = ShiftUtils.formatShiftLabel(matchingShift.time);
              const translatedShiftName = this.translate.instant(shiftName);
              
              tooltipText = `${baseTooltip}\n ${shiftDateStr}\n ${translatedShiftName}`;
            } else {
              // Si non assigné : afficher nom + date de position
              tooltipText = positionDateStr ? `${baseTooltip}\n ${positionDateStr}` : baseTooltip;
            }
          } else {
            // Si pas d'equipmentLayerManager ou pas de données : afficher nom + date de position si disponible
            tooltipText = positionDateStr ? `${baseTooltip}\n ${positionDateStr}` : baseTooltip;
          }
        }
        
        // Afficher le tooltip si on a du texte
        if (tooltipText) {
          tooltip.textContent = tooltipText;
          tooltip.style.display = 'block';
          
          // Type guard: check if originalEvent has clientX/clientY
          const originalEvent = evt.originalEvent;
          if ('clientX' in originalEvent && 'clientY' in originalEvent) {
            tooltip.style.left = (originalEvent.clientX + 10) + 'px';
            tooltip.style.top = (originalEvent.clientY - 25) + 'px';
          }
        }
      }
    })
    }
  onClick() {
    if (this.enablePolygonePicking) {
      this.map.on('click', (evt) => {
          if (this.activeButton === 3) {
        return;
      }
        let features = this.map.getFeaturesAtPixel(evt.pixel);
        
        // Gestion du mode d'assignation d'équipement ou de route
        if (this.assignmentMode()) {
          if (features && features.length > 0) {
            // Chercher un polygone de blast pour l'assignation
            let polygonFeature = features.find(f => {
              return f.get(MapConstants.FEATURE_NAME) == MapConstants.FEATURE_TYPE.blast_polygone;
            });

            if (polygonFeature) {
              const tirId = polygonFeature.get(MapConstants.TIR_ID).value;

              // Si une route est sélectionnée pour assignation, l'assigner
              if (this.routeToAssignByClick()) {
                this.assignRouteToBlastById(this.routeToAssignByClick(), tirId);
                this.routeToAssignByClick.set(null); // Désélectionner après assignation
                return;
              }

              // Sinon, assigner l'équipement (comportement original)
              this.assignEquipmentToBlast(tirId);
              return;
            }
          }

          // Si pas de polygone trouvé et une route était sélectionnée, juste désélectionner
          if (this.routeToAssignByClick()) {
            this.routeToAssignByClick.set(null);
            return;
          }

          // Si pas de polygone trouvé, annuler le mode assignation
          this.cancelAssignmentMode();
          return;
        }

        // Gestion du mode d'assignation de route à un blast
        if (this.routeAssignmentMode) {
          if (features && features.length > 0) {
            // Chercher un polygone de blast pour l'assignation
            let polygonFeature = features.find(f => {
              return f.get(MapConstants.FEATURE_NAME) == MapConstants.FEATURE_TYPE.blast_polygone;
            });

            if (polygonFeature) {
              const tirId = polygonFeature.get(MapConstants.TIR_ID).value;
              this.assignRouteToBlast(tirId);
              return;
            }
          }

          // Si pas de polygone trouvé, annuler le mode assignation de route
          this.cancelRouteAssignmentMode();
          return;
        }
        
        if (features && features.length > 0 && !this.modalPolygoneTypeisVisible) {
          // Chercher d'abord les équipements
          let equipmentFeature = features.find(f => f.get(MapConstants.EQUIP_TYPE));
          if (equipmentFeature) {
            const positionData = equipmentFeature.get(MapConstants.POSITION_DATA);
            this.createPopupEquipment(evt.coordinate as Coordinate, positionData);
            return; // Priorité aux équipements
          }
          
          if (this.enableHoleInteraction) {
            let holeFeature = features.find(f => 
              f.get(MapConstants.FEATURE_NAME) == MapConstants.FEATURE_TYPE.hole
            );
            if (holeFeature) {
              const blastName = holeFeature.get(MapConstants.BLAST_NAME);
              const hole = holeFeature.get(MapConstants.HOLE_OBJECT);
              this.createPopupHole(evt.coordinate as Coordinate, hole, blastName);
              return; // Priorité aux holes
            }
          }
          
          // Enfin chercher les polygones
          let polygonFeature = features.find(f => {
            return f.get(MapConstants.FEATURE_NAME) == MapConstants.FEATURE_TYPE.blast_polygone;
          });
          if (polygonFeature && !this.showPolygonTypeModal) {
            const tirId = polygonFeature.get(MapConstants.TIR_ID).value;
            this.polygonIDToDelete = polygonFeature.get(MapConstants.POLYGONE_ID);
            this.selectedPolygonType = polygonFeature.get(MapConstants.POLYGONE_TYPE);
            this.selectedPolygonFeature = new Feature();
            this.selectedPolygonFeature.set(MapConstants.TIR_ID, tirId);
            this.selectedPolygonFeature.set(MapConstants.FEATURE_NAME, MapConstants.FEATURE_TYPE.blast_polygone);
            this.selectedPolygonFeature.setGeometry(polygonFeature.getGeometry() as Geometry);
            this.createPopupTir(evt.coordinate as Coordinate, tirId, evt.coordinate as Coordinate);
            return;
          }
        }
        
        this.closePopup();
      });
    }
  }

  private configureOnPan() {
  this.map.on('moveend', (evt) => {
      this.RefreshHoles(); 
  });
}

private RefreshHoles(): void {
  
  const viewExtent = this.map.getView().calculateExtent(this.map.getSize());
  const visibleBlasts = this.blastPolygoneLayer.findPolygoneInView(viewExtent);

  let blastIdsInView = [];
  for (var feature of visibleBlasts) {
    var blastId = feature.get(MapConstants.TIR_ID).value;
    if (!blastIdsInView.includes(blastId)) {
      blastIdsInView.push(blastId);
    }             
  }
  
  this.holeLayer.refreshHoles(blastIdsInView, this.holesAreShown, this.listeTirsSelectionnes, this.getVisibleHoleStatuses(), this.selectedHoleStatusFilter as HoleStatus, this.selectedHoleFeatureFilter);
  
  // Les statistiques des features seront calculées lors des changements de filtres
}
  setMouseCoordinates() {
    var coord = [0, 0];
    var epsg;
    let isDegre = true;
    var C1 = 'X', C2 = 'Y';
    if (null !== this.site.epsg && undefined !== this.site.epsg) {
      epsg = "EPSG:" + this.site.epsg;
      if (undefined !== this.site.epsg && '4326' !== this.site.epsg) {
        isDegre = false;
      }
    }
    else {
      epsg = "EPSG:4326";
      isDegre = true;
    }

    if (isDegre) {
      C1 = 'G', C2 = 'L';
    }

    const element = document.getElementById('mouse-position');

    if (element) {
      element.innerHTML =
        epsg
        + '<br/>' + C1 + ': ' + '0'
        + '<br/>' + C2 + ': ' + '0';
    }

    this.map.on('pointermove', function (evt) {
    coord = evt.coordinate;
    coord = transform(coord, MapConstants.EPSG_REFERENCE_OL, epsg);
    document.getElementById('mouse-position').innerHTML = `
    <span class="mouse-pos-text">
      ${epsg}<br/>${C1}: ${(isDegre ? coord[0].toFixed(4) : coord[0].toFixed(0))}<br/>${C2}: ${(isDegre ? coord[1].toFixed(4) : coord[1].toFixed(0))}
    </span>`;
});
  }
  

  public onDeletePolygonClick() {
    if (this.modalConfirmDeletePolygon) {
      this.modalConfirmDeletePolygon.show();
    }
  }


  public confirmDeletePolygon() {
    if (this.polygonIDToDelete) {
      this.deleteBlastPolygon(this.polygonIDToDelete);
      this.closePopup();
    }
    if (this.modalConfirmDeletePolygon) {
      this.modalConfirmDeletePolygon.hide();
    }
  }


  public cancelDeletePolygon() {
    if (this.modalConfirmDeletePolygon) {
      this.modalConfirmDeletePolygon.hide();
    }
  }
  createPopupTir(coordinates: Coordinate, idTir: number, coordinatesPanTo: Coordinate, shouldPan = true) {
    if (this.modalValidationPrePolygoneisVisible) {
      return;
    }
    
    this.closePopup();
    this.holePopup.set(null);
    this.popupHoleActive.set(false);
    this.popupOuverte.next(idTir);

    if (shouldPan) {
      var zoom = this.view.getZoom();
      if (this.site.epsg != null && this.site.epsg != undefined && this.site.epsg != '') {
        let coordModif: number[] = transform(coordinatesPanTo, MapConstants.EPSG_REFERENCE_OL, 'EPSG:' + this.site.epsg);
        this.panTo({ coord: coordModif, zoom: zoom });
      }
    }

    this.popupTirActive.set(true);
    this.tirPopup.set(this.listeTirs()?.find(element => element.tirId == idTir) ?? null);
    const kpiConfig: { nom: string, valeur: string, unite: string }[] = [];
    this.putValKPIPopup();
    if (this.site.configurationKPI != "" && this.listeKPITirs?.length > 0) {
      this.configSite = JSON.parse(this.site.configurationKPI);
      const currentTirPopup = this.tirPopup();
      if (currentTirPopup) {
        for (let i = 0; i < 4; i++) {
          if (this.configSite[i] != null) {
            var valeur = this.listeKPITirs.find(element => element.referentielDonneeAnalyseId === this.configSite[i] && element.tirId === currentTirPopup.tirId);
            if (valeur != null) {
              const kpiDef = this.listeKPIActifs?.find(element => element.referentielDonneeAnalyseId === this.configSite[i]);
              if (kpiDef) {
                kpiConfig[i] = {
                  nom: kpiDef.nom,
                  valeur: valeur.valeur,
                  unite: valeur.unite ?? ""
                };
              }
            }
          }
        }
      }
    }
    this.kpiConfiguration.set(kpiConfig);
    this.popup.setPosition(coordinates);
  }

  //crée la popup pour hole
  createPopupHole(coordinates: Coordinate, hole: HoleDTO, blastName: string) {
    if (this.modalValidationPrePolygoneisVisible) {
      return;
    }

    this.holeService.GetHoleDetail(hole.publicGuid).then((holeDetails) => {
      this.holePopupDetails.set(holeDetails);
      this.blastsNamePopup.set(blastName);
      this.tirPopup.set(null);
      this.popupTirActive.set(false);
      var zoom = this.view.getZoom();
      let coordModif: number[] = transform(coordinates, MapConstants.EPSG_REFERENCE_OL, 'EPSG:' + this.site.epsg);
      this.panTo({ coord: coordModif, zoom: zoom });
      this.popupHoleActive.set(true);
  
      this.holePopup.set(hole);
  
      this.popup.setPosition(coordinates);
    });
  }

  closePopup() {
    // document.getElementById('popup-closer').blur();
    if (this.popup) {
      this.popup.setPosition(undefined);
    }
    this.popupTirActive.set(false);
    this.popupHoleActive.set(false);
    const currentTir = this.tirPopup();
    this.popupFermee.next(Number((currentTir !== null && currentTir != undefined && currentTir.tirId != null) ? currentTir.tirId : undefined));
    this.focusedEquipment.set(undefined);
    if (this.popupEquipmentActive()) {
      this.popupEquipmentActive.set(false);
    }
  }

  putValKPIPopup() {
    this.valKPITir.set({ valeur: "", unite: "" });
    const currentTir = this.tirPopup();
    if (this.kpiSelectionne !== null && this.kpiSelectionne !== undefined && currentTir != undefined && this.valKPISelectionne?.length > 0) {
      var valSelection = this.valKPISelectionne.find(e => e.idTir === currentTir.tirId);
      if (valSelection != undefined) {
        this.valKPITir.set({
          valeur: valSelection.valeur,
          unite: valSelection.unite
        });
      }
    }
  }

  //bouger la carte vers les coordonnées du site
  panTo(val: any) {
    if (null != this.site.epsg) {
      const tab = val['coord'];
      const coord = transform(tab, 'EPSG:' + this.site.epsg, MapConstants.EPSG_REFERENCE_OL);
      this.view.animate({
        zoom: val['zoom'],
        center: coord,
      });
    }
    else {
      //center in France if no coordinate ;)
      this.view.animate({
        zoom: val['zoom'],
        center: fromLonLat([4.7778, 43.6080]),
      });
    }
  }

  onChangeSite() {
    if (this.tirPopup != undefined)
      this.closePopup();
    if (this.showPopupForm()) {
      this.closePopupForm();
    }
    this.selectedEquipments.set([]);
    if (this.bottomActiveButoon === 3) {
      this.bottomActiveButoon = 0;
    }
    
    if (this.site.configurationKPI != "") {
      this.configSite = JSON.parse(this.site.configurationKPI);
      this.defaultKPI = this.configSite[0];
    }
    this.kpiDataLoaded = false;
    this.kpiSelectionne = null;
    this.selectedKPI = null;
    forkJoin([this.http.get<Tir[]>('Sites/' + this.utilService.currentSite().siteId + '/Blasts'),
    this.http.get<ControlPoint[]>('Sites/' + this.site.siteId + '/ControlPoints?transformCoord=false'),
    this.kpiService.getSiteActiveAnalysisEntry(this.utilService.currentSite().siteId),
    this.http.get<string>('Sites/proj4/' + this.site.epsg),
    this.http.get<string>('Sites/proj4/' + MapConstants.EPSG_REFERENCE_OL),
    ])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(resultat => {
        this.listeTirs.set(resultat[0]);
        this.listeKPIActifs = resultat[2];
        this.proj4_site = resultat[3];

        this.blastPolygoneLayer.setBlastsData(this.listeTirs());
        
        if(null !== this.equipmentLayerManager && undefined !== this.equipmentLayerManager){
          this.equipments = this.equipmentLayerManager.getEquipments();

          this.equipments = this.equipments?.map(equipment => ({
            ...equipment,
            displayName: EquipmentUtils.getEquipmentTypeFromEquipment(equipment) + " - " + EquipmentUtils.formatEquipmentDisplayName(equipment)
          }));
        }

        this.registerProjString(this.proj4_site);

        this.setMouseCoordinates();
        this.panTo({ coord: [this.site.coordX, this.site.coordY], zoom: 15 });

        this.mapLayersControler.ChangeSite(this.site);
        this.blastPolygoneLayer.changeSite(this.site.siteId);
        this.sitePolygonLayer.changeSite(this.site.siteId, Number(this.site.epsg))
          .then(polygones => {
            this.dxfLayers = polygones;
            this.cdr.detectChanges();
          })
          .catch(() => { this.dxfLayers = []; });
        this.zoneOfInterestLayer.changeSite(this.site.siteId);
        this.controlPointLayer.setControlPoints(resultat[1].filter(cp => cp.isActif));
        this.controlPointLayer.setVisible(this.controlPointsToggle);
        this.holeLayer.clear();
        this.refresh3DViewForSite();

      if ((this.listeTirs()?.length ?? 0) > 0) {
      let kpiTirs = this.http.get<DonneeAnalyseSiteDto[]>('Sites/' + this.site.siteId + '/AnalysisDataValues');
      kpiTirs.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(resultat => {
        this.listeKPITirs = resultat;
        
        this.kpiDataLoaded = true;
        this.setDefaultKPI();
        
        if (this.kpiSelectionne !== null && this.kpiSelectionne !== undefined && this.listeKPITirs !== undefined)
          this.getValeurKPITirs();
      });
    } else {
      this.kpiDataLoaded = true;
      this.setDefaultKPI();
    }

    if (this.blastIdToZoom) {
        setTimeout(() => {
          this.zoomToBlast(this.blastIdToZoom);
        }, 1000);
      }
  });

      
  }
private setDefaultKPI(): void {
  if (this.defaultKPI && this.listeKPIActifs && this.kpiDataLoaded) {
    this.selectedKPI = this.listeKPIActifs.find(kpi => 
      kpi.referentielDonneeAnalyseId === this.defaultKPI
    );
    
    if (this.selectedKPI) {
    }
  }
  
  setTimeout(() => {
    this.updateKpiScaleGradient();
  }, 200);
}



  registerProjString(projString: string) {
    if (undefined !== projString && null !== projString && projString != "") {
      proj4.defs("EPSG:" + this.site.epsg, projString);
      register(proj4);
    }
  }

getTirChange(event: number[]) {
  this.listeTirsSelectionnes = event;
  
  if (this.kpiDataLoaded) {
    this.DisplayBlastPolygons(this.listeTirsSelectionnes);
  } else {
    const waitForKPIData = () => {
      if (this.kpiDataLoaded) {
        this.DisplayBlastPolygons(this.listeTirsSelectionnes);
      } else {
        setTimeout(waitForKPIData, 100);
      }
    };
    waitForKPIData();
  }
  
  this.holeLayer.setSelectedBlast(this.listeTirsSelectionnes);
  this.RefreshHoles();

  // Afficher les trous 3D en mode Mapbox terrain
  this.selectedBlastIdsSignal.set([...this.listeTirsSelectionnes]);
  this.clampTimelineCursor();
  if (this.isMapboxTerrainMode) {
    if (this.listeTirsSelectionnes.length > 0) {
      this.display3DHoles(this.listeTirsSelectionnes);
    } else {
      this.cleanup3DHoles();
    }
  }
}

  getTypeChange() {
    // Mettre à jour les types sélectionnés avant d'afficher les polygones
    this.listeTypesSelectionnes = this.cartSelectedTirsPolygoneEnum.map(x => this.convertPolygonEnumToNumber(x));
    this.DisplayBlastPolygons(this.listeTirsSelectionnes);
    this.holeLayer.setSelectedBlast(this.listeTirsSelectionnes);
  }
private DisplayBlastPolygons(blastIdToDisplay?: number[], blastIdToZoom?: number) {
  this.fonctionsService.loading_screen(true);
  if (blastIdToDisplay != null && blastIdToDisplay != undefined && blastIdToDisplay.length > 0) {
    // Charger TOUS les types de polygones (pas seulement ceux sélectionnés)
    // Using actual numerical values from PolygonType enum
    const allPolygonTypes = [
      0, // AutomaticFromHoles (AUTOMATIC)
      1, // DrillingContour (DRILLED)
      2, // MuckPile (MUCKPILE)
      3  // DangerZone (DANGER_ZONE)
    ];
    
    this.blastPolygoneLayer.displayPolygonsForBlast(blastIdToDisplay, allPolygonTypes)
      .finally(() => {
        // Après chargement de tous les types, filtrer selon la sélection actuelle
        this.blastPolygoneLayer.filterPolygonsByType(this.listeTypesSelectionnes);
        
        this.RefreshHoles();
        this.fonctionsService.loading_screen(false);
        
        if (this.selectedKPI && !this.kpiSelectionne) {
          setTimeout(() => {
            this.getSelectedKPI(this.selectedKPI);
          }, 500);
        }
      });
      
      if (blastIdToZoom)
      {
        this.zoomOnSelectedBlast(blastIdToZoom);
      }
  }
  else {
    this.blastPolygoneLayer.hideAll();
    this.holeLayer.setSelectedBlast([]); 
    this.fonctionsService.loading_screen(false);
  }
}

  getSelectedKPI(event) {
    if (event != null) {
      this.kpiSelectionne = this.listeKPIActifs.find(e => e.referentielDonneeAnalyseId === event.referentielDonneeAnalyseId);
      
      this.selectedKPI = this.kpiSelectionne;
      
      if (this.listeKPITirs !== undefined) {
        this.getValeurKPITirs();
      }
      
      setTimeout(() => {
        this.updateKpiScaleGradient();
      }, 100);
      
    } else {
      this.kpiSelectionne = null;
      
      this.selectedKPI = null;
      
      this.borneInf = 0;
      this.borneSup = 100;
      this.borneMoy = null;
      this.valKPITir.update(v => ({ ...v, unite: "" }));
      let kpiJaugeElement = document.getElementById('kpi-jauge');
      if (kpiJaugeElement) {
        kpiJaugeElement.hidden = true;
      }
      this.blastPolygoneLayer.resetPolygonsKPIs();
      
      setTimeout(() => {
        this.updateKpiScaleGradient();
      }, 100);
    }
  }


getCentrerTir(event: number) {
  const polygonCenter = this.blastPolygoneLayer.getPolygonCenter(event);
  
  if (polygonCenter) {
    this.centerOnPolygon(event);

    const onMoveEnd = () => {
      this.map.un('moveend', onMoveEnd);
      const coordinates = polygonCenter;
      const coordinatesPanTo = this.getCoordonneesDecaleesZoom(coordinates);
      if (!this.modalPolygoneTypeisVisible) {
        this.createPopupTir(coordinates, event, coordinatesPanTo, false);
      }
    };

    this.map.on('moveend', onMoveEnd);
  } else {
    const coordinates = this.map.getView().getCenter() as Coordinate;
    const coordinatesPanTo = [coordinates[0], coordinates[1]];
    const popupCoordinates = this.getCoordonneesDecaleesZoom(coordinates, false);
    if (!this.modalPolygoneTypeisVisible) {
      this.createPopupTir(popupCoordinates, event, coordinatesPanTo, false);
    }
  }
}

  private centerOnPolygon(tirId: number): void {    
    const center = this.blastPolygoneLayer.getPolygonCenter(tirId);    
    if (center) {
      this.map.getView().animate({
        center: center,
        duration: 500
      });
    } 
  }

  private zoomToBlast(blastId: number): void {
    this.DisplayBlastPolygons(this.listeTirsSelectionnes, blastId);
  }

  public zoomOnSelectedBlast(tirId: number): void {
    const center = this.blastPolygoneLayer.getPolygonCenter(tirId);
    if (center) {
      this.map.getView().animate({
        center: center,
        zoom: 19,
        duration: 2000
      });
    }
  }

  getColorPolygon(valeurKPI) {
  let min = this.kpiSelectionne.valeurMin; 
  let max = this.kpiSelectionne.valeurMax; 
  let nom = this.kpiSelectionne.valeurNominal; 

  if (valeurKPI != null) {
    if (nom != null) {
      this.borneMoy = nom;
      if (min != null && max == null) {
        this.borneInf = min;
        this.borneSup = nom;
        this.borneMoy = null;
        return this.getKpiColorFromValue(valeurKPI, min, nom);
      }
      else if (max != null && min == null) {
        this.borneInf = nom;
        this.borneSup = max;
        this.borneMoy = null;
        return this.getKpiColorFromValue(valeurKPI, nom, max);
      }
    }
    if (min != null && max != null) {
      this.borneInf = min;
      this.borneSup = max;
      this.borneMoy = null;
      let couleur = this.getKpiColorFromValue(valeurKPI, min, max);
      return couleur;
    }
    return MapConstants.COULEUR_VIOLET_EPC;
  }
  else return MapConstants.COULEUR_VIOLET_EPC;
}

  private getKpiColorFromValue(kpiValue: number, minVal?: number, maxVal?: number): string {
    const min = minVal !== undefined ? minVal : this.borneInf;
    const max = maxVal !== undefined ? maxVal : this.borneSup;
    
    if (min === undefined || max === undefined) {
      return MapConstants.COULEUR_VIOLET_EPC;
    }
    
    kpiValue = Math.min(Math.max(kpiValue, min), max);
    const ratio = (kpiValue - min) / (max - min);
    
    if (isNaN(ratio) || ratio < 0 || ratio > 1) {
      return MapConstants.COULEUR_VIOLET_EPC;
    }
    
    const startHue = 300; 
    const endHue = 0; 
    const saturation = 80; 
    const lightness = 50; 
    
    const h = startHue + (endHue - startHue) * ratio;
    
    // Return in the expected format: "hue,saturation%,lightness%"
    return `${h},${saturation}%,${lightness}%`;
  }

  getValeurKPITirs() {
    this.valKPISelectionne = [];
    var unite = "";
    var min = 10000000000;
    var max = 0;
    
    if (this.kpiJauge?.nativeElement?.hidden) {
    this.kpiJauge.nativeElement.hidden = false;
  } else {
    const kpiJaugeElement = document.getElementById('kpi-jauge');
    if (kpiJaugeElement?.hidden) {
      kpiJaugeElement.hidden = false;
    }
  }

    this.showValKPITir = false;
    const tirs = this.listeTirs() ?? [];
    for (let i = 0; i < tirs.length; i++) {
      const kpi = this.listeKPITirs.find(element => element.referentielDonneeAnalyseId === this.kpiSelectionne.referentielDonneeAnalyseId && element.tirId === tirs[i].tirId);
      this.showValKPITir = (kpi !== undefined && !isNaN(Number(kpi.valeur))) || this.showValKPITir;
      if (kpi != undefined && kpi.valeur != null && kpi.valeur != "") {
        if (kpi.unite == null)
          unite = "";
        else
          unite = kpi.unite;
          const val = +kpi.valeur;
          if (max < val) max = val;
          if (min > val) min = val;
        if (this.kpiSelectionne.valeurMin == null && this.kpiSelectionne.valeurMax == null && this.kpiSelectionne.valeurNominal == null) {
          this.valKPISelectionne[i] = {
            idTir: tirs[i].tirId,
            valeur: kpi.valeur,
            unite: unite,
            couleur: MapConstants.COULEUR_VIOLET_EPC
          };
          let val = +this.valKPISelectionne[i].valeur;
          if (max < val) max = val;
          if (min > val) min = val;
        }
        else {
          this.valKPISelectionne[i] = {
            idTir: tirs[i].tirId,
            valeur: kpi.valeur,
            unite: unite,
            couleur: this.getColorPolygon(kpi.valeur)
          };

        }
      } else {
        this.valKPISelectionne[i] = {
          idTir: tirs[i].tirId,
          valeur: "",
          unite: "",
          couleur: MapConstants.COULEUR_VIOLET_EPC
        };

      }
    }
    
    if (undefined !== this.kpiSelectionne && null != this.kpiSelectionne) {
      if (this.kpiSelectionne.valeurMin == null && this.kpiSelectionne.valeurMax == null && this.kpiSelectionne.valeurNominal == null) {
        this.kpiSelectionne.valeurMin = min;
        this.kpiSelectionne.valeurMax = max;
        this.blastPolygoneLayer.setBlastKpis(this.valKPISelectionne, min, max);
      } else {
        this.showValKPITir = true;
        this.blastPolygoneLayer.setBlastKpis(this.valKPISelectionne, this.kpiSelectionne.valeurMin, this.kpiSelectionne.valeurMax);
      }
      
      this.UpdateKpiColorScale();
    }
  
  this.putValKPIPopup();
  }

  private UpdateKpiColorScale() {
  if (this.kpiSelectionne) {
    this.borneInf = this.kpiSelectionne.valeurMin || 0;
    this.borneSup = this.kpiSelectionne.valeurMax || 0;
    this.borneMoy = this.kpiSelectionne.valeurNominal || null;

    if (this.listeKPITirs && this.listeKPITirs.length > 0) {
      const kpiWithUnit = this.listeKPITirs.find(kpi => 
        kpi.referentielDonneeAnalyseId === this.kpiSelectionne.referentielDonneeAnalyseId && 
        kpi.unite !== null && kpi.unite !== undefined && kpi.unite !== ""
      );
      
      if (kpiWithUnit) {
        this.valKPITir.update(v => ({ ...v, unite: kpiWithUnit.unite }));
      }
    }

    // Update gradient after KPI values are updated
    this.updateKpiScaleGradient();
  }
}

  private updateKpiScaleGradient() {
      const scaleElement = document.getElementById('scale');
        const startColor = { h: 300, s: 80, l: 50 };
        const endColor = { h: 0, s: 80, l: 50 }; 
        
        const stops = [];
        const numStops = 20; 
        
        for (let i = 0; i <= numStops; i++) {
          const ratio = i / numStops;
          const h = startColor.h + (endColor.h - startColor.h) * ratio;
          const color = `hsl(${h}, ${startColor.s}%, ${startColor.l}%)`;
          const position = (ratio * 100).toFixed(1);
          stops.push(`${color} ${position}%`);
        }
        
        const gradient = `linear-gradient(to right, ${stops.join(', ')})`;
        if(!scaleElement) {
          return;
        }
        scaleElement.style.background = gradient;
  }

  inverserReferentielOuvert() {
    this.referentielOuvert = !this.referentielOuvert;
  }

  getCoordonneesDecaleesZoom(coordonnees: Coordinate, ajout = true): Coordinate {
    let zoom = this.view.getZoom();
    let difference = 0;
    let coordX = coordonnees[0];
    let coordY = coordonnees[1];
    if (zoom < 16) {
      difference = 500;
    }
    else if (zoom < 19) {
      difference = 100;
    }
    else {
      difference = 20;
    }
    if (ajout) {
      coordX += difference;
      coordY += difference;
    } else {
      coordX -= difference;
      coordY -= difference;
    }
    return [coordX, coordY];
  }

  public setActiveButton(buttonId: number): void {
    this.map.getTargetElement().classList.remove('map-drawing');
    
    if (buttonId === this.activeButton) {
      this.activeButton = 1;
      this.enablePolygonePicking = true;
      this.enableHoleInteraction = true;
      this.rulerControlLayer.stop();
      this.closePolygonTypeModal();
    }
    else if (buttonId === 2) {
      this.enablePolygonePicking = false;
      this.enableHoleInteraction = false;
      this.rulerControlLayer.toggle(MEASURE_MODE.line);
      this.activeButton = buttonId;
      this.closePolygonTypeModal();
    }
    else if (buttonId === 3) {
      this.enableHoleInteraction = false;
      this.openPolygonTypeModal();
      this.closePopup();
      this.activeButton = buttonId;
    }
    else if (buttonId === 1) {
      this.enablePolygonePicking = true;
      this.enableHoleInteraction = true;
      this.selectedPolygonFeature = undefined;
      this.rulerControlLayer.stop();
      this.activeButton = buttonId;
      this.closePolygonTypeModal();
    }
  }

  public setActiveBottomButton(buttonId: number): void {
    if (buttonId === this.bottomActiveButoon) {
      this.bottomActiveButoon = 0;
      this.showPopupForm.set(false);
      this.equipmentLayerManager.clear();
      // Masquer le layer d'équipement quand on désactive le mode
      this.equipmentLayerManager.setEquipmentsVisible(false);
      // Désactiver le mode neutre des polygones
      this.blastPolygoneLayer.setNeutralColorsEnabled(false);
      // Réactiver le toggle des holes
      this.holeToggle = true;
      if (this.inZoom) {
        this.holesAreShown = true;
        this.RefreshHoles();
      }
    }
    else if (buttonId === 3) {
      this.enablePolygonePicking = false;
      this.togglePopupForm();
      this.bottomActiveButoon = buttonId;
      // Rendre le layer d'équipement visible quand on active le mode
      this.equipmentLayerManager.setEquipmentsVisible(true);
      this.getEquipementPosition();
      // Activer le mode neutre des polygones
      this.blastPolygoneLayer.setNeutralColorsEnabled(true);
      // Désactiver le toggle des holes
      this.holeToggle = false;
      this.holesAreShown = false;
      this.RefreshHoles();
    }
    else if (buttonId === 1) {
      this.bottomActiveButoon = buttonId;
      this.showPopupForm.set(false);
      this.equipmentLayerManager.clear();
      // Désactiver le mode neutre des polygones
      this.blastPolygoneLayer.setNeutralColorsEnabled(false);
      // Réactiver le toggle des holes
      this.holeToggle = true;
      if (this.inZoom) {
        this.holesAreShown = true;
      }
      setTimeout(() => {
        this.updateKpiScaleGradient();
      }, 200);
    }
    else{
      this.bottomActiveButoon = buttonId;
      this.showPopupForm.set(false);
      this.equipmentLayerManager.clear();
      // Désactiver le mode neutre des polygones
      this.blastPolygoneLayer.setNeutralColorsEnabled(false);
      // Réactiver le toggle des holes
      this.holeToggle = true;
      if (this.inZoom) {
        this.holesAreShown = true;
      }

      if (buttonId === 2) {
        setTimeout(() => {
          this.evaluateHolesModalOverflow();
        }, 50);
      }
    }
    
  }

  public toggleLegend() {
    this.showLegend = !this.showLegend;
  }


  protected closeModalPolygoneType() {
    this.modalPolygoneTypeisVisible = false;
  }


  protected openModalValidationPolygone() {
    this.closePopup();
    this.modalValidationPrePolygoneisVisible = true;
    this.closePolygonTypeModal();


  }
  protected closeModalValidationPolygone() {
    this.enableHoleInteraction = true;
    this.modalValidationPrePolygoneisVisible = false;
    this.rulerControlLayer.stop()
    this.closePolygonTypeModal();

  }


  protected savePolygone() {
  let blastIdToUse: number;
  
  if (this.preSelectedBlast) {
    blastIdToUse = this.preSelectedBlast.tirId;
  } else if (this.selectedBlastForPolygon) {
    blastIdToUse = this.selectedBlastForPolygon;
  } else {
    alert('Please select a blast');
    return;
  }

  this.closeModalValidationPolygone();
  this.setActiveButton(1);
  this.view.setZoom(17);
  this.fonctionsService.loading_screen(true);
  
   
  let tirContour: TirContour = new TirContour();
  tirContour.format = MapConstants.EPSG_REFERENCE_OL;
  tirContour.coordonnees = StaticUtils.doubleCoordinateArrayToString(this.polygonCoordinatesToSave);

  if (this.selectedTirsPolygoneEnum === TirsPolygoneEnum.AUTOMATIC) {
    tirContour.typePolygone = PolygonType.AutomaticFromHoles;
  } else if(this.selectedTirsPolygoneEnum === TirsPolygoneEnum.DRILLED) {
    tirContour.typePolygone = PolygonType.DrillingContour;
  } else if (this.selectedTirsPolygoneEnum === TirsPolygoneEnum.MUCKPILE) {
    tirContour.typePolygone = PolygonType.MuckPile;
  } else if (this.selectedTirsPolygoneEnum === TirsPolygoneEnum.DANGER_ZONE) {
    tirContour.typePolygone = PolygonType.DangerZone;
  }

  this.http.post('Blasts/' + blastIdToUse + '/BlastOutlines', tirContour).subscribe({
    next: () => {
      this.fonctionsService.launch_toast(true);

        if (!this.cartSelectedTirsPolygoneEnum.includes(this.selectedTirsPolygoneEnum)) {
          this.cartSelectedTirsPolygoneEnum.push(this.selectedTirsPolygoneEnum);
        }
      
      this.listeTypesSelectionnes = this.cartSelectedTirsPolygoneEnum.map(x => this.convertPolygonEnumToNumber(x));
      this.blastPolygoneLayer.clear(); 

      this.blastPolygoneLayer.displayPolygonsForBlast(this.listeTirsSelectionnes, this.listeTypesSelectionnes, true).then(() => {
        this.clearDrawnPolygon();
        this.rulerControlLayer.stop()
        this.fonctionsService.loading_screen(false);
      });
    },
    error: () => {
      this.fonctionsService.launch_toast(false);
      this.fonctionsService.loading_screen(false);
      this.clearDrawnPolygon();  
      this.rulerControlLayer.stop()

    }
  });

  this.selectedPolygonFeature = undefined;
  this.selectedBlastForPolygon = null;
  this.preSelectedBlast = null;
  this.polygonCoordinatesToSave = [];
}
  protected cartPolygoneTypeChange() {
    this.listeTypesSelectionnes = this.cartSelectedTirsPolygoneEnum.map(x => this.convertPolygonEnumToNumber(x));
    
    // Debug: afficher les valeurs converties
    console.log('Selected enum values:', this.cartSelectedTirsPolygoneEnum);
    console.log('Converted to numbers:', this.listeTypesSelectionnes);
    
    // Filtrer les polygones déjà chargés côté client (pas d'appel API)
    this.blastPolygoneLayer.filterPolygonsByType(this.listeTypesSelectionnes);
    
    // Rafraîchir les holes instantanément
    this.RefreshHoles();
    
    // Mettre à jour les KPI instantanément
    if (this.kpiSelectionne) {
      this.getValeurKPITirs();
    } else if (this.selectedKPI) {
      this.getSelectedKPI(this.selectedKPI);
    }
  }

  protected closeMenuRightClick() {
    this.menuVisible = false;
  }

  togglePopupForm(): void {
    this.closePopup();

    if (!this.equipments || this.equipments.length === 0) {
      if (this.equipmentLayerManager) {
        this.equipmentLayerManager.fetchEquipments(this.site.siteId);
        this.equipmentLayerManager.dataLoaded.subscribe(() => {
          this.equipments = this.equipmentLayerManager.getEquipments();
          this.equipments = this.equipments?.map(equipment => ({
            ...equipment,
            displayName: EquipmentUtils.getEquipmentTypeFromEquipment(equipment) + " - " + EquipmentUtils.formatEquipmentDisplayName(equipment)
          }));
          this.showPopupForm.set(true);
          if (!this.selectedEquipments() || this.selectedEquipments().length === 0) {
            this.selectedEquipments.set(structuredClone(this.equipments));
          }
        });
      }
    } else {
      this.showPopupForm.set(true);
      if (!this.selectedEquipments() || this.selectedEquipments().length === 0) {
        this.selectedEquipments.set(structuredClone(this.equipments));
      }
    }
  }

  

  closePopupForm(): void {
    this.showPopupForm.set(false);
    this.selectedDate.set(undefined);
    this.selectedDateRange.set([]);
    this.selectedShift.set(undefined);
    this.shouldLoadSavedPositions = false;
    this.equipmentLayerManager.shouldLoadSavedPositions = this.shouldLoadSavedPositions;
    this.equipmentLayerManager.clear();
    this.saveBooleanToLocalStorage('showPopupForm', this.showPopupForm());
  }

  formatShiftLabel(shift: ShiftEnum): string {
    return ShiftUtils.formatShiftLabel(shift);
  }

  getDateFormat(): string {
    return StaticUtils.getDatePickerDateFormat(this.translate.currentLang);
  }

  // Fonction utilitaire pour formater les dates en dd/mm/yyyy
  private formatDateToDDMMYYYY(date: Date): string {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  compareFunction(item1: Equipment, item2: Equipment) {
    return item1 && item2 ? item1.equipementId === item2.equipementId : item1 === item2;
  }

  private createPopupEquipment(coordinates: Coordinate, positionData: EquipmentPosition) {
    if (this.modalValidationPrePolygoneisVisible) {
      return;
    }
    
    this.closePopup();
    const equipment = this.equipments.find(eq => eq.externalId === positionData.equipmentExternalId);
    this.equipmentDisplayName = equipment ? equipment.displayName : 'Unknown';
    this.equipmentName = equipment ? equipment.name : 'Unknown';
    this.equipmentExternalId = positionData.equipmentExternalId;
    this.currentEquipmentPosition = positionData;

    let positionDate: Date = positionData.date instanceof Date
      ? positionData.date
      : new Date(positionData.date);

    const timeFormat = StaticUtils.getTimeFormat(this.translate.currentLang);
    
    // Formatage manuel de la date en dd/mm/yyyy
    const day = positionDate.getDate().toString().padStart(2, '0');
    const month = (positionDate.getMonth() + 1).toString().padStart(2, '0');
    const year = positionDate.getFullYear();
    this.formattedDate = `${day}/${month}/${year}`;
    
    this.formattedTime = positionDate.toLocaleTimeString(this.translate.currentLang, timeFormat);
    this.equipmentLatitude = positionData.latitude;
    this.equipmentLongitude = positionData.longitude;

    this.checkEquipmentAssignment(positionData);

    this.popup.setPosition(coordinates);
    this.popupEquipmentActive.set(true);
    this.focusedEquipment.set(equipment)

  }

  private saveBooleanToLocalStorage(key: string, value: boolean) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  private savePolygonToggles() {
    localStorage.setItem('cartSelectedTirsPolygoneEnum', JSON.stringify(this.cartSelectedTirsPolygoneEnum));
  }

  private loadPolygonToggles() {
    const saved = localStorage.getItem('cartSelectedTirsPolygoneEnum');
    if (saved) {
      this.cartSelectedTirsPolygoneEnum = JSON.parse(saved);
    } else {
      this.cartSelectedTirsPolygoneEnum = [TirsPolygoneEnum.DRILLED, TirsPolygoneEnum.AUTOMATIC];
      this.savePolygonToggles();
    }
  }

  getEquipementPosition() {
    this.missingDateField = false;
    this.missingDateRangeField = false;
    this.missingShiftField = false;
    this.missingEquipmentField = false;

    if (this.timeSelection() === 'dateRange') {
      if (!this.selectedDateRange() || this.selectedDateRange().length < 2) {
        this.missingDateRangeField = true;
      }
      if (!this.selectedEquipments() || this.selectedEquipments().length === 0){
        this.missingEquipmentField = true;
      }
    } else if (this.timeSelection() === 'shift') {
      if (!this.selectedDate()) {
        this.missingDateField = true;
      }
      if (this.selectedShift() == undefined || this.selectedShift() == null){
        this.missingShiftField = true;
      }
      if (!this.equipments || this.equipments.length === 0){
        this.missingEquipmentField = true;
      }
    }

    if (this.missingDateField || this.missingDateRangeField || this.missingShiftField || this.missingEquipmentField) {
      if (this.equipmentLayerManager.getFeaturesCount() > 0) {
        this.equipmentLayerManager.clear();
      }
      this.hasAppliedFilters.set(false);
      return;
    }

    // En mode shift : charger tous les équipements pour avoir la liste complète,
    // puis après chargement sélectionner ceux qui ont des positions.
    const equipmentsToLoad = this.timeSelection() === 'shift' && this.equipments && this.equipments.length > 0
      ? this.equipments
      : this.selectedEquipments();

    const params = {
      selectedEquipments: equipmentsToLoad,
      selectedDate: this.selectedDate(),
      selectedDateRange: this.selectedDateRange(),
      selectedShift: this.selectedShift(),
      timeSelection: this.timeSelection(),
    };

    this.equipmentLayerManager.getEquipmentPositions(params);
    this.equipmentLayerManager.shouldLoadSavedPositions = true;
    this.hasAppliedFilters.set(true);

    // Activer l'affichage des routes après une recherche explicite
    if (this.showEquipmentRoutes) {
      this.equipmentLayerManager.setRoutesVisible(true);
    }

    // Mettre à jour la plage du slider de temps et appliquer le filtre initial
    this.updateTimeSliderRange();

    // Appliquer automatiquement les effets de timeline dès le chargement
    this.equipmentLayerManager.dataLoaded.pipe(take(1)).subscribe(() => {
      // Sélectionner tous les équipements présents sur ce shift
      this.selectedEquipments.set([...this.equipmentsWithPositions()]);
      this.updateEquipmentVisibility();
      this.applyTimelineEffects();
    });
  }

  /**
   * Appelé quand la date ou le shift change - applique automatiquement les filtres
   */
  onDateOrShiftChange(): void {
    // Appliquer automatiquement si date et shift sont sélectionnés
    if (this.selectedDate() && this.selectedShift() !== null && this.selectedShift() !== undefined) {
      this.equipmentRouteService.getRoutesBySiteId(this.site.siteId).subscribe({
        next: (savedRoutes) => {
          this.equipmentLayerManager.setSavedRoutes(savedRoutes);
          this.getEquipementPosition();
        },
        error: () => {
          this.getEquipementPosition();
        }
      });
    }
  }

  /**
   * Vérifie si on peut naviguer vers le shift précédent
   */
  canNavigateToPreviousShift(): boolean {
    if (!this.selectedDate() || this.selectedShift() === null || this.selectedShift() === undefined) {
      return false;
    }
    // On peut toujours aller en arrière (shift précédent ou jour précédent)
    return true;
  }

  /**
   * Vérifie si on peut naviguer vers le shift suivant
   */
  canNavigateToNextShift(): boolean {
    if (!this.selectedDate() || this.selectedShift() === null || this.selectedShift() === undefined) {
      return false;
    }
    // Vérifier si on n'est pas déjà au dernier shift de la date d'aujourd'hui
    const isToday = this.isSameDay(this.selectedDate(), new Date());
    const lastShiftIndex = this.shifts.length - 1;
    return !(isToday && this.selectedShift() === this.shifts[lastShiftIndex]);
  }

  /**
   * Navigue vers le shift précédent
   */
  navigateToPreviousShift(): void {
    if (!this.canNavigateToPreviousShift()) {
      return;
    }

    const currentShiftIndex = this.shifts.indexOf(this.selectedShift());

    if (currentShiftIndex > 0) {
      // Passer au shift précédent du même jour
      this.selectedShift.set(this.shifts[currentShiftIndex - 1] as ShiftEnum);
    } else {
      // Premier shift du jour, passer au dernier shift du jour précédent
      const previousDay = new Date(this.selectedDate());
      previousDay.setDate(previousDay.getDate() - 1);
      this.selectedDate.set(previousDay);
      this.selectedShift.set(this.shifts[this.shifts.length - 1] as ShiftEnum);
    }

    this.onDateOrShiftChange();
  }

  /**
   * Navigue vers le shift suivant
   */
  navigateToNextShift(): void {
    if (!this.canNavigateToNextShift()) {
      return;
    }

    const currentShiftIndex = this.shifts.indexOf(this.selectedShift());
    const lastShiftIndex = this.shifts.length - 1;

    if (currentShiftIndex < lastShiftIndex) {
      // Passer au shift suivant du même jour
      this.selectedShift.set(this.shifts[currentShiftIndex + 1] as ShiftEnum);
    } else {
      // Dernier shift du jour, passer au premier shift du jour suivant
      const nextDay = new Date(this.selectedDate());
      nextDay.setDate(nextDay.getDate() + 1);

      // Ne pas dépasser aujourd'hui
      if (nextDay <= this.today) {
        this.selectedDate.set(nextDay);
        this.selectedShift.set(this.shifts[0] as ShiftEnum);
      }
    }

    this.onDateOrShiftChange();
  }

  /**
   * Vérifie si deux dates sont le même jour
   */
  private isSameDay(date1: Date, date2: Date): boolean {
    return date1.getFullYear() === date2.getFullYear() &&
           date1.getMonth() === date2.getMonth() &&
           date1.getDate() === date2.getDate();
  }

  /**
   * Vérifie si un équipement a des positions
   */
  equipmentHasPositions(equipmentId: number): boolean {
    if (!this.equipmentLayerManager) {
      return false;
    }
    const positions = this.equipmentLayerManager.getAllPositions();
    return positions.some(p => p.equipmentExternalId === equipmentId);
  }

  /**
   * Retourne la liste des équipements qui ont des positions
   */
  equipmentsWithPositions = computed(() => {
    this.routesVersion(); // Dépendance signal pour recalculer quand les données changent
    if (!this.equipments || !this.equipmentLayerManager) {
      return [] as Equipment[];
    }
    const positions = this.equipmentLayerManager.getAllPositions();
    const equipmentIdsWithPositions = new Set(positions.map((p: EquipmentPosition) => p.equipmentExternalId));
    return this.equipments.filter(e => equipmentIdsWithPositions.has(e.externalId));
  });

  resetFilters() {
    this.selectedDate.set(undefined);
    this.selectedShift.set(undefined);
    this.selectedEquipments.set([]);
    this.hasAppliedFilters.set(false);
    this.timeSliderEnabled.set(false);

    if (this.equipmentLayerManager && this.equipmentLayerManager.getFeaturesCount() > 0) {
      this.equipmentLayerManager.clear();
    }
  }

  ngAfterViewChecked() {
  this.updateAllViewCheckboxState();
  
  this.checkAndApplyKpiGradient();
}

  private checkAndApplyKpiGradient() {
    if (this.bottomActiveButoon === 1) {
      const scaleElement = document.getElementById('scale');
      if (scaleElement && !scaleElement.style.background.includes('linear-gradient')) {
        this.updateKpiScaleGradient();
      }
    }
  }
  updateAllViewCheckboxState() {
  if (!this.allViewCheckbox) return;
  const total = this.equipmentsWithPositions()?.length || 0;
  const selected = this.selectedEquipments()?.length || 0;
  this.allViewCheckbox.nativeElement.indeterminate = selected > 0 && selected < total;
  this.allView.set(selected === total && total > 0);
}

  onAllViewToggle(): void {
    // Inverser l'état avant d'agir
    this.allView.update(v => !v);
    if (this.allView()) {
      // Cocher tous les équipements avec positions
      this.selectedEquipments.set([...this.equipmentsWithPositions()]);
    } else {
      // Décocher tous les équipements
      this.selectedEquipments.set([]);
    }
    // Mettre à jour l'état de la checkbox après modification
    this.updateAllViewCheckboxState();
    // Filtrer l'affichage sur la carte
    this.updateEquipmentVisibility();
  }

  onShowAssignedEquipmentsToggle(): void {
    // Forcer le rafraîchissement des styles pour masquer/afficher les équipements assignés
    if (this.equipmentLayerManager) {
      this.equipmentLayerManager.updateStylesBasedOnAssignmentFilter(this.showAssignedEquipments);
    }
  }

  onShowEquipmentRoutesToggle(): void {
    // Afficher ou masquer les routes entre les positions d'équipements
    if (this.equipmentLayerManager) {
      this.equipmentLayerManager.setRoutesVisible(this.showEquipmentRoutes);
    }
  }

  getRoutesForEquipment(equipmentId: number) {
    this.routesVersion(); // Lecture du signal pour déclencher le change detection en zoneless
    if (!this.equipmentLayerManager) {
      return [];
    }
    const routeLayer = this.equipmentLayerManager.getRouteLayer();
    return routeLayer.getRoutesForEquipment(equipmentId);
  }

  selectRoute(route: any) {
    if (this.equipmentLayerManager) {
      const routeLayer = this.equipmentLayerManager.getRouteLayer();
      routeLayer.selectRoute(route);
    }
  }

  zoomToRoute(route: EquipmentRoute): void {
    this.equipmentLayerManager?.getRouteLayer()?.zoomToRoute(route);
  }

  /**
   * Sélectionne ou fusionne une route depuis les cards
   */
  toggleRouteForMerge(route: EquipmentRoute, event: Event): void {
    event.stopPropagation();

    if (!this.routeSelectedForMerge()) {
      // Première route sélectionnée
      this.routeSelectedForMerge.set(route);
    } else if (this.routeSelectedForMerge() === route) {
      // Même route, désélectionner
      this.routeSelectedForMerge.set(null);
    } else if (this.routeSelectedForMerge().equipmentId !== route.equipmentId) {
      // Routes de différents équipements, changer la sélection
      this.routeSelectedForMerge.set(route);
    } else {
      // Deux routes du même équipement, fusionner
      this.mergeRoutesFromCards(this.routeSelectedForMerge(), route);
      this.routeSelectedForMerge.set(null);
    }
  }

  /**
   * Vérifie si une route est sélectionnée pour fusion
   */
  isRouteSelectedForMerge(route: EquipmentRoute): boolean {
    return this.routeSelectedForMerge() === route;
  }

  /**
   * Annule la sélection de route pour fusion
   */
  cancelMergeSelection(): void {
    this.routeSelectedForMerge.set(null);
  }

  /**
   * Fusionne deux routes depuis les cards
   */
  private mergeRoutesFromCards(route1: EquipmentRoute, route2: EquipmentRoute): void {
    if (!this.equipmentLayerManager) {
      return;
    }

    const routeLayer = this.equipmentLayerManager.getRouteLayer();

    // Récupérer les positions des deux routes
    const positions1 = route1.feature.get('positions') as EquipmentPosition[];
    const positions2 = route2.feature.get('positions') as EquipmentPosition[];

    if (!positions1 || !positions2) {
      console.warn('Positions manquantes pour la fusion');
      return;
    }

    // Combiner les positions et les trier chronologiquement
    const mergedPositions = [...positions1, ...positions2].sort((a, b) =>
      new Date(a.date).getTime() - new Date(b.date).getTime()
    );

    // Supprimer les anciennes routes via le layer (et en base si elles ont un ID)
    routeLayer.removeRoute(route1, true);
    routeLayer.removeRoute(route2, true);

    // Créer la nouvelle route fusionnée
    routeLayer.createMergedRoute(mergedPositions, route1.equipmentId, route1.equipmentName, route1.color);
  }

  formatRouteTime(date: Date): string {
    return `${date.getHours()}:${String(date.getMinutes()).padStart(2, '0')}`;
  }

  formatRouteDate(dayKey: string): string {
    // Format: YYYY-MM-DD_SHIFT (ex: 2024-09-18_night) ou ancien format YYYY-MM-DD
    const [datePart, shiftPart] = dayKey.split('_');
    const parts = datePart.split('-');
    const dateFormatted = `${parts[2]}/${parts[1]}`;

    // Si pas de shift (ancien format), retourner seulement la date
    if (!shiftPart) {
      return dateFormatted;
    }

    // Traduire le nom du shift
    const shiftNames: { [key: string]: string } = {
      'morning': 'Matin',
      'afternoon': 'Après-midi',
      'night': 'Nuit'
    };
    const shiftName = shiftNames[shiftPart] || shiftPart;

    return `${dateFormatted} - ${shiftName}`;
  }

  /**
   * Formate une date de blast pour l'affichage (DD/MM/YY)
   */
  formatBlastDate(date: Date | string): string {
    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, '0');
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const year = d.getFullYear().toString().slice(2);
    return `${day}/${month}/${year}`;
  }

  /**
   * Récupère le nom d'un blast par son ID
   */
  getBlastNameById(tirId: number): string {
    const blast = this.listeTirs()?.find(tir => tir.tirId === tirId);
    return blast?.nom || `Blast ${tirId}`;
  }

  /**
   * Désassigne une route d'un blast
   */
  unassignRouteFromBlast(route: EquipmentRoute): void {
    if (!route.id) {
      // Route non sauvegardée, juste supprimer le tirId localement
      route.tirId = undefined;
      this.routesVersion.update(v => v + 1);
      return;
    }

    // Créer le DTO pour la mise à jour (sans tirId)
    const routeDto: EquipmentRouteDto = {
      id: route.id,
      siteId: this.site.siteId,
      equipmentId: route.equipmentId,
      start: route.startTime,
      end: route.endTime,
      tirId: null // Supprimer l'assignation
    };

    this.equipmentRouteService.updateRoute(route.id, routeDto).subscribe({
      next: () => {
        // Mettre à jour localement
        route.tirId = undefined;
        this.routesVersion.update(v => v + 1);
        console.log('Route désassignée avec succès');
      },
      error: (err) => {
        console.error('Erreur lors de la désassignation de la route:', err);
      }
    });
  }

  /**
   * Gère le début du drag d'une carte de route
   */
  onRouteDragStart(event: DragEvent, route: EquipmentRoute): void {
    this.draggingRoute.set(route);
    // Stocker l'ID de la route dans le dataTransfer pour le drop
    event.dataTransfer?.setData('text/plain', JSON.stringify({
      routeId: route.id,
      equipmentId: route.equipmentId,
      dayKey: route.dayKey,
      startTime: route.startTime,
      endTime: route.endTime
    }));
    event.dataTransfer!.effectAllowed = 'link';

    // Ajouter un listener temporaire sur la carte pour détecter le drop sur un polygone
    const mapElement = this.map.getTargetElement();
    mapElement.addEventListener('dragover', this.onMapDragOver);
    mapElement.addEventListener('drop', this.onMapDrop);
  }

  /**
   * Gère la fin du drag d'une carte de route
   */
  onRouteDragEnd(_event: DragEvent): void {
    // Retirer les listeners
    const mapElement = this.map.getTargetElement();
    mapElement.removeEventListener('dragover', this.onMapDragOver);
    mapElement.removeEventListener('drop', this.onMapDrop);

    this.draggingRoute.set(null);
    this.dragTooltipVisible = false;
  }

  /**
   * Handler pour dragover sur la carte (permet le drop et affiche la tooltip du blast)
   */
  private readonly onMapDragOver = (event: DragEvent): void => {
    event.preventDefault();
    event.dataTransfer!.dropEffect = 'link';

    // Afficher la tooltip du blast survolé
    const pixel = this.map.getEventPixel(event);
    let foundBlastInfo: { name: string; date: string } | null = null;

    this.map.forEachFeatureAtPixel(pixel, (feature) => {
      const featureType = feature.get(FEATURE_NAME);
      const featureType2 = feature.get(MapConstants.FEATURE_NAME);
      if (featureType === FEATURE_TYPE.blast_polygone ||
          featureType2 === MapConstants.FEATURE_TYPE.blast_polygone) {
        const tirIdObj = feature.get(MapConstants.TIR_ID);
        const tirId = tirIdObj?.value !== undefined ? tirIdObj.value : tirIdObj;
        if (tirId) {
          const tir = this.listeTirs()?.find(t => t.tirId === tirId);
          if (tir) {
            foundBlastInfo = {
              name: tir.nom || `Tir ${tirId}`,
              date: tir.dateTirPrevisionnelle ? this.formatBlastDate(tir.dateTirPrevisionnelle) : ''
            };
          }
        }
        return true;
      }
      return false;
    });

    if (foundBlastInfo) {
      this.dragTooltipVisible = true;
      this.dragTooltipText = foundBlastInfo.date
        ? `${foundBlastInfo.name} - ${foundBlastInfo.date}`
        : foundBlastInfo.name;
      this.dragTooltipX = event.clientX + 15;
      this.dragTooltipY = event.clientY + 15;
    } else {
      this.dragTooltipVisible = false;
    }
  };

  /**
   * Handler pour drop sur la carte - détecte si on est sur un polygone de blast
   */
  private readonly onMapDrop = (event: DragEvent): void => {
    event.preventDefault();

    if (!this.draggingRoute()) {
      return;
    }

    // Obtenir les coordonnées du drop sur la carte
    const pixel = this.map.getEventPixel(event);

    // Chercher un polygone de blast à cette position
    let foundFeature: any = null;
    this.map.forEachFeatureAtPixel(pixel, (feature) => {
      const featureType = feature.get(FEATURE_NAME);
      // Aussi checker avec MapConstants au cas où
      const featureType2 = feature.get(MapConstants.FEATURE_NAME);
      if (featureType === FEATURE_TYPE.blast_polygone ||
          featureType2 === MapConstants.FEATURE_TYPE.blast_polygone) {
        foundFeature = feature;
        return true; // Stop iteration
      }
      return false;
    });

    if (foundFeature) {
      // Récupérer le tirId du polygone
      const tirIdObj = foundFeature.get(MapConstants.TIR_ID);
      const tirId = tirIdObj?.value !== undefined ? tirIdObj.value : tirIdObj;

      if (tirId) {
        // Assigner la route à ce blast
        this.assignRouteToBlastById(this.draggingRoute(), tirId);
      }
    }

    this.draggingRoute.set(null);
  };

  /**
   * Assigne une route à un blast par son ID
   */
  assignRouteToBlastById(route: EquipmentRoute, tirId: number): void {
    if (!route.id) {
      // Route non sauvegardée, la créer d'abord avec le tirId
      const routeDto: EquipmentRouteDto = {
        siteId: this.site.siteId,
        equipmentId: route.equipmentId,
        start: route.startTime,
        end: route.endTime,
        tirId: tirId
      };

      this.equipmentRouteService.createRoute(routeDto).subscribe({
        next: (savedRoute) => {
          // Mettre à jour l'ID et le tirId dans la route locale
          route.id = savedRoute.id;
          route.tirId = tirId;
          this.routesVersion.update(v => v + 1);
          console.log('Route créée et assignée au blast:', savedRoute);
          this.fonctionsService.launch_toast(true);
        },
        error: (err) => {
          console.error('Erreur lors de la création de la route:', err);
          this.fonctionsService.launch_toast(false);
        }
      });
      return;
    }

    // Créer le DTO pour la mise à jour
    const routeDto: EquipmentRouteDto = {
      id: route.id,
      siteId: this.site.siteId,
      equipmentId: route.equipmentId,
      start: route.startTime,
      end: route.endTime,
      tirId: tirId
    };

    this.equipmentRouteService.updateRoute(route.id, routeDto).subscribe({
      next: () => {
        // Mettre à jour localement
        route.tirId = tirId;
        this.routesVersion.update(v => v + 1);
        console.log('Route assignée au blast avec succès:', tirId);
        this.fonctionsService.launch_toast(true);
      },
      error: (err) => {
        console.error('Erreur lors de l\'assignation de la route:', err);
        this.fonctionsService.launch_toast(false);
      }
    });
  }

  /**
   * Gère le clic sur une carte de route
   * En mode assignation, sélectionne la route pour assignation
   * Sinon, toggle la visibilité de la route
   */
  onRouteCardClick(route: EquipmentRoute): void {
    if (this.assignmentMode()) {
      // Mode assignation : sélectionner/désélectionner cette route pour assignation
      if (this.routeToAssignByClick() === route) {
        // Déselectionner si déjà sélectionnée
        this.routeToAssignByClick.set(null);
      } else {
        // Sélectionner cette route (une seule à la fois)
        this.routeToAssignByClick.set(route);
      }
    } else {
      // Mode normal : toggle la visibilité de la route
      this.selectRoute(route);
    }
  }

  /**
   * Bascule l'expansion d'une carte d'équipement
   */
  toggleEquipmentCard(equipmentId: number): void {
    this.expandedEquipmentCards.update(set => {
      const next = new Set(set);
      if (next.has(equipmentId)) {
        next.delete(equipmentId);
      } else {
        next.add(equipmentId);
      }
      return next;
    });
  }

  /**
   * Vérifie si une carte d'équipement est dépliée
   */
  isEquipmentCardExpanded(equipmentId: number): boolean {
    return this.expandedEquipmentCards().has(equipmentId);
  }

  /**
   * Obtient la couleur pour un équipement basé sur son ID
   * Utilise une palette de couleurs très distinctes
   */
  getEquipmentColor(equipmentId: number): string {
    const colors = [
      'rgba(230, 25, 75, 0.9)',    // Rouge vif
      'rgba(60, 180, 75, 0.9)',    // Vert vif
      'rgba(0, 130, 200, 0.9)',    // Bleu vif
      'rgba(255, 225, 25, 0.9)',   // Jaune vif
      'rgba(145, 30, 180, 0.9)',   // Violet
      'rgba(245, 130, 48, 0.9)',   // Orange
      'rgba(70, 240, 240, 0.9)',   // Cyan
      'rgba(240, 50, 230, 0.9)',   // Magenta
      'rgba(188, 246, 12, 0.9)',   // Lime
      'rgba(250, 190, 190, 0.9)',  // Rose
      'rgba(0, 128, 128, 0.9)',    // Teal
      'rgba(230, 190, 255, 0.9)',  // Lavande
      'rgba(154, 99, 36, 0.9)',    // Marron
      'rgba(255, 250, 200, 0.9)',  // Beige
      'rgba(128, 0, 0, 0.9)',      // Bordeaux
      'rgba(170, 255, 195, 0.9)',  // Menthe
      'rgba(128, 128, 0, 0.9)',    // Olive
      'rgba(255, 215, 180, 0.9)',  // Pêche
      'rgba(0, 0, 128, 0.9)',      // Navy
      'rgba(169, 169, 169, 0.9)'   // Gris
    ];
    return colors[equipmentId % colors.length];
  }

  /**
   * Bascule l'expansion du date range picker
   */
  toggleDateRangePicker(): void {
    this.isDateRangeExpanded.update(v => !v);
  }

  /**
   * Formate l'affichage de la date sélectionnée
   */
  formatSelectedDate(): string {
    if (!this.selectedDate()) {
      return 'Select date';
    }
    return this.formatDateShort(this.selectedDate());
  }

  /**
   * Formate l'affichage du shift sélectionné
   */
  formatSelectedShift(): string {
    if (this.selectedShift() === undefined || this.selectedShift() === null) {
      return 'Select shift';
    }
    return this.translate.instant(this.formatShiftLabel(this.selectedShift()));
  }

  /**
   * Formate une date courte (DD/MM/YYYY)
   */
  private formatDateShort(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  /**
   * Réinitialise le date and shift picker
   */
  resetDateRange(): void {
    this.selectedDate.set(undefined);
    this.selectedShift.set(undefined);
    this.hasAppliedFilters.set(false);
  }

  /**
   * Applique la date et le shift sélectionné
   */
  applyDateRange(): void {
    // Vérifier que date et shift sont sélectionnés
    if (!this.selectedDate() || this.selectedShift() === undefined || this.selectedShift() === null) {
      return;
    }

    // Mettre la sélection en mode shift
    this.timeSelection.set('shift');

    // Pour le chargement, utiliser tous les équipements disponibles
    const equipmentsToLoad = this.equipments && this.equipments.length > 0
      ? this.equipments
      : this.selectedEquipments();

    if (this.equipmentLayerManager && equipmentsToLoad && equipmentsToLoad.length > 0) {
      const params = {
        selectedEquipments: equipmentsToLoad,
        selectedDate: this.selectedDate(),
        selectedDateRange: this.selectedDateRange(),
        selectedShift: this.selectedShift(),
        timeSelection: this.timeSelection(),
      };

      this.equipmentLayerManager.getEquipmentPositions(params);
      this.equipmentLayerManager.shouldLoadSavedPositions = true;
      this.hasAppliedFilters.set(true);

      // Activer l'affichage des routes si nécessaire
      if (this.showEquipmentRoutes) {
        this.equipmentLayerManager.setRoutesVisible(true);
      }

      // Activer le time slider
      this.timeSliderEnabled.set(true);
      this.updateTimeSliderRange();

      // Appliquer automatiquement les effets de timeline dès le chargement
      this.equipmentLayerManager.dataLoaded.pipe(take(1)).subscribe(() => {
        // Sélectionner automatiquement tous les équipements qui ont des positions
        this.selectedEquipments.set([...this.equipmentsWithPositions()]);
        // Mettre à jour la visibilité pour que tous les équipements avec positions soient visibles
        this.updateEquipmentVisibility();
        this.applyTimelineEffects();
      });
    }

    // Fermer le picker
    this.isDateRangeExpanded.set(false);
  }


  /**
   * Convertit des minutes depuis minuit en format HH:MM
   */
  formatTimeFromMinutes(minutes: number): string {
    const wrapped = ((minutes % 1440) + 1440) % 1440;
    const hours = Math.floor(wrapped / 60);
    const mins = wrapped % 60;
    return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
  }

  /**
   * Calcule le pourcentage de progression du slider
   */
  getSliderPercentage(): number {
    if (!this.timeSliderEnabled() || this.maxTime() === this.minTime()) {
      return 0;
    }

    return ((this.selectedTime() - this.minTime()) / (this.maxTime() - this.minTime())) * 100;
  }

  /**
   * Appelé quand le slider de temps change
   */
  onTimeSliderChange(): void {
    if (!this.timeSliderEnabled() || !this.equipmentLayerManager) {
      return;
    }
    this.filterPositionsByTime();
  }

  /**
   * Filtre les positions d'équipements en fonction du temps sélectionné
   */
  private filterPositionsByTime(): void {
    if (!this.equipmentLayerManager || !this.timeSliderEnabled()) {
      return;
    }

    // Créer une date de référence pour le filtrage
    // Pour le shift nuit, le startDate est sur J-1, on utilise directement le shiftRange
    const referenceDate = this.selectedDate() || new Date();
    const filterDate = new Date(referenceDate);
    const hours = Math.floor(this.selectedTime() / 60);
    if (hours >= 24) {
      // selectedTime > 24h signifie qu'on est passé minuit (ex: 22h+24=lendemain 5h)
      filterDate.setHours(hours - 24);
      filterDate.setMinutes(this.selectedTime() % 60);
    } else if (this.selectedShift() === ShiftEnum.NightToMorning && hours >= 22) {
      // Partie 22h-00h du shift nuit : c'est la veille de la date sélectionnée
      filterDate.setDate(filterDate.getDate() - 1);
      filterDate.setHours(hours);
      filterDate.setMinutes(this.selectedTime() % 60);
    } else {
      filterDate.setHours(hours);
      filterDate.setMinutes(this.selectedTime() % 60);
    }
    filterDate.setSeconds(0);

    // Filtrer les positions par temps (le slider ne touche QUE au style, pas à la visibilité)
    this.equipmentLayerManager.filterPositionsByTime(filterDate);
  }

  /**
   * Applique automatiquement les effets de timeline (tailles et opacités)
   * en positionnant le curseur au milieu de la plage de temps
   */
  private applyTimelineEffects(): void {
    if (!this.equipmentLayerManager || !this.timeSliderEnabled()) {
      return;
    }

    // Calculer le temps médian entre minTime et maxTime
    const medianTime = Math.floor((this.minTime() + this.maxTime()) / 2);
    this.selectedTime.set(medianTime);

    // Appliquer le filtre avec ce temps médian
    this.filterPositionsByTime();
  }

  /**
   * Calcule la plage de temps en fonction du shift sélectionné
   */
  private updateTimeSliderRange(): void {
    if (!this.selectedDate() && !this.selectedDateRange().length) {
      this.timeSliderEnabled.set(false);
      return;
    }

    this.timeSliderEnabled.set(true);

    if (this.selectedShift() !== undefined && this.selectedShift() !== null) {
      // Calculer la plage horaire en fonction du shift
      const shiftRange = ShiftUtils.calculateShiftTimeRange(this.selectedDate(), this.selectedShift());

      // Convertir en minutes depuis minuit
      this.minTime.set(shiftRange.startDate.getHours() * 60 + shiftRange.startDate.getMinutes());
      this.maxTime.set(shiftRange.endDate.getHours() * 60 + shiftRange.endDate.getMinutes());

      // Si le shift traverse minuit (comme Night shift)
      if (this.maxTime() < this.minTime()) {
        this.maxTime.update(v => v + 24 * 60); // Ajouter 24h
      }

      // Initialiser au début du shift
      this.selectedTime.set(this.minTime());
    } else {
      // Mode date range ou pas de shift: toute la journée
      this.minTime.set(0);
      this.maxTime.set(1439); // 23:59
      this.selectedTime.set(0);
    }
  }

  onTimeSelectionChange() {
    this.selectedShift.set(undefined);
    this.missingDateField = false;
    this.missingDateRangeField = false;
    this.missingShiftField = false;
    this.missingEquipmentField = false;
  }

  onDateChange(date: Date): void {
    this.selectedDate.set(date);
    this.getEquipementPosition();
  }

  onDateRangeChange(range: Date[]): void {
    if (!range || range.length !== 2) {
      return;
    }

    const hasChanged = !this.previousDateRange.length ||
                      this.previousDateRange[0]?.getTime() !== range[0]?.getTime() ||
                      this.previousDateRange[1]?.getTime() !== range[1]?.getTime();

    if (!hasChanged) {
      return;
    }

    if (this.dateRangeChangeTimeout) {
      clearTimeout(this.dateRangeChangeTimeout);
    }

    this.selectedDateRange.set(range);
    this.previousDateRange = [...range]; 


    this.getEquipementPosition();
 
  }
  public adjustDateRangePickerPosition(): void {
    setTimeout(() => this.startCalendarPositionMonitoring(), 50);
  }

  private checkAndAdjustCalendarPosition(): void {
    const container = document.querySelector('bs-daterangepicker-container') as HTMLElement;
    if (!container) return;

    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const margin = 10; // marge de sécurité
    
    // Obtenir la position et taille actuelles
    const rect = container.getBoundingClientRect();
    
    // Vérifier si le calendrier déborde (avec une petite tolérance)
    const overflowRight = rect.right > (viewportWidth - margin);
    const overflowLeft = rect.left < margin;
    const overflowBottom = rect.bottom > (viewportHeight - margin);
    const overflowTop = rect.top < margin;

    // Toujours ajuster si il y a le moindre débordement
    if (overflowRight || overflowLeft || overflowBottom || overflowTop) {
      console.log(`Calendar overflow detected: right=${overflowRight}, left=${overflowLeft}, bottom=${overflowBottom}, top=${overflowTop}`);
      
      // Calculer la position optimale pour garantir que tout est visible
      let newLeft = rect.left;
      let newTop = rect.top;
      
      // Ajuster horizontalement - priorité au débordement le plus critique
      if (overflowRight) {
        // Le calendrier déborde à droite, le coller au bord droit
        newLeft = viewportWidth - rect.width - margin;
      }
      if (overflowLeft || newLeft < margin) {
        // Le calendrier déborde à gauche ou la nouvelle position est trop à gauche
        newLeft = margin;
      }
      
      // Ajuster verticalement
      if (overflowBottom) {
        // Le calendrier déborde en bas, le coller au bord bas
        newTop = viewportHeight - rect.height - margin;
      }
      if (overflowTop || newTop < margin) {
        // Le calendrier déborde en haut ou la nouvelle position est trop haute
        newTop = margin;
      }
      
      // S'assurer que les nouvelles coordonnées restent dans les limites
      newLeft = Math.max(margin, Math.min(newLeft, viewportWidth - rect.width - margin));
      newTop = Math.max(margin, Math.min(newTop, viewportHeight - rect.height - margin));
      
      // Appliquer la position corrigée
      container.style.position = 'fixed';
      container.style.left = `${newLeft}px`;
      container.style.top = `${newTop}px`;
      container.style.right = 'auto';
      container.style.bottom = 'auto';
      container.style.transform = 'none';
      container.style.zIndex = '1060';
      
      console.log(`Calendar repositioned from (${rect.left}, ${rect.top}) to (${newLeft}, ${newTop}), size: ${rect.width}x${rect.height}, viewport: ${viewportWidth}x${viewportHeight}`);
      
      // Vérification finale après repositionnement
      setTimeout(() => {
        const newRect = container.getBoundingClientRect();
        if (newRect.right > viewportWidth || newRect.bottom > viewportHeight || newRect.left < 0 || newRect.top < 0) {
          console.warn(`Calendar still overflows after adjustment: left=${newRect.left}, top=${newRect.top}, right=${newRect.right}, bottom=${newRect.bottom}`);
        }
      }, 50);
    }
  }

  private calendarMonitoringInterval: any;

  // Démarrer la surveillance ULTRA-AGRESSIVE du calendrier
  private startCalendarPositionMonitoring(): void {
    this.stopCalendarPositionMonitoring(); // S'assurer qu'on n'a pas déjà un interval
    
    // Forcer immédiatement
    this.forceCalendarInScreen();
    
    // Surveiller de manière très agressive - toutes les 50ms
    this.calendarMonitoringInterval = setInterval(() => {
      this.forceCalendarInScreen();
    }, 50);
    
    // Ajustements supplémentaires aux moments clés
    setTimeout(() => this.forceCalendarInScreen(), 10);
    setTimeout(() => this.forceCalendarInScreen(), 25);
    setTimeout(() => this.forceCalendarInScreen(), 75);
    setTimeout(() => this.forceCalendarInScreen(), 150);
    setTimeout(() => this.forceCalendarInScreen(), 300);
  }

  // Arrêter la surveillance
  private stopCalendarPositionMonitoring(): void {
    if (this.calendarMonitoringInterval) {
      clearInterval(this.calendarMonitoringInterval);
      this.calendarMonitoringInterval = null;
    }
  }

  // Juste décaler légèrement si le calendrier dépasse
  private forceCalendarInScreen(): void {
    const container = document.querySelector('bs-daterangepicker-container') as HTMLElement;
    if (!container) return;

    const viewportWidth = window.innerWidth;
    const rect = container.getBoundingClientRect();
    
    // Vérifier si ça dépasse à droite
    if (rect.right > viewportWidth) {
      const overflow = rect.right - viewportWidth;
      
      // Calculer la nouvelle position right pour rentrer dans l'écran
      // Si le calendrier est à "right: 100px" et déborde de 50px,
      // on doit mettre "right: 150px" pour le décaler de 50px vers la gauche
      const currentStyle = getComputedStyle(container);
      const currentRightValue = currentStyle.right;
      
      let currentRight: number;
      if (currentRightValue.includes('calc(')) {
        // Si c'est calc(77px + 1.2rem), approximer à 100px
        currentRight = 100;
      } else {
        currentRight = parseInt(currentRightValue) || 0;
      }
      
      const newRight = currentRight + overflow + 20; // +20px de marge de sécurité
      
      container.style.right = `${newRight}px`;
      console.log(`Calendar adjusted: viewport=${viewportWidth}, rect.right=${rect.right}, overflow=${overflow}, newRight=${newRight}px`);
    }
  }

  // Nettoyer quand le calendrier se ferme
  private cleanupCalendarPosition(): void {
    document.body.classList.remove('datepicker-open');
  }

  onShiftChange(shift: ShiftEnum): void {
    this.selectedShift.set(shift);
    this.getEquipementPosition();
  }
  onControlPointsToggleChange() {
    if (this.controlPointLayer) {
      this.controlPointLayer.setVisible(this.controlPointsToggle);
    }
    this.saveBooleanToLocalStorage('controlPointsToggle', this.controlPointsToggle);
  }

  onZoiToggleChange() {
    this.saveBooleanToLocalStorage('zoiToggle', this.zoiToggle);
    this.zoneOfInterestLayer.setVisible(this.zoiToggle);
  }

 onHolesToggleChange() {
  
  if (this.holeToggle && this.inZoom) {
    this.holesAreShown = true;
  } else {
    this.holesAreShown = false;
  }
  
  this.RefreshHoles();
  this.updateHoleVisibility();
}
  toggleEnumValue(value: TirsPolygoneEnum) {
  const index = this.cartSelectedTirsPolygoneEnum.indexOf(value);
  if (index === -1) {
    this.cartSelectedTirsPolygoneEnum.push(value);
  } else {
    this.cartSelectedTirsPolygoneEnum.splice(index, 1);
  }
  this.savePolygonToggles();
  this.cartPolygoneTypeChange(); 
  
}
  isSelected(item: Equipment): boolean {
    return this.selectedEquipments().some(e => e.equipementId === item.equipementId);
  }

  toggleSelection(item: Equipment): void {
  const index = this.selectedEquipments().findIndex(e => e.equipementId === item.equipementId);
  if (index > -1) {
    this.selectedEquipments.set(this.selectedEquipments().filter(e => e.equipementId !== item.equipementId));
  } else {
    this.selectedEquipments.set([...this.selectedEquipments(), item]); // Ajout non-mutatif
  }
  this.updateAllViewCheckboxState();
  // Filtrer l'affichage sur la carte
  this.updateEquipmentVisibility();
}

  updateEquipmentVisibility(): void {
    if (!this.equipmentLayerManager) {
      return;
    }

    // Récupérer les IDs des équipements sélectionnés
    const selectedIds = this.selectedEquipments().map(e => e.externalId).filter(id => id !== undefined);

    // Filtrer les équipements et routes visibles
    this.equipmentLayerManager.filterEquipmentsByIds(selectedIds);
  }

  private openPolygonTypeModal(): void {
    this.showPolygonTypeModal = true;
    this.selectedPolygonType = 'normal';
    this.selectAndStartPolygonType(this.selectedPolygonType) 
    if (this.menuTirSelected) {
      this.tirPopup.set(this.menuTirSelected);
    }
  }

  protected openHolesModal() {
    this.showHolesModal = true;
  }

  protected closeHolesModal() {
    this.showHolesModal = false;
  }

  protected onHoleStatusFilterChange(filter: string | HoleStatus) {
    this.selectedHoleStatusFilter = filter;
    this.selectedHoleFeatureFilter = 'all';
    this.updateHoleVisibility();
  }
  onHoleFeatureFilterChange(feature: string): void {
    this.selectedHoleFeatureFilter = feature;
    this.selectedHoleStatusFilter = 'actual';
    this.updateHoleVisibility();
    
    if (this.holeLayer && feature !== 'all') {
      setTimeout(() => {
        const features = this.holeLayer?.getAllHoleFeatures() || [];
        if (features.length > 0) {
          const totalHoles = features.length;
          let waterCount = 0;
          let tubeCount = 0;
          let deviationCount = 0;
          
          features.forEach(f => {
            const hole = f.get(MapConstants.HOLE_OBJECT);
            if (hole) {
              if (hole.hasWater) waterCount++;
              if (hole.hasTube) tubeCount++;
              if (hole.hasDeviation) deviationCount++;
            }
          });
          
          this.holeFeatureLegendProperties = [
            {
              featureType: 'water' as const,
              numberOfHoles: waterCount,
              percentage: Math.round((waterCount / totalHoles) * 100),
              totalHoles
            },
            {
              featureType: 'tube' as const,
              numberOfHoles: tubeCount,
              percentage: Math.round((tubeCount / totalHoles) * 100),
              totalHoles
            } ,
            { featureType: 'deviation' as const,
              numberOfHoles: deviationCount,
              percentage: Math.round((deviationCount / totalHoles) * 100),
              totalHoles
            } ,
          ];
        }
      }, 100);
    } else {
      this.holeFeatureLegendProperties = [];
    }
  }

  private getVisibleHoleStatuses(): Set<HoleStatus> {
    if (this.selectedHoleStatusFilter === 'actual') {
      return new Set(Object.values(HoleStatus));
    } else {
      return new Set([this.selectedHoleStatusFilter as HoleStatus]);
    }
  }

  protected updateHoleVisibility() {
    if (this.holesAreShown) {
      const visibleStatuses = this.getVisibleHoleStatuses();
      this.holeLayer.refreshHoleVisibility(visibleStatuses, this.selectedHoleStatusFilter as HoleStatus, this.selectedHoleFeatureFilter);
    } else {
      this.holeLayer.hideAllHoles();
    }
  }

  protected getHoleStatusList(): HoleStatus[] {
    return Object.values(HoleStatus);
  }

  getFeatureDisplayName(featureType: string): string {
    switch (featureType) {
      case 'water':
        return 'Water';
      case 'tube':
        return 'Tube';
      case 'both':
        return 'Water & Tube';
      case 'none':
        return 'No Features';
      default:
        return featureType;
    }
  }

  getFeatureIconPath(featureType: string): string {
    switch (featureType) {
      case 'water':
        return 'assets/icon/hole-water.svg';
      case 'tube':
        return 'assets/icon/hole-tube.svg';
      case 'both':
        return 'assets/icon/hole-water.svg'; 
      case 'none':
        return 'assets/icon/hole-others.svg';
      case 'deviation':
        return 'assets/icon/hole-deviation.svg';
      default:
        return 'assets/icon/hole-others.svg';
    }
  }

  public updateHoleFeatureLegend(): void {
    const features = this.holeLayer?.getAllHoleFeatures() || [];
    
    if (features.length === 0) {
      this.holeFeatureLegendProperties = [];
      return;
    }

    const totalHoles = features.length;
    const featureCount: { [key in 'water' | 'tube' | 'both' | 'none']: number } = {
      'water': 0,
      'tube': 0,
      'both': 0,
      'none': 0
    };

    features.forEach((feature, index) => {
      const hole = feature.get(MapConstants.HOLE_OBJECT);
      if (!hole) return;
      
      const hasWater = hole.hasWater || false;
      const hasTube = hole.hasTube || false;

      if (hasWater && hasTube) {
        featureCount.both++;
      } else if (hasWater) {
        featureCount.water++;
      } else if (hasTube) {
        featureCount.tube++;
      } else {
        featureCount.none++;
      }
    });

    this.holeFeatureLegendProperties = [
      {
        featureType: 'water' as const,
        numberOfHoles: featureCount.water,
        percentage: Math.round((featureCount.water / totalHoles) * 100),
        totalHoles
      },
      {
        featureType: 'tube' as const,
        numberOfHoles: featureCount.tube,
        percentage: Math.round((featureCount.tube / totalHoles) * 100),
        totalHoles
      }
    ];
  }


  public closePolygonTypeModal(): void {
    this.showPolygonTypeModal = false;
  }

  public selectAndStartPolygonType(type: string): void {
    this.activeButton = 3;
    this.map.getTargetElement().classList.add('map-drawing');
    this.selectedPolygonType = type;
    if (type === 'normal') {  
      this.rulerControlLayer.toggle(MEASURE_MODE.area);
      
      this.rulerControlLayer.drawPolygonCoordinatesEvent.subscribe({
        next: (coordinates: Coordinate[][]) => {
          this.polygonCoordinatesToSave = coordinates;
          this.handleDrawingComplete();
        },
        error: () => {
          this.handleDrawingError();
        }
      });
      
    } else if (type === 'circle') {
      this.rulerControlLayer.toggle(MEASURE_MODE.circle);
      
      this.listenForCircleDrawEnd();
    }
    
  }

  private listenForCircleDrawEnd(): void {
    const drawInteraction = this.rulerControlLayer.getDrawInteraction();
    
    if (drawInteraction) {
      drawInteraction.on('drawend', (event) => {
        const feature = event.feature;
        const geometry = feature.getGeometry();
        
        this.polygonCoordinatesToSave = this.extractCoordinatesFromGeometry(geometry);
        
        setTimeout(() => {
          this.handleDrawingComplete();
        }, 100);
      });
    }
  }

  private extractCoordinatesFromGeometry(geometry: any): Coordinate[][] {
    if (geometry.getType() === 'Circle') {
      const center = geometry.getCenter();
      const radius = geometry.getRadius();
      const points = 64; 
      const coordinates: Coordinate[] = [];
      
      for (let i = 0; i <= points; i++) {
        const angle = (i * 2 * Math.PI) / points;
        const x = center[0] + radius * Math.cos(angle);
        const y = center[1] + radius * Math.sin(angle);
        coordinates.push([x, y]);
      }
      
      coordinates[coordinates.length - 1] = [...coordinates[0]];
      
      return [coordinates];
      
    } else if (geometry.getType() === 'Polygon') {
      const coords = geometry.getCoordinates();
      return coords;
    } else {
      console.error('Unsupported geometry type:', geometry.getType());
      return [];
    }
  }

  private handleDrawingComplete(): void {
    if (this.menuTirSelected) {
      this.preSelectedBlast = this.menuTirSelected;
      this.selectedBlastForPolygon = this.menuTirSelected.tirId;
    } else if (this.tirPopup()) {
      this.preSelectedBlast = this.tirPopup()!;
      this.selectedBlastForPolygon = this.tirPopup()!.tirId;
    } else {
      this.preSelectedBlast = null;
      this.selectedBlastForPolygon = null;
    }
    
    if (!this.selectedTirsPolygoneEnum) {
      this.selectedTirsPolygoneEnum = TirsPolygoneEnum.MUCKPILE;
    }
    
    this.map.getTargetElement().classList.remove('map-drawing');
    this.activeButton = 1;
    this.enablePolygonePicking = true;
    
    this.openModalValidationPolygone();
  }

  private handleDrawingError(): void {
    this.map.getTargetElement().classList.remove('map-drawing');
    this.activeButton = 1;
    this.enablePolygonePicking = true;
    this.closePolygonTypeModal();
    this.fonctionsService.launch_toast(false);
    alert('An error occurred while drawing the polygon.');
  }

    private clearDrawnPolygon(): void {
    this.rulerControlLayer.clearDrawings();
    this.activeButton = 1;
    
}

checkScreenSize() {
  this.evaluateBottomButtonsOverflow();
}

private evaluateBottomButtonsOverflow(): void {
  requestAnimationFrame(() => {
    const rightMenu = document.querySelector('.right-menu') as HTMLElement;
    if (!rightMenu) return;

    const topButtons = rightMenu.querySelectorAll('.icon-button');
    let topUsed = 0;
    topButtons.forEach(btn => {
      const rect = (btn as HTMLElement).getBoundingClientRect();
      topUsed += rect.height; 
      const styles = window.getComputedStyle(btn as HTMLElement);
      topUsed += parseFloat(styles.marginTop) || 0;
      topUsed += parseFloat(styles.marginBottom) || 0;
    });

    const totalHeight = rightMenu.clientHeight;

    const availableForBottom = totalHeight - topUsed;
    
    if (availableForBottom <= 0) {
      if (!this.isBottomButtonsOverflow) {
        this.isBottomButtonsOverflow = true;
        this.cdr.detectChanges();
      }
      return;
    }

    const tempButtons = rightMenu.querySelectorAll('.right-menu-bottom:not(.overflow) .icon-button-bottom, .right-menu-bottom .icon-button-bottom');
    const uniqueButtons: HTMLElement[] = [];
    tempButtons.forEach(el => { if (!uniqueButtons.includes(el as HTMLElement)) uniqueButtons.push(el as HTMLElement); });
    if (!uniqueButtons.length) return;
    
    const needed = uniqueButtons.reduce((sum, el) => {
      const h = el.offsetHeight;
      const styles = window.getComputedStyle(el);
      const marginTop = parseFloat(styles.marginTop) || 0;
      const marginBottom = parseFloat(styles.marginBottom) || 0;
      return sum + h + marginTop + marginBottom;
    }, 0);

    let tolerance = 2;
    if (Math.abs(window.devicePixelRatio - 1.5) < 0.1) {
      tolerance = 10; 
    }
    
    const mustOverflow = needed > (availableForBottom - tolerance);
    
    if (mustOverflow) {
      const arrowsReserve = 64 + 8; 
      const candidate = availableForBottom - arrowsReserve;
      this.bottomButtonsViewportHeight = Math.max(candidate, 40); // sécurité
    } else {
      this.bottomButtonsViewportHeight = null;
    }
    
    if (mustOverflow !== this.isBottomButtonsOverflow) {
      this.isBottomButtonsOverflow = mustOverflow;
      this.cdr.detectChanges();
    }
  });
}

private evaluateTopButtonsOverflow(): void {
  requestAnimationFrame(() => {
    const container = this.topButtonsContainer?.nativeElement;
    const rightMenu = document.querySelector('.right-menu') as HTMLElement;
    if (!container || !rightMenu) return;
    const reservedForBottom = 120; 
    const available = rightMenu.clientHeight - reservedForBottom;
    const needed = container.scrollHeight;
    const overflow = needed > available;
    if (overflow !== this.isTopButtonsOverflow) {
      this.isTopButtonsOverflow = overflow;
      if (overflow) container.classList.add('top-scroll'); else container.classList.remove('top-scroll');
      this.cdr.detectChanges();
    }
  });
}

private evaluateHolesModalOverflow(): void {
  if (this.bottomActiveButoon !== 2) return;
  
  requestAnimationFrame(() => {
    const holesModal = document.querySelector('.modal-overlay-custome-holes') as HTMLElement;
    if (!holesModal) return;

    const rightMenu = document.querySelector('.right-menu') as HTMLElement;
    if (!rightMenu) return;

    const rightMenuRect = rightMenu.getBoundingClientRect();
    const modalRect = holesModal.getBoundingClientRect();
    
    const availableHeight = modalRect.top - rightMenuRect.top - 20;
    

    const neededHeight = modalRect.height;
    

    const mustOverflow = neededHeight > availableHeight;
    
    if (mustOverflow !== this.isHolesModalOverflow) {
      this.isHolesModalOverflow = mustOverflow;
      this.cdr.detectChanges();
    }
  });
}

private scheduleOverflowRecalc(): void {
  if (this.recalcTimeout) clearTimeout(this.recalcTimeout);
  
  this.recalcTimeout = setTimeout(() => { 
    this.adjustTopRightButtonsPosition();
    setTimeout(() => {
      this.evaluateBottomButtonsOverflow();
      this.evaluateTopButtonsOverflow();
      this.evaluateHolesModalOverflow();
    }, 10);
  }, 50);
}

private adjustTopRightButtonsPosition(): void {
  requestAnimationFrame(() => {
    const topRightButtons = document.querySelector('.top-right-buttons') as HTMLElement;
    if (!topRightButtons) return;

    const zoomFactor = window.devicePixelRatio;
    const baseDistance = 1; // 1rem de base
    

    const scaledDistance = baseDistance * Math.max(0.5, Math.min(1.5, 1 / Math.sqrt(zoomFactor)));
    
    topRightButtons.style.setProperty('--top-right-distance', `${scaledDistance}rem`);
    
    topRightButtons.classList.remove('zoom-high', 'zoom-low');
    
    if (zoomFactor > 2.0) {
      // Zoom très élevé
      topRightButtons.classList.add('zoom-high');
      topRightButtons.style.transform = `scale(${0.8})`;
      topRightButtons.style.setProperty('--top-right-gap', '0.25rem');
      topRightButtons.style.setProperty('--top-right-padding', '0.1rem 0.25rem');
    } else if (zoomFactor > 1.5) {
      // Zoom élevé
      topRightButtons.style.transform = `scale(${0.9})`;
      topRightButtons.style.setProperty('--top-right-gap', '0.3rem');
      topRightButtons.style.setProperty('--top-right-padding', '0.1rem 0.3rem');
    } else if (zoomFactor < 0.7) {
      // Zoom réduit
      topRightButtons.classList.add('zoom-low');
      topRightButtons.style.transform = `scale(${1.15})`;
      topRightButtons.style.setProperty('--top-right-gap', '0.6rem');
      topRightButtons.style.setProperty('--top-right-padding', '0.3rem 0.5rem');
    } else if (zoomFactor < 0.9) {
      // Zoom légèrement réduit
      topRightButtons.style.transform = `scale(${1.05})`;
      topRightButtons.style.setProperty('--top-right-gap', '0.55rem');
      topRightButtons.style.setProperty('--top-right-padding', '0.25rem 0.45rem');
    } else {
      // Zoom normal - réinitialiser aux valeurs par défaut
      topRightButtons.style.transform = 'scale(1)';
      topRightButtons.style.setProperty('--top-right-gap', '0.5rem');
      topRightButtons.style.setProperty('--top-right-padding', '0.2rem 0.4rem');
    }
  });
}

scrollToActiveButton() {
  if (this.isBottomButtonsOverflow) {
    const activeButton = document.querySelector('.icon-button-bottom.active');
    if (activeButton) {
      activeButton.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'center' 
      });
    }
  }
}
scrollUp() {
  if (this.isBottomButtonsOverflow && this.bottomButtonsContainer) {
    this.bottomButtonsContainer.nativeElement.scrollBy({ top: -40, behavior: 'smooth' });
  }
}

scrollDown() {
  if (this.isBottomButtonsOverflow && this.bottomButtonsContainer) {
    this.bottomButtonsContainer.nativeElement.scrollBy({ top: 40, behavior: 'smooth' });
  }
}

  toggleZoneColors(): void {
    this.useZoneColors = !this.useZoneColors;
    
    this.blastPolygoneLayer.setZoneColorsEnabled(this.useZoneColors);
    
    if (this.useZoneColors) {
      this.kpiSelectionne = null;
      this.selectedKPI = null;
      this.blastPolygoneLayer.resetPolygonsKPIs();
    } else {
      if (this.selectedKPI) {
        setTimeout(() => {
          this.getSelectedKPI(this.selectedKPI);
        }, 100);
      }
    }
  }

  private previousSelectedKPI: any = null;

  onColorModeChange(useZoneColors: boolean): void {
    this.useZoneColors = useZoneColors;
    
    this.blastPolygoneLayer.setZoneColorsEnabled(this.useZoneColors);
    
    if (this.useZoneColors) {
      if (this.selectedKPI) {
        this.previousSelectedKPI = this.selectedKPI;
      }
      this.kpiSelectionne = null;
      this.selectedKPI = null;
      this.blastPolygoneLayer.resetPolygonsKPIs();
    } else {
      if (this.previousSelectedKPI) {
        setTimeout(() => {
          this.getSelectedKPI(this.previousSelectedKPI);
        }, 100);
      } else if (this.selectedKPI) {
        setTimeout(() => {
          this.getSelectedKPI(this.selectedKPI);
        }, 100);
      }
    }
  }



  getZonesWithColors(): { zone: any, color: string }[] {
    if (!this.listeTirs()) return [];
    
    const zonesMap: { [key: number]: any } = {};
    
    this.listeTirs()?.forEach(tir => {
      if (tir.zoneId && !zonesMap[tir.zoneId]) {
        zonesMap[tir.zoneId] = {
          zoneId: tir.zoneId,
          nomZone: tir.nomZone || `Zone ${tir.zoneId}`
        };
      }
    });
    
    return Object.values(zonesMap).map(zone => ({
      zone,
      color: this.getZoneDisplayColor(zone.zoneId)
    }));
  }

  private getZoneDisplayColor(zoneId: number): string {
    if (zoneId && zoneId > 0 && ZoneColorPalette[zoneId]) {
      return ZoneColorPalette[zoneId];
    }
    return 'rgba(145, 40, 59, 0.8)'; // Couleur par défaut
  }
  setActiveTab(tab: string): void {
    this.activeTab = tab;
  }

  get orthoLayers(): OrthoPhotoDto[] {
    return this.mapLayersControler ? this.mapLayersControler.getOrthophotoMaps() : [];
  }

  dropOrthoLayer(event: CdkDragDrop<OrthoPhotoDto[]>) {
    const layers = [...this.orthoLayers];
    
    moveItemInArray(layers, event.previousIndex, event.currentIndex);
    

    layers.forEach((layer, index) => {
      layer.zOrder = index + 1;
    });
    
    this.mapLayersControler.updateOrthophotoOrder(layers);
    
    this.updateOrderInDatabase(layers);
    
  }

  private updateOrderInDatabase(layers: OrthoPhotoDto[]) {
    if (layers.length < 2) return;
    
    const orthophotosForApi = layers.map(layer => ({
      name: layer.mapName,
      ordre: layer.zOrder,
      guidProcess: layer.tileSetId,
      isActif: layer.isVisible
    }));
    
    const url = `sites/${this.utilService.currentSite().siteId}/map/order`;
    this.http.post(url, orthophotosForApi).subscribe((result: any) => {
      
        if (result.statusCode > 299) {
          this.fonctionsService.launch_toast(false, false, result.message);
        } else if (result.statusCode === 200 || result.statusCode === 204) {
          // 200 = OK avec contenu, 204 = No Content (succès sans retour)
          this.fonctionsService.launch_toast(true);
        }
      
      error: () => {
        this.fonctionsService.launch_toast(false);
      }
    });
  }

  toggleOrthoLayer(orthoPhoto: OrthoPhotoDto): void {
    const newVisibility = !orthoPhoto.isVisible;
    
    orthoPhoto.isVisible = newVisibility;
    
    this.mapLayersControler.toggleOrthophotoVisibility(orthoPhoto.id, newVisibility);
    
    const url = `sites/${this.utilService.currentSite().siteId}/map/${orthoPhoto.tileSetId}/visibility?isVisible=${newVisibility}`;
    this.http.post(url, {}).subscribe({
      next: (result: any) => {
        if (result.statusCode > 299) {
          orthoPhoto.isVisible = !newVisibility;
          this.mapLayersControler.toggleOrthophotoVisibility(orthoPhoto.id, !newVisibility);
          this.fonctionsService.launch_toast(false, false, result.message);
        } else if (result.statusCode === 200 || result.statusCode === 204) {
          this.fonctionsService.launch_toast(true);
        }
      },
      error: () => {
        orthoPhoto.isVisible = !newVisibility;
        this.mapLayersControler.toggleOrthophotoVisibility(orthoPhoto.id, !newVisibility);
        this.fonctionsService.launch_toast(false);
      }
    });
  }

  /**
   * Shows or hides a DXF layer on the map and persists the choice for the site.
   * Reverts the map and the checkbox if the API call fails.
   */
  protected toggleDxfLayer(polygone: SitePolygoneDto): void {
    const newVisibility = !polygone.isVisible;

    this.sitePolygonLayer.setPolygoneVisibility(polygone.id, newVisibility);

    this.dxfService.setSitePolygoneVisibility(this.site.siteId, polygone.id, newVisibility)
      .catch(() => {
        this.sitePolygonLayer.setPolygoneVisibility(polygone.id, !newVisibility);
        this.fonctionsService.launch_toast(false);
        this.cdr.detectChanges();
      });
  }

  selectOrthoLayer(orthoPhoto: OrthoPhotoDto): void {
    if (this.selectedOrthoLayer === orthoPhoto) {
      this.selectedOrthoLayer = null;
    } else {
      this.selectedOrthoLayer = orthoPhoto;
    }
  }

  isOrthoLayerSelected(orthoPhoto: OrthoPhotoDto): boolean {
    return this.selectedOrthoLayer === orthoPhoto;
  }
  
  deleteOrthoLayer(orthoPhoto: OrthoPhotoDto): void {
    this.orthoToDelete = orthoPhoto;
    this.modalConfirmDeleteOrtho.show();
  }
  
  confirmDeleteOrthoLayer(): void {
    if (!this.orthoToDelete) return;
    
    this.fonctionsService.loading_screen(true);
    
    const file = {
      siteId: this.utilService.currentSite().siteId,
      guidProcess: this.orthoToDelete.tileSetId || '', 
      name: this.orthoToDelete.mapName,
      fileType: 'ORT' 
    };
    
    const url = "GeoData/DeleteLayer";
    this.http.put(url, file).subscribe({
      next: (result: any) => {
        this.fonctionsService.loading_screen(false);
        if (result.statusCode > 299) {
          this.fonctionsService.launch_toast(false, false, result.message);
        } else {
          const updatedLayers = this.orthoLayers.filter(layer => layer.id !== this.orthoToDelete.id);
          this.mapLayersControler.updateOrthophotoOrder(updatedLayers);
          
          this.fonctionsService.launch_toast(true);
          console.log(`Ortho layer ${this.orthoToDelete.mapName} deleted from database`);
        }
        this.modalConfirmDeleteOrtho.hide();
        this.orthoToDelete = null;
      },
      error: () => {
        this.fonctionsService.loading_screen(false);
        this.fonctionsService.launch_toast(false);
        this.modalConfirmDeleteOrtho.hide();
        this.orthoToDelete = null;
      }
    });
  }
  
  cancelDeleteOrthoLayer(): void {
    this.modalConfirmDeleteOrtho.hide();
    this.orthoToDelete = null;
  }
  
  openAddOrthophotosModal(): void {
    const initialState = {
      window: 1, 
      multi: false,
      types: ['.tif', '.tiff', '.geotiff']
    };
    
    const modalRef = this.modalService.show(SiteOrthophotosAddFilesModalComponent, { 
      initialState,
      class: 'custome-orto-modal modal-lg',
      backdrop: 'static',
      keyboard: false
    });
    
    modalRef.onHide?.subscribe((result: string) => {
      if (result !== 'cancel') {
        this.refreshOrthophotos();
      }
    });
  }
  
  /** Opens the DXF upload modal, then reloads the site DXF layers on close */
  protected openAddDxfModal(): void {
    const modalRef = this.modalService.show(SiteDxfAddFileModalComponent, {
      initialState: { siteId: this.site.siteId },
      class: 'modal-md',
      backdrop: 'static',
      keyboard: false
    });

    modalRef.onHide?.subscribe(() => this.refreshDxfLayers());
  }

  /** Reloads the DXF layers of the current site and refreshes the panel list */
  private refreshDxfLayers(): void {
    this.sitePolygonLayer.changeSite(this.site.siteId, Number(this.site.epsg))
      .then(polygones => {
        this.dxfLayers = polygones;
        this.cdr.detectChanges();
      })
      .catch(() => { this.dxfLayers = []; });
  }

  private refreshOrthophotos(): void {
    if (this.mapLayersControler && this.utilService.currentSite()) {
      this.mapLayersControler.ChangeSite(this.utilService.currentSite());
    }
  }
  
  moveUp(zOrder: number) {
    const layers = [...this.orthoLayers];
    
    const currentIndex = layers.findIndex(layer => layer.zOrder === zOrder);
    if (currentIndex <= 0) return;
    moveItemInArray(layers, currentIndex, currentIndex - 1);
    
    layers.forEach((layer, idx) => {
      layer.zOrder = idx + 1;
    });
    
    this.mapLayersControler.updateOrthophotoOrder(layers);
    this.updateOrderInDatabase(layers);
    console.log('Move Up →', layers.map(l => `${l.mapName} (zOrder: ${l.zOrder})`));
  }

  moveDown(zOrder: number) {
    const layers = [...this.orthoLayers];
    
    const currentIndex = layers.findIndex(layer => layer.zOrder === zOrder);
    if (currentIndex >= layers.length - 1 || currentIndex === -1) return; 
    moveItemInArray(layers, currentIndex, currentIndex + 1);
    
    layers.forEach((layer, idx) => {
      layer.zOrder = idx + 1;
    });
    
    this.mapLayersControler.updateOrthophotoOrder(layers);
    this.updateOrderInDatabase(layers);
    console.log('Move Down →', layers.map(l => `${l.mapName} (zOrder: ${l.zOrder})`));
  }


  public deleteBlastPolygon(polygonId: number) {
    this.fonctionsService.loading_screen(true);
    this.http.delete('Blasts/BlastOutlines/' + polygonId).subscribe({
      next: () => {
        this.fonctionsService.launch_toast(true);
        this.blastPolygoneLayer.clear();
        this.blastPolygoneLayer.displayPolygonsForBlast(this.listeTirsSelectionnes, this.listeTypesSelectionnes, true).then(() => {
          this.fonctionsService.loading_screen(false);
        });
      },
      error: () => {
        this.fonctionsService.launch_toast(false);
        this.fonctionsService.loading_screen(false);
      }
    });
  }


  private checkEquipmentAssignment(positionData: EquipmentPosition) {
    this.equipmentAssignedShift = null;
    
    if (this.equipmentLayerManager) {
      const shifts = this.equipmentLayerManager.getShifts();
      const positionDate = new Date(positionData.date);
      
      this.equipmentAssignedShift = shifts.find(shift => {
        if (shift.isDeleted || !shift.equipementsIds) return false;
        
        const equipmentIds = shift.equipementsIds.split(';').map(id => parseInt(id.trim(), 10));
        const isEquipmentInShift = equipmentIds.includes(positionData.equipmentExternalId);
        
        if (!isEquipmentInShift) return false;
        
        const shiftDate = new Date(shift.date);
        
        if (shift.time === ShiftEnum.NightToMorning) {

          const positionHour = positionDate.getHours();
          const positionDateOnly = new Date(positionDate.getFullYear(), positionDate.getMonth(), positionDate.getDate());
          const shiftDateOnly = new Date(shiftDate.getFullYear(), shiftDate.getMonth(), shiftDate.getDate());
          const dayBeforeShift = new Date(shiftDateOnly.getTime() - 24 * 60 * 60 * 1000);
          
          if (positionHour >= 0 && positionHour < 6) {
            // Pour 0h-6h locales, le shift appartient à la veille (-1)
            return dayBeforeShift.getTime() === shiftDateOnly.getTime();
          }
          
          return false;
        } else {
          const timeRange = ShiftUtils.calculateShiftTimeRange(shiftDate, shift.time);
          return positionDate >= timeRange.startDate && positionDate <= timeRange.endDate;
        }
      }) || null;
    }
  }

 
  public getShiftDisplayName(shift: Shift): string {
    if (!shift) return '';
    
    const shiftName = ShiftUtils.formatShiftLabel(shift.time);
    const shiftDate = new Date(shift.date);
    const dateStr = this.formatDateToDDMMYYYY(shiftDate);
    
    return `${this.translate.instant(shiftName)} - ${dateStr}`;
  }


  public getBlastName(shift: Shift): string {
    if (!shift || !shift.tirId) return '';
    
    const tir = this.listeTirs()?.find(t => t.tirId === shift.tirId);
    return tir ? tir.nom || `Blast ${shift.tirId}` : `Blast ${shift.tirId}`;
  }

  public openAssignEquipmentModal() {
    if (!this.currentEquipmentPosition) return;
    
    this.assignmentMode.set(true);
    this.pendingEquipmentAssignment = this.currentEquipmentPosition;
    
    this.closePopup();

    this.map.getViewport().style.cursor = 'crosshair';
  }

 
  public assignEquipmentToShift(shift: Shift) {
    this.fonctionsService.loading_screen(true);
    
    this.http.post<Shift, Shift>('Blasts/shifts', shift).subscribe({
      next: (response) => {
        this.fonctionsService.launch_toast(true);
        this.fonctionsService.loading_screen(false);
        
        this.equipmentAssignedShift = { ...shift, shiftId: response.shiftId };
        
        if (this.equipmentLayerManager && this.currentEquipmentPosition) {
          const equipmentIds = [this.currentEquipmentPosition.equipmentExternalId];
          const updatedShift = { ...shift, shiftId: response.shiftId };
          
          const siteId = this.utilService.currentSite()?.siteId;
          this.equipmentLayerManager.forceLoadShifts(() => {
            this.equipmentLayerManager.applyAssignmentStyleImmediately(equipmentIds, true, this.showAssignedEquipments);
            
            setTimeout(() => {
              if (this.currentEquipmentPosition) {
                this.checkEquipmentAssignment(this.currentEquipmentPosition);
              }
            }, 100);
          }, siteId);
        }
      },
      error: (error) => {
        console.error('Error assigning equipment to shift:', error);
        this.fonctionsService.launch_toast(false);
        this.fonctionsService.loading_screen(false);
      }
    });
  }

  public unassignEquipment() {
    if (!this.equipmentAssignedShift || !this.currentEquipmentPosition) return;
    
    this.fonctionsService.loading_screen(true);
    
    const shiftId = this.equipmentAssignedShift.shiftId;
    const siteId = this.utilService.currentSite()?.siteId;
    
    if (!shiftId || !siteId) {
      this.fonctionsService.loading_screen(false);
      return;
    }
    
    const shiftToRemove = { ...this.equipmentAssignedShift };
    
    this.http.delete(`Blasts/${siteId}/shifts/${shiftId}`).subscribe({
      next: () => {
        this.fonctionsService.launch_toast(true);
        this.fonctionsService.loading_screen(false);
        
        if (this.equipmentLayerManager && this.currentEquipmentPosition) {
          const equipmentIds = [this.currentEquipmentPosition.equipmentExternalId];
          
          const siteId = this.utilService.currentSite()?.siteId;
          this.equipmentLayerManager.forceLoadShifts(() => {
            this.equipmentLayerManager.applyAssignmentStyleImmediately(equipmentIds, false, this.showAssignedEquipments);
            
            setTimeout(() => {
              if (this.currentEquipmentPosition) {
                this.checkEquipmentAssignment(this.currentEquipmentPosition);
              }
            }, 100);
          }, siteId);
        }

        this.equipmentAssignedShift = null;
      },
      error: (error) => {
        console.error('Error unassigning equipment from shift:', error);
        this.fonctionsService.launch_toast(false);
        this.fonctionsService.loading_screen(false);
      }
    });
  }


  public cancelAssignmentMode() {
    this.assignmentMode.set(false);
    this.pendingEquipmentAssignment = null;
    this.routeToAssignByClick.set(null); // Nettoyer la route sélectionnée
    this.map.getViewport().style.cursor = '';
  }

  /**
   * Active le mode assignation de route à un blast
   */
  public startRouteAssignmentMode(route: any): void {
    this.routeAssignmentMode = true;
    this.equipmentLayerManager.getRouteLayer().setAssignMode(true, route);
  }

  /**
   * Annule le mode assignation de route
   */
  public cancelRouteAssignmentMode(): void {
    this.routeAssignmentMode = false;
    this.equipmentLayerManager.getRouteLayer().setAssignMode(false);
    this.map.getViewport().style.cursor = '';
  }

  /**
   * Assigne la route sélectionnée à un blast
   */
  private assignRouteToBlast(tirId: number): void {
    const routeLayer = this.equipmentLayerManager.getRouteLayer();
    const route = routeLayer.getRouteToAssign();

    if (!route) {
      this.cancelRouteAssignmentMode();
      return;
    }

    // Si la route a un ID, faire un update, sinon créer
    if (route.id) {
      // Update de la route existante avec le tirId
      const routeDto: EquipmentRouteDto = {
        id: route.id,
        siteId: this.site.siteId,
        equipmentId: route.equipmentId,
        start: route.startTime,
        end: route.endTime,
        tirId: tirId
      };

      this.equipmentRouteService.updateRoute(route.id, routeDto).subscribe({
        next: (savedRoute) => {
          console.log('Route mise à jour avec le tirId:', savedRoute);
          // Mettre à jour le tirId dans la route locale
          route.tirId = tirId;
          this.routesVersion.update(v => v + 1);
          this.fonctionsService.launch_toast(true);
        },
        error: (error) => {
          console.error('Erreur lors de la mise à jour de la route:', error);
          this.fonctionsService.launch_toast(false);
        }
      });
    } else {
      // La route n'existe pas encore en base, la créer avec le tirId
      const routeDto: EquipmentRouteDto = {
        siteId: this.site.siteId,
        equipmentId: route.equipmentId,
        start: route.startTime,
        end: route.endTime,
        tirId: tirId
      };

      this.equipmentRouteService.createRoute(routeDto).subscribe({
        next: (savedRoute) => {
          console.log('Route créée et assignée au blast:', savedRoute);
          // Mettre à jour l'ID et le tirId dans la route locale
          route.id = savedRoute.id;
          route.tirId = tirId;
          this.routesVersion.update(v => v + 1);
          this.fonctionsService.launch_toast(true);
        },
        error: (error) => {
          console.error('Erreur lors de la création de la route:', error);
          this.fonctionsService.launch_toast(false);
        }
      });
    }

    this.cancelRouteAssignmentMode();
  }

  private assignEquipmentToBlast(tirId: number) {
    if (!this.pendingEquipmentAssignment) {
      this.cancelAssignmentMode();
      return;
    }

    const positionDate = new Date(this.pendingEquipmentAssignment.date);
    
    let shiftTime: ShiftEnum;
    let shiftDate = new Date(positionDate);
    // Utiliser l'heure locale au lieu de UTC pour correspondre à l'affichage utilisateur
    const hour = positionDate.getHours();
    
    if (hour >= 22 || hour < 6) {
      shiftTime = ShiftEnum.NightToMorning;
      if (hour >= 0 && hour < 6) {
        // Pour les positions entre 0h et 6h locales, -1 jour (le shift appartient à la veille)
        shiftDate.setDate(positionDate.getDate() - 1);
        shiftDate.setHours(0, 0, 0, 0);
      } else {
        // Pour 22h-23h locales, même date (début du shift de nuit)
        shiftDate.setHours(0, 0, 0, 0);
      }

    } else if (hour >= 6 && hour < 14) {
      shiftTime = ShiftEnum.MorningToAfternoon;
      shiftDate.setHours(0, 0, 0, 0);
    } else {
      shiftTime = ShiftEnum.AfternoonToEvening;
      shiftDate.setHours(0, 0, 0, 0);
    }

    const equipmentId = this.pendingEquipmentAssignment.equipmentExternalId;

    const conflictingShift = this.findConflictingShift(equipmentId, positionDate, shiftTime);
    
    const existingShift = this.findExistingShift(tirId, shiftDate, shiftTime);
    const deletedShift = this.findDeletedShift(tirId, shiftDate, shiftTime);
    
    if (existingShift) {
      this.addEquipmentToExistingShift(existingShift, equipmentId);
    } else if (deletedShift) {
      // Créer une date UTC qui représente la date locale pour éviter les problèmes de timezone
      const utcShiftDate = new Date(Date.UTC(
        shiftDate.getFullYear(),
        shiftDate.getMonth(),
        shiftDate.getDate(),
        0, 0, 0, 0
      ));
      
      // Réactiver un shift supprimé avec le nouvel équipement
      const reactivatedShift: Shift = {
        ...deletedShift,
        date: utcShiftDate,
        equipementsIds: this.pendingEquipmentAssignment.equipmentExternalId.toString(),
        isDeleted: false
      };
      
      this.reactivateDeletedShift(reactivatedShift);
    } else {
      // Créer une date UTC qui représente la date locale pour éviter les problèmes de timezone
      const utcShiftDate = new Date(Date.UTC(
        shiftDate.getFullYear(),
        shiftDate.getMonth(),
        shiftDate.getDate(),
        0, 0, 0, 0
      ));
      
      const newShift: Shift = {
        date: utcShiftDate,
        time: shiftTime,
        tirId: tirId,
        siteId: this.utilService.currentSite()?.siteId || 0,
        equipementsIds: this.pendingEquipmentAssignment.equipmentExternalId.toString(),
        equipeId: 0,
        operatorId: 0,
        isDeleted: false
      };
      
      this.assignEquipmentToShift(newShift);
    }
    
    this.cancelAssignmentMode();
  }


  private findConflictingShift(equipmentId: number, date: Date, shiftTime: ShiftEnum): Shift | null {
    if (!this.equipmentLayerManager) {
      return null;
    }

    const shifts = this.equipmentLayerManager.getShifts();
    const targetDate = new Date(date);
    targetDate.setHours(0, 0, 0, 0);

    return shifts.find(shift => {
      if (shift.isDeleted || shift.time !== shiftTime) {
        return false;
      }

      const shiftDate = new Date(shift.date);
      shiftDate.setHours(0, 0, 0, 0);
      
      if (shiftDate.getTime() !== targetDate.getTime()) {
        return false;
      }

      const equipmentIds = shift.equipementsIds 
        ? shift.equipementsIds.split(';').map(id => parseInt(id.trim(), 10))
        : [];
      
      return equipmentIds.includes(equipmentId);
    }) || null;
  }

  private findExistingShift(tirId: number, date: Date, shiftTime: ShiftEnum): Shift | null {
    if (!this.equipmentLayerManager) {
      return null;
    }

    const shifts = this.equipmentLayerManager.getShifts();
    const targetDate = new Date(date);
    targetDate.setHours(0, 0, 0, 0); 

    return shifts.find(shift => {
      if (shift.isDeleted || shift.tirId !== tirId || shift.time !== shiftTime) {
        return false;
      }

      const shiftDate = new Date(shift.date);
      shiftDate.setHours(0, 0, 0, 0);
      
      return shiftDate.getTime() === targetDate.getTime();
    }) || null;
  }

  private findDeletedShift(tirId: number, date: Date, shiftTime: ShiftEnum): Shift | null {
    if (!this.equipmentLayerManager) {
      return null;
    }

    const shifts = this.equipmentLayerManager.getShifts();
    const targetDate = new Date(date);
    targetDate.setHours(0, 0, 0, 0); 

    return shifts.find(shift => {
      if (!shift.isDeleted || shift.tirId !== tirId || shift.time !== shiftTime) {
        return false;
      }

      const shiftDate = new Date(shift.date);
      shiftDate.setHours(0, 0, 0, 0);
      
      return shiftDate.getTime() === targetDate.getTime();
    }) || null;
  }

  private reactivateDeletedShift(shift: Shift) {
    this.fonctionsService.loading_screen(true);
    
    this.http.put<Shift, Shift>('Blasts/shifts', shift).subscribe({
      next: (response) => {
        this.fonctionsService.launch_toast(true);
        this.fonctionsService.loading_screen(false);
        
        this.equipmentAssignedShift = response;
        
        if (this.equipmentLayerManager && this.currentEquipmentPosition) {
          const equipmentIds = [this.currentEquipmentPosition.equipmentExternalId];
          
          const siteId = this.utilService.currentSite()?.siteId;
          // D'abord recharger les shifts depuis le serveur
          this.equipmentLayerManager.fetchShifts(siteId, () => {
            // Puis appliquer le style une fois les shifts rechargés
            this.equipmentLayerManager.applyAssignmentStyleImmediately(equipmentIds, true, this.showAssignedEquipments);
          });
        }
      },
      error: (error) => {
        console.error('Erreur lors de la réactivation du shift:', error);
        this.fonctionsService.launch_toast(false);
        this.fonctionsService.loading_screen(false);
      }
    });
  }


  private addEquipmentToExistingShift(existingShift: Shift, equipmentExternalId: number) {
    if (!existingShift.shiftId) {
      console.error('Cannot add equipment to shift: shift has no ID');
      return;
    }

    const currentEquipmentIds = existingShift.equipementsIds 
      ? existingShift.equipementsIds.split(';').map(id => parseInt(id.trim(), 10))
      : [];

    if (currentEquipmentIds.includes(equipmentExternalId)) {
      this.fonctionsService.launch_toast(true); // Toast de succès car l'équipement est déjà assigné
      return;
    }

    const updatedEquipmentIds = [...currentEquipmentIds, equipmentExternalId].join(';');
    
    const updatedShift: Shift = {
      ...existingShift,
      equipementsIds: updatedEquipmentIds
    };


    this.fonctionsService.loading_screen(true);
    
    this.http.put<Shift, Shift>('Blasts/shifts', updatedShift).subscribe({
      next: (response) => {
        this.fonctionsService.launch_toast(true);
        this.fonctionsService.loading_screen(false);
        
        this.equipmentAssignedShift = updatedShift;
        
        if (this.equipmentLayerManager && this.currentEquipmentPosition) {
          const equipmentIds = [this.currentEquipmentPosition.equipmentExternalId];
          
          const siteId = this.utilService.currentSite()?.siteId;
          this.equipmentLayerManager.forceLoadShifts(() => {
            this.equipmentLayerManager.applyAssignmentStyleImmediately(equipmentIds, true, this.showAssignedEquipments);
            
            setTimeout(() => {
              if (this.currentEquipmentPosition) {
                this.checkEquipmentAssignment(this.currentEquipmentPosition);
              }
            }, 100);
          }, siteId);
        }
      },
      error: (error) => {
        this.fonctionsService.launch_toast(false);
        this.fonctionsService.loading_screen(false);
      }
    });
  }

  private initializeEquipmentLayer(): void {
    this.showEquipmentButton = true;
    this.equipmentLayerManager = 
        !this.equipmentLayerManager ? 
        new BlastEquipmentLayer(this.map, this.http, this.translate, this.logger, this.getDynamicZIndex(60))
        : this.equipmentLayerManager;

    this.equipmentLayerManager.dataLoaded.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.equipments = this.equipmentLayerManager.getEquipments();
      this.routesVersion.update(v => v + 1);
    });
    this.equipmentLayerManager.dataLoading.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(isLoading => {
      this.loadingEquipments = isLoading;
    });

    // S'abonner à l'événement de split terminé
    this.equipmentLayerManager.getRouteLayer().splitCompleted.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.splitRouteMode.set(false); // Désactiver le bouton split
      // Rafraîchir les styles des positions pour qu'elles prennent les nouvelles couleurs des routes
      this.equipmentLayerManager.forceStyleRefresh();
      this.routesVersion.update(v => v + 1);
    });

    // S'abonner à l'événement de merge terminé
    this.equipmentLayerManager.getRouteLayer().mergeCompleted.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.mergeRouteMode = false; // Désactiver le bouton merge
      this.routeSelectedForMerge.set(null); // Réinitialiser la sélection de fusion
      // Rafraîchir les styles des positions pour qu'elles prennent les nouvelles couleurs des routes
      this.equipmentLayerManager.forceStyleRefresh();
      this.routesVersion.update(v => v + 1);
    });

    // S'abonner à l'événement de sauvegarde des routes
    this.equipmentLayerManager.getRouteLayer().routesSaveRequired.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((routes: EquipmentRouteDto[]) => {
      // Ajouter le siteId aux routes avant de sauvegarder
      const routesWithSiteId = routes.map(route => ({
        ...route,
        siteId: this.site.siteId
      }));
      this.equipmentRouteService.saveRoutes(routesWithSiteId).subscribe({
        next: (savedRoutes) => {
          console.log('Routes sauvegardées avec succès:', savedRoutes);
          // Mettre à jour les IDs des routes en mémoire avec les IDs retournés par le serveur
          savedRoutes.forEach(savedRoute => {
            const matchingRoute = this.equipmentLayerManager.getRouteLayer().getRoutes().find(r =>
              r.equipmentId === savedRoute.equipmentId &&
              r.startTime.getTime() === new Date(savedRoute.start).getTime() &&
              r.endTime.getTime() === new Date(savedRoute.end).getTime() &&
              !r.id
            );
            if (matchingRoute) {
              matchingRoute.id = savedRoute.id;
            }
          });
          // Synchroniser les savedRoutes pour que createRoutesFromPositions reste cohérent
          this.equipmentLayerManager.addSavedRoutes(savedRoutes);
        },
        error: (err) => {
          console.error('Erreur lors de la sauvegarde des routes:', err);
        }
      });
    });

    // S'abonner à l'événement de suppression des routes
    this.equipmentLayerManager.getRouteLayer().routesDeleteRequired.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((routeIds: number[]) => {
      // Retirer immédiatement des savedRoutes pour garder la cohérence
      this.equipmentLayerManager.removeSavedRoutes(routeIds);
      routeIds.forEach(routeId => {
        this.equipmentRouteService.deleteRoute(routeId).subscribe({
          next: () => {
            console.log('Route supprimée avec succès:', routeId);
          },
          error: (err) => {
            console.error('Erreur lors de la suppression de la route:', routeId, err);
          }
        });
      });
    });

    // Définir le siteId sur le layer pour les futures sauvegardes
    this.equipmentLayerManager.getRouteLayer().setSiteId(this.site.siteId);

    // Charger les routes sauvegardées avant de charger les positions
    this.equipmentRouteService.getRoutesBySiteId(this.site.siteId).subscribe({
      next: (savedRoutes) => {
        console.log('Routes sauvegardées chargées:', savedRoutes);
        this.equipmentLayerManager.setSavedRoutes(savedRoutes);
        // Maintenant charger les équipements et positions
        this.equipmentLayerManager.fetchEquipments(this.site.siteId);
        this.equipmentLayerManager.loadAndApplySavedPositions();
      },
      error: (err) => {
        console.error('Erreur lors du chargement des routes sauvegardées:', err);
        // Charger quand même les équipements sans routes sauvegardées
        this.equipmentLayerManager.fetchEquipments(this.site.siteId);
        this.equipmentLayerManager.loadAndApplySavedPositions();
      }
    });
  }

  // --- Zone of Interest ---

  protected startZOIDrawing(): void {
    this.showZoiTypeModal = !this.showZoiTypeModal;
  }

  protected selectAndStartZOIType(type: string): void {
    this.showZoiTypeModal = false;
    this.activeButton = 4;
    this.map.getTargetElement().classList.add('map-drawing');

    if (type === 'normal') {
      this.zoiGeometryType = 'polygon';
      this.rulerControlLayer.toggle(MEASURE_MODE.area);

      this.rulerControlLayer.drawPolygonCoordinatesEvent.pipe(take(1)).subscribe({
        next: (coordinates: Coordinate[][]) => {
          const drawnPolygon = new OlPolygon(coordinates);
          const wkt = new WKTFormat();
          this.zoiWkt = wkt.writeGeometry(drawnPolygon);
          this.zoiCenterX = undefined;
          this.zoiCenterY = undefined;
          this.zoiRadius = undefined;
          this.openZoiModal();
        }
      });
    } else if (type === 'circle') {
      this.zoiGeometryType = 'circle';
      this.rulerControlLayer.toggle(MEASURE_MODE.circle);

      this.rulerControlLayer.drawCircleDataEvent.pipe(take(1)).subscribe({
        next: (data: { center: Coordinate; radius: number }) => {
          this.zoiCenterX = data.center[0];
          this.zoiCenterY = data.center[1];
          this.zoiRadius = data.radius;
          this.zoiWkt = undefined;
          this.openZoiModal();
        }
      });
    }
  }

  private openZoiModal(): void {
    this.map.getTargetElement().classList.remove('map-drawing');
    this.activeButton = 1;
    this.zoiName = '';
    this.zoiType = 0;
    this.zoiThreshold = 30;
    this.zoiModalVisible = true;
  }

  protected closeZoiModal(): void {
    this.zoiModalVisible = false;
    this.rulerControlLayer.stop();
  }

  protected saveZoneOfInterest(): void {
    const dto: ZoneOfInterestDto = {
      id: 0,
      name: this.zoiName,
      type: this.zoiType,
      geometryType: this.zoiGeometryType,
      centerX: this.zoiCenterX,
      centerY: this.zoiCenterY,
      radius: this.zoiRadius,
      wktString: this.zoiWkt,
      detectionThresholdSeconds: this.zoiThreshold,
      isActive: true
    };

    this.zoiService.create(this.site.siteId, dto).subscribe({
      next: () => {
        this.fonctionsService.launch_toast(true);
        this.zoiModalVisible = false;
        this.rulerControlLayer.stop();
        this.zoneOfInterestLayer.refresh();
      },
      error: () => {
        this.fonctionsService.launch_toast(false);
      }
    });
  }

}